import { useTranslation } from "react-i18next";
import { useContext } from "react";
import { DtriContext } from "../context/dtri";

export function useMap() {
  const { t } = useTranslation(["common", "eca", "escap", "eclac"]);
  const { region } = useContext(DtriContext);

  if (region === "eca") {
    return {
      title: "Africa",
      version: "2.0.0",
      type: "FeatureCollection",
      copyright:
        "Copyright (c) 2022 Highsoft AS, Based on data from Natural Earth",
      copyrightShort: "Natural Earth",
      copyrightUrl: "http://www.naturalearthdata.com",
      crs: {
        type: "name",
        properties: {
          name: "urn:ogc:def:crs:EPSG:102024",
        },
      },
      "hc-transform": {
        default: {
          crs: "+proj=lcc +lat_1=20 +lat_2=-23 +lat_0=0 +lon_0=25 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
          scale: 8.12423194296e-5,
          jsonres: 15.5,
          jsonmarginX: -999,
          jsonmarginY: 9851.0,
          xoffset: -5257539.5112,
          yoffset: 4185728.66873,
        },
      },
      features: [
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [6582, 4531],
                  [6573, 4540],
                  [6555, 4538],
                  [6568, 4527],
                  [6582, 4531],
                ],
              ],
              [
                [
                  [6690, 4597],
                  [6709, 4588],
                  [6714, 4617],
                  [6697, 4617],
                  [6690, 4597],
                ],
              ],
              [
                [
                  [6512, 4449],
                  [6514, 4449],
                  [6512, 4451],
                  [6512, 4449],
                ],
              ],
              [
                [
                  [6227, 4517],
                  [6216, 4460],
                  [6219, 4399],
                  [6260, 4389],
                  [6335, 4441],
                  [6382, 4449],
                  [6507, 4449],
                  [6496, 4475],
                  [6538, 4539],
                  [6525, 4561],
                  [6613, 4597],
                  [6667, 4593],
                  [6701, 4628],
                  [6740, 4602],
                  [6796, 4610],
                  [6863, 4720],
                  [6901, 4737],
                  [6925, 4794],
                  [6918, 4899],
                  [6873, 4960],
                  [6848, 5017],
                  [6856, 5054],
                  [6820, 5067],
                  [6796, 5126],
                  [6737, 5068],
                  [6670, 5082],
                  [6586, 5063],
                  [6560, 5036],
                  [6508, 5074],
                  [6472, 5054],
                  [6425, 5071],
                  [6385, 5032],
                  [6373, 4973],
                  [6387, 4955],
                  [6367, 4899],
                  [6441, 4861],
                  [6457, 4821],
                  [6398, 4776],
                  [6350, 4712],
                  [6337, 4740],
                  [6265, 4681],
                  [6267, 4644],
                  [6234, 4567],
                  [6261, 4561],
                  [6227, 4517],
                ],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.59,
            "hc-middle-y": 0.45,
            "hc-key": "UGA",
            "hc-a2": "UG",
            name: t("Countries.ug", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Uga.",
            subregion: "Eastern Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "UGA",
            "iso-a2": "UG",
            "woe-id": "23424974",
            continent: "Africa",
          },
          id: "UG",
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [3312, 5152],
                  [3296, 5156],
                  [3285, 5142],
                  [3342, 5150],
                  [3312, 5152],
                ],
              ],
              [
                [
                  [2703, 5394],
                  [2855, 5403],
                  [2925, 5395],
                  [2989, 5349],
                  [3049, 5263],
                  [3083, 5171],
                  [3161, 5125],
                  [3270, 5142],
                  [3308, 5169],
                  [3362, 5157],
                  [3434, 5162],
                  [3428, 5213],
                  [3475, 5198],
                  [3502, 5243],
                  [3509, 5333],
                  [3673, 5484],
                  [3722, 5469],
                  [3736, 5493],
                  [3831, 5412],
                  [3862, 5470],
                  [3904, 5500],
                  [3884, 5521],
                  [3944, 5614],
                  [3948, 5669],
                  [4023, 5728],
                  [4030, 5800],
                  [4074, 5822],
                  [4080, 5893],
                  [4105, 5903],
                  [4122, 5972],
                  [4176, 6052],
                  [4200, 6047],
                  [4256, 6082],
                  [4265, 6171],
                  [4201, 6200],
                  [4185, 6292],
                  [4125, 6376],
                  [4092, 6377],
                  [3988, 6313],
                  [3976, 6289],
                  [3922, 6296],
                  [3840, 6329],
                  [3740, 6330],
                  [3642, 6298],
                  [3605, 6255],
                  [3478, 6267],
                  [3399, 6318],
                  [3357, 6320],
                  [3309, 6291],
                  [3245, 6277],
                  [3174, 6359],
                  [3067, 6391],
                  [3030, 6375],
                  [2929, 6366],
                  [2880, 6336],
                  [2875, 6272],
                  [2818, 6209],
                  [2812, 6097],
                  [2798, 6057],
                  [2830, 6020],
                  [2846, 5952],
                  [2811, 5910],
                  [2804, 5852],
                  [2754, 5796],
                  [2750, 5756],
                  [2708, 5747],
                  [2696, 5593],
                  [2711, 5480],
                  [2703, 5394],
                ],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.5,
            "hc-middle-y": 0.45,
            "hc-key": "NGA",
            "hc-a2": "NG",
            name: t("Countries.ng", { ns: region }),
            labelrank: "2",
            "country-abbrev": "Nigeria",
            subregion: "Western Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "NGA",
            "iso-a2": "NG",
            "woe-id": "23424908",
            continent: "Africa",
          },
          id: "NG",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [3222, 4580],
                [3241, 4607],
                [3225, 4623],
                [3202, 4598],
                [3222, 4580],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.55,
            "hc-middle-y": 0.5,
            "hc-key": "STP",
            "hc-a2": "ST",
            name: t("Countries.st", { ns: region }),
            labelrank: "6",
            "country-abbrev": "S.T.P.",
            subregion: "Middle Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "STP",
            "iso-a2": "ST",
            "woe-id": "23424966",
            continent: "Africa",
          },
          id: "ST",
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [7539, 3535],
                  [7559, 3567],
                  [7535, 3559],
                  [7523, 3543],
                  [7539, 3535],
                ],
              ],
              [
                [
                  [7473, 3814],
                  [7467, 3775],
                  [7510, 3735],
                  [7485, 3832],
                  [7473, 3814],
                ],
              ],
              [
                [
                  [7529, 3867],
                  [7556, 3892],
                  [7551, 3929],
                  [7534, 3939],
                  [7529, 3867],
                ],
              ],
              [
                [
                  [6657, 4327],
                  [6645, 4314],
                  [6687, 4297],
                  [6679, 4323],
                  [6657, 4327],
                ],
              ],
              [
                [
                  [6915, 3070],
                  [6995, 3066],
                  [7027, 3091],
                  [7075, 3052],
                  [7123, 3048],
                  [7156, 3069],
                  [7235, 3049],
                  [7281, 3070],
                  [7293, 3102],
                  [7343, 3107],
                  [7373, 3089],
                  [7426, 3121],
                  [7477, 3122],
                  [7571, 3167],
                  [7627, 3210],
                  [7628, 3227],
                  [7533, 3280],
                  [7545, 3293],
                  [7525, 3379],
                  [7488, 3442],
                  [7478, 3495],
                  [7501, 3534],
                  [7478, 3588],
                  [7514, 3650],
                  [7504, 3684],
                  [7424, 3751],
                  [7415, 3792],
                  [7463, 3912],
                  [7470, 3967],
                  [7263, 4120],
                  [7270, 4180],
                  [6805, 4441],
                  [6750, 4386],
                  [6740, 4320],
                  [6774, 4290],
                  [6693, 4252],
                  [6583, 4263],
                  [6564, 4287],
                  [6512, 4229],
                  [6524, 4265],
                  [6484, 4314],
                  [6518, 4430],
                  [6514, 4449],
                  [6512, 4449],
                  [6506, 4442],
                  [6507, 4449],
                  [6382, 4449],
                  [6335, 4441],
                  [6382, 4372],
                  [6382, 4275],
                  [6346, 4268],
                  [6328, 4210],
                  [6381, 4193],
                  [6377, 4155],
                  [6334, 4124],
                  [6273, 4025],
                  [6228, 4002],
                  [6220, 3944],
                  [6250, 3915],
                  [6239, 3875],
                  [6265, 3812],
                  [6235, 3769],
                  [6288, 3742],
                  [6346, 3676],
                  [6348, 3605],
                  [6423, 3463],
                  [6472, 3448],
                  [6529, 3400],
                  [6581, 3392],
                  [6651, 3355],
                  [6714, 3329],
                  [6780, 3314],
                  [6784, 3336],
                  [6801, 3341],
                  [6802, 3341],
                  [6803, 3340],
                  [6812, 3331],
                  [6816, 3329],
                  [6828, 3315],
                  [6854, 3284],
                  [6884, 3115],
                  [6885, 3112],
                  [6886, 3110],
                  [6894, 3102],
                  [6906, 3094],
                  [6907, 3093],
                  [6909, 3091],
                  [6915, 3080],
                  [6915, 3070],
                ],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.47,
            "hc-middle-y": 0.49,
            "hc-key": "TZA",
            "hc-a2": "TZ",
            name: t("Countries.tz", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Tanz.",
            subregion: "Eastern Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "TZA",
            "iso-a2": "TZ",
            "woe-id": "23424973",
            continent: "Africa",
          },
          id: "TZ",
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [697, 5528],
                  [650, 5522],
                  [696, 5511],
                  [707, 5501],
                  [697, 5528],
                ],
              ],
              [
                [
                  [998, 5648],
                  [940, 5626],
                  [972, 5673],
                  [945, 5756],
                  [865, 5845],
                  [781, 5844],
                  [703, 5825],
                  [679, 5766],
                  [637, 5723],
                  [601, 5715],
                  [622, 5601],
                  [646, 5612],
                  [649, 5567],
                  [722, 5520],
                  [709, 5499],
                  [797, 5469],
                  [845, 5440],
                  [858, 5469],
                  [956, 5553],
                  [955, 5585],
                  [988, 5604],
                  [998, 5648],
                ],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.33,
            "hc-middle-y": 0.62,
            "hc-key": "SLE",
            "hc-a2": "SL",
            name: t("Countries.sl", { ns: region }),
            labelrank: "4",
            "country-abbrev": "S.L.",
            subregion: "Western Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "SLE",
            "iso-a2": "SL",
            "woe-id": "23424946",
            continent: "Africa",
          },
          id: "SL",
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [219, 5996],
                  [214, 5974],
                  [258, 5977],
                  [252, 5992],
                  [219, 5996],
                ],
              ],
              [
                [
                  [371, 5965],
                  [414, 6038],
                  [467, 6060],
                  [539, 6067],
                  [539, 6106],
                  [506, 6126],
                  [540, 6142],
                  [536, 6196],
                  [344, 6193],
                  [281, 6160],
                  [208, 6160],
                  [143, 6143],
                  [246, 6065],
                  [324, 6097],
                  [286, 6035],
                  [342, 6070],
                  [363, 6049],
                  [310, 6034],
                  [319, 5994],
                  [371, 5965],
                ],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.55,
            "hc-middle-y": 0.5,
            "hc-key": "GNB",
            "hc-a2": "GW",
            name: t("Countries.gw", { ns: region }),
            labelrank: "6",
            "country-abbrev": "GnB.",
            subregion: "Western Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "GNB",
            "iso-a2": "GW",
            "woe-id": "23424929",
            continent: "Africa",
          },
          id: "GW",
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-863, 6457],
                  [-858, 6471],
                  [-872, 6485],
                  [-888, 6469],
                  [-863, 6457],
                ],
              ],
              [
                [
                  [-786, 6525],
                  [-789, 6487],
                  [-752, 6471],
                  [-746, 6484],
                  [-786, 6525],
                ],
              ],
              [
                [
                  [-712, 6527],
                  [-722, 6507],
                  [-712, 6499],
                  [-703, 6507],
                  [-712, 6527],
                ],
              ],
              [
                [
                  [-672, 6648],
                  [-684, 6622],
                  [-665, 6618],
                  [-650, 6643],
                  [-672, 6648],
                ],
              ],
              [
                [
                  [-863, 6703],
                  [-880, 6705],
                  [-867, 6681],
                  [-855, 6698],
                  [-863, 6703],
                ],
              ],
              [
                [
                  [-970, 6776],
                  [-999, 6763],
                  [-996, 6738],
                  [-954, 6764],
                  [-970, 6776],
                ],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.64,
            "hc-middle-y": 0.89,
            "hc-key": "CPV",
            "hc-a2": "CV",
            name: t("Countries.cv", { ns: region }),
            labelrank: "4",
            "country-abbrev": "C.Vd.",
            subregion: "Western Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "CPV",
            "iso-a2": "CV",
            "woe-id": "23424794",
            continent: "Africa",
          },
          id: "CV",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [9589, 3952],
                [9587, 3945],
                [9594, 3930],
                [9598, 3945],
                [9589, 3952],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.63,
            "hc-middle-y": 0.45,
            "hc-key": "SYC",
            "hc-a2": "SC",
            name: t("Countries.sc", { ns: region }),
            labelrank: "6",
            "country-abbrev": "Syc.",
            subregion: "Eastern Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "SYC",
            "iso-a2": "SC",
            "woe-id": "23424941",
            continent: "Seven seas (open ocean)",
          },
          id: "SC",
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [3754, 9293],
                  [3728, 9291],
                  [3749, 9255],
                  [3771, 9278],
                  [3754, 9293],
                ],
              ],
              [
                [
                  [3831, 9180],
                  [3788, 9185],
                  [3761, 9253],
                  [3726, 9228],
                  [3726, 9263],
                  [3675, 9262],
                  [3637, 9306],
                  [3647, 9361],
                  [3709, 9397],
                  [3783, 9509],
                  [3769, 9570],
                  [3709, 9609],
                  [3697, 9688],
                  [3734, 9707],
                  [3778, 9776],
                  [3767, 9811],
                  [3685, 9752],
                  [3650, 9809],
                  [3663, 9826],
                  [3608, 9851],
                  [3522, 9835],
                  [3441, 9785],
                  [3416, 9736],
                  [3395, 9602],
                  [3406, 9573],
                  [3395, 9411],
                  [3342, 9373],
                  [3296, 9290],
                  [3333, 9181],
                  [3378, 9164],
                  [3409, 9080],
                  [3506, 9004],
                  [3571, 8721],
                  [3617, 8740],
                  [3670, 8827],
                  [3648, 8903],
                  [3748, 9016],
                  [3840, 9068],
                  [3824, 9095],
                  [3831, 9180],
                ],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.5,
            "hc-middle-y": 0.59,
            "hc-key": "TUN",
            "hc-a2": "TN",
            name: t("Countries.tn", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Tun.",
            subregion: "Northern Africa",
            "region-wb": "Middle East & North Africa",
            "iso-a3": "TUN",
            "iso-a2": "TN",
            "woe-id": "23424967",
            continent: "Africa",
          },
          id: "TN",
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [8647, 2835],
                  [8631, 2835],
                  [8632, 2818],
                  [8647, 2813],
                  [8647, 2835],
                ],
              ],
              [
                [
                  [8264, 1155],
                  [8360, 1208],
                  [8414, 1209],
                  [8475, 1244],
                  [8534, 1396],
                  [8573, 1550],
                  [8619, 1681],
                  [8667, 1849],
                  [8736, 2054],
                  [8774, 2141],
                  [8793, 2244],
                  [8785, 2295],
                  [8840, 2393],
                  [8814, 2528],
                  [8848, 2544],
                  [8866, 2485],
                  [8890, 2470],
                  [8924, 2540],
                  [8892, 2635],
                  [8882, 2762],
                  [8857, 2861],
                  [8809, 2917],
                  [8771, 3006],
                  [8721, 2925],
                  [8730, 2892],
                  [8702, 2813],
                  [8660, 2799],
                  [8647, 2765],
                  [8600, 2800],
                  [8588, 2765],
                  [8610, 2725],
                  [8566, 2688],
                  [8571, 2657],
                  [8535, 2593],
                  [8533, 2649],
                  [8480, 2576],
                  [8502, 2546],
                  [8466, 2534],
                  [8469, 2578],
                  [8371, 2511],
                  [8303, 2502],
                  [8292, 2475],
                  [8247, 2483],
                  [8193, 2443],
                  [8141, 2449],
                  [8138, 2380],
                  [8074, 2279],
                  [8087, 2148],
                  [8113, 2096],
                  [8109, 2062],
                  [8141, 1998],
                  [8140, 1945],
                  [8064, 1813],
                  [8052, 1766],
                  [8013, 1754],
                  [7975, 1627],
                  [7992, 1544],
                  [8043, 1456],
                  [8027, 1430],
                  [8035, 1323],
                  [8076, 1239],
                  [8119, 1202],
                  [8179, 1189],
                  [8218, 1154],
                  [8264, 1155],
                ],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.43,
            "hc-middle-y": 0.51,
            "hc-key": "MDG",
            "hc-a2": "MG",
            name: t("Countries.mg", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Mad.",
            subregion: "Eastern Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "MDG",
            "iso-a2": "MG",
            "woe-id": "23424883",
            continent: "Africa",
          },
          id: "MG",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [6805, 4441],
                [7270, 4180],
                [7263, 4120],
                [7470, 3967],
                [7498, 3975],
                [7548, 4066],
                [7573, 4136],
                [7606, 4185],
                [7600, 4215],
                [7658, 4242],
                [7698, 4285],
                [7693, 4311],
                [7745, 4317],
                [7778, 4352],
                [7777, 4368],
                [7707, 4459],
                [7710, 4941],
                [7758, 4987],
                [7830, 5088],
                [7729, 5087],
                [7683, 5129],
                [7563, 5076],
                [7522, 5016],
                [7386, 5045],
                [7335, 5044],
                [7171, 5152],
                [7066, 5154],
                [7050, 5177],
                [7010, 5177],
                [6984, 5231],
                [6849, 5178],
                [6796, 5126],
                [6820, 5067],
                [6856, 5054],
                [6848, 5017],
                [6873, 4960],
                [6918, 4899],
                [6925, 4794],
                [6901, 4737],
                [6863, 4720],
                [6796, 4610],
                [6796, 4572],
                [6829, 4543],
                [6892, 4566],
                [6906, 4537],
                [6818, 4530],
                [6805, 4441],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.47,
            "hc-middle-y": 0.43,
            "hc-key": "KEN",
            "hc-a2": "KE",
            name: t("Countries.ke", { ns: region }),
            labelrank: "2",
            "country-abbrev": "Ken.",
            subregion: "Eastern Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "KEN",
            "iso-a2": "KE",
            "woe-id": "23424863",
            continent: "Africa",
          },
          id: "KE",
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [6154, 4330],
                  [6145, 4301],
                  [6145, 4287],
                  [6155, 4292],
                  [6154, 4330],
                ],
              ],
              [
                [
                  [6441, 4861],
                  [6367, 4899],
                  [6387, 4955],
                  [6373, 4973],
                  [6385, 5032],
                  [6346, 5048],
                  [6344, 5081],
                  [6302, 5092],
                  [6204, 5185],
                  [6167, 5144],
                  [6113, 5171],
                  [6067, 5135],
                  [5984, 5177],
                  [5941, 5239],
                  [5899, 5256],
                  [5866, 5235],
                  [5813, 5238],
                  [5769, 5264],
                  [5730, 5255],
                  [5669, 5270],
                  [5662, 5234],
                  [5594, 5220],
                  [5554, 5243],
                  [5411, 5176],
                  [5347, 5207],
                  [5285, 5117],
                  [5193, 5138],
                  [5126, 5137],
                  [5082, 5158],
                  [5046, 5152],
                  [5012, 5200],
                  [4931, 5247],
                  [4890, 5246],
                  [4848, 5217],
                  [4800, 5148],
                  [4776, 5138],
                  [4791, 5096],
                  [4788, 5030],
                  [4787, 4985],
                  [4716, 4859],
                  [4717, 4780],
                  [4690, 4710],
                  [4701, 4640],
                  [4671, 4553],
                  [4675, 4511],
                  [4617, 4446],
                  [4557, 4414],
                  [4516, 4337],
                  [4478, 4302],
                  [4471, 4204],
                  [4478, 4151],
                  [4434, 4066],
                  [4393, 4054],
                  [4345, 4015],
                  [4297, 3953],
                  [4241, 3943],
                  [4237, 4022],
                  [4151, 3969],
                  [4105, 3954],
                  [4068, 3975],
                  [3987, 3920],
                  [3995, 3833],
                  [3957, 3828],
                  [3988, 3790],
                  [4083, 3816],
                  [4281, 3814],
                  [4491, 3818],
                  [4528, 3809],
                  [4550, 3708],
                  [4652, 3529],
                  [4734, 3540],
                  [4888, 3540],
                  [4887, 3596],
                  [4908, 3608],
                  [4909, 3671],
                  [5009, 3671],
                  [5051, 3682],
                  [5039, 3634],
                  [5203, 3634],
                  [5200, 3539],
                  [5223, 3487],
                  [5213, 3330],
                  [5253, 3289],
                  [5273, 3231],
                  [5253, 3168],
                  [5263, 3116],
                  [5302, 3144],
                  [5364, 3135],
                  [5426, 3153],
                  [5470, 3145],
                  [5487, 3165],
                  [5541, 3133],
                  [5529, 3098],
                  [5658, 3122],
                  [5667, 3064],
                  [5751, 3029],
                  [5842, 3015],
                  [5905, 3074],
                  [5964, 2978],
                  [6055, 2957],
                  [6162, 2827],
                  [6215, 2854],
                  [6244, 2828],
                  [6245, 2995],
                  [6202, 2984],
                  [6206, 2957],
                  [6145, 2967],
                  [6077, 3033],
                  [6057, 3089],
                  [6094, 3211],
                  [6099, 3305],
                  [6079, 3361],
                  [6054, 3341],
                  [6056, 3400],
                  [6128, 3478],
                  [6131, 3479],
                  [6346, 3511],
                  [6306, 3563],
                  [6296, 3623],
                  [6207, 3710],
                  [6166, 3812],
                  [6191, 3852],
                  [6155, 3922],
                  [6169, 3994],
                  [6154, 4056],
                  [6170, 4147],
                  [6174, 4185],
                  [6145, 4227],
                  [6129, 4236],
                  [6127, 4258],
                  [6125, 4302],
                  [6151, 4374],
                  [6172, 4362],
                  [6190, 4384],
                  [6219, 4399],
                  [6216, 4460],
                  [6227, 4517],
                  [6192, 4490],
                  [6184, 4515],
                  [6234, 4567],
                  [6267, 4644],
                  [6265, 4681],
                  [6337, 4740],
                  [6339, 4773],
                  [6441, 4861],
                ],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.67,
            "hc-middle-y": 0.67,
            "hc-key": "COD",
            "hc-a2": "CD",
            name: t("Countries.cd", { ns: region }),
            labelrank: "2",
            "country-abbrev": "D.R.C.",
            subregion: "Middle Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "COD",
            "iso-a2": "CD",
            "woe-id": "23424780",
            continent: "Africa",
          },
          id: "CD",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [1167, 8251],
                [1166, 8061],
                [729, 8054],
                [735, 7692],
                [656, 7659],
                [605, 7622],
                [586, 7583],
                [596, 7547],
                [609, 7383],
                [89.2768207942265, 7373.138537822513],
                [78, 7293],
                [95, 7349],
                [130, 7281],
                [147, 7291],
                [192, 7219],
                [152, 7104],
                [195, 7047],
                [221, 6907],
                [204, 6810],
                [168, 6725],
                [159, 6611],
                [185, 6702],
                [271, 6705],
                [369, 6729],
                [446, 6729],
                [517, 6661],
                [560, 6666],
                [594, 6594],
                [630, 6579],
                [655, 6531],
                [724, 6482],
                [782, 6500],
                [793, 6587],
                [834, 6596],
                [900, 6529],
                [923, 6573],
                [1042, 6568],
                [1105, 6586],
                [1610, 6593],
                [1629, 6704],
                [1593, 6733],
                [1544, 7141],
                [1448, 7919],
                [1682, 7923],
                [1589, 7984],
                [1167, 8251],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.51,
            "hc-middle-y": 0.56,
            "hc-key": "MRT",
            "hc-a2": "MR",
            name: t("Countries.mr", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Mrt.",
            subregion: "Western Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "MRT",
            "iso-a2": "MR",
            "woe-id": "23424896",
            continent: "Africa",
          },
          id: "MR",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [1167, 8251],
                [1589, 7984],
                [1682, 7923],
                [2477, 7378],
                [2480, 7326],
                [2543, 7297],
                [2576, 7257],
                [2614, 7264],
                [2643, 7233],
                [2751, 7198],
                [2757, 7138],
                [2737, 7108],
                [2765, 7085],
                [2886, 7108],
                [3097, 7157],
                [3312, 7353],
                [3901, 7732],
                [3848, 7840],
                [3736, 7880],
                [3692, 7869],
                [3644, 7923],
                [3636, 8002],
                [3560, 8106],
                [3570, 8141],
                [3617, 8164],
                [3626, 8214],
                [3601, 8280],
                [3629, 8365],
                [3607, 8425],
                [3613, 8554],
                [3591, 8627],
                [3540, 8703],
                [3571, 8721],
                [3506, 9004],
                [3409, 9080],
                [3378, 9164],
                [3333, 9181],
                [3296, 9290],
                [3342, 9373],
                [3395, 9411],
                [3406, 9573],
                [3395, 9602],
                [3416, 9736],
                [3441, 9785],
                [3349, 9769],
                [3279, 9808],
                [3216, 9776],
                [3140, 9804],
                [3121, 9776],
                [2994, 9734],
                [2934, 9773],
                [2806, 9775],
                [2758, 9752],
                [2688, 9757],
                [2648, 9723],
                [2437, 9701],
                [2316, 9628],
                [2283, 9584],
                [2253, 9604],
                [2142, 9547],
                [2132, 9518],
                [2067, 9475],
                [2006, 9468],
                [2067, 9412],
                [2053, 9389],
                [2080, 9311],
                [2082, 9173],
                [2116, 9095],
                [2167, 9061],
                [2141, 8992],
                [1973, 8998],
                [1917, 8984],
                [1932, 8945],
                [1822, 8921],
                [1802, 8870],
                [1837, 8814],
                [1826, 8777],
                [1730, 8744],
                [1612, 8648],
                [1578, 8592],
                [1549, 8605],
                [1365, 8587],
                [1302, 8568],
                [1163, 8457],
                [1166, 8307],
                [1167, 8251],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.6,
            "hc-middle-y": 0.5,
            "hc-key": "DZA",
            "hc-a2": "DZ",
            name: t("Countries.dz", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Alg.",
            subregion: "Northern Africa",
            "region-wb": "Middle East & North Africa",
            "iso-a3": "DZA",
            "iso-a2": "DZ",
            "woe-id": "23424740",
            continent: "Africa",
          },
          id: "DZ",
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [7598, 6668],
                  [7585, 6648],
                  [7610, 6631],
                  [7646, 6625],
                  [7598, 6668],
                ],
              ],
              [
                [
                  [8001, 6236],
                  [7956, 6258],
                  [7893, 6354],
                  [7813, 6403],
                  [7745, 6498],
                  [7694, 6506],
                  [7663, 6547],
                  [7631, 6536],
                  [7577, 6616],
                  [7557, 6584],
                  [7523, 6619],
                  [7494, 6699],
                  [7485, 6770],
                  [7455, 6875],
                  [7412, 6959],
                  [7360, 6893],
                  [7268, 6866],
                  [7254, 6826],
                  [7201, 6832],
                  [7184, 6758],
                  [7193, 6720],
                  [7123, 6566],
                  [7136, 6451],
                  [7208, 6454],
                  [7237, 6477],
                  [7273, 6431],
                  [7316, 6533],
                  [7386, 6471],
                  [7472, 6500],
                  [7489, 6473],
                  [7529, 6490],
                  [7607, 6476],
                  [7702, 6426],
                  [7749, 6360],
                  [7817, 6310],
                  [7847, 6260],
                  [7903, 6205],
                  [7943, 6190],
                  [8001, 6236],
                ],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.32,
            "hc-middle-y": 0.39,
            "hc-key": "ERI",
            "hc-a2": "ER",
            name: t("Countries.er", { ns: region }),
            labelrank: "4",
            "country-abbrev": "Erit.",
            subregion: "Eastern Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "ERI",
            "iso-a2": "ER",
            "woe-id": "23424806",
            continent: "Africa",
          },
          id: "ER",
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [3499, 5059],
                  [3461, 4995],
                  [3489, 4987],
                  [3524, 5045],
                  [3499, 5059],
                ],
              ],
              [
                [
                  [3834, 4855],
                  [3660, 4854],
                  [3635, 4877],
                  [3636, 4820],
                  [3577, 4726],
                  [3637, 4703],
                  [3837, 4704],
                  [3834, 4855],
                ],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.42,
            "hc-middle-y": 0.75,
            "hc-key": "GNQ",
            "hc-a2": "GQ",
            name: t("Countries.gq", { ns: region }),
            labelrank: "4",
            "country-abbrev": "Eq. G.",
            subregion: "Middle Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "GNQ",
            "iso-a2": "GQ",
            "woe-id": "23424804",
            continent: "Africa",
          },
          id: "GQ",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [9851, 1899],
                [9828, 1909],
                [9807, 1843],
                [9845, 1846],
                [9851, 1899],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.61,
            "hc-middle-y": 0.58,
            "hc-key": "MUS",
            "hc-a2": "MU",
            name: t("Countries.mu", { ns: region }),
            labelrank: "5",
            "country-abbrev": "Mus.",
            subregion: "Eastern Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "MUS",
            "iso-a2": "MU",
            "woe-id": "23424894",
            continent: "Seven seas (open ocean)",
          },
          id: "MU",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [162, 6311],
                [299, 6313],
                [354, 6346],
                [421, 6326],
                [453, 6299],
                [500, 6317],
                [519, 6284],
                [448, 6270],
                [349, 6315],
                [338, 6293],
                [260, 6277],
                [259, 6255],
                [149, 6254],
                [138, 6241],
                [137, 6176],
                [143, 6143],
                [208, 6160],
                [281, 6160],
                [344, 6193],
                [536, 6196],
                [622, 6192],
                [622, 6176],
                [717, 6150],
                [754, 6164],
                [844, 6165],
                [844, 6236],
                [813, 6293],
                [748, 6338],
                [765, 6366],
                [730, 6430],
                [724, 6482],
                [655, 6531],
                [630, 6579],
                [594, 6594],
                [560, 6666],
                [517, 6661],
                [446, 6729],
                [369, 6729],
                [271, 6705],
                [185, 6702],
                [159, 6611],
                [83, 6490],
                [31, 6466],
                [78, 6453],
                [110, 6414],
                [162, 6311],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.45,
            "hc-middle-y": 0.41,
            "hc-key": "SEN",
            "hc-a2": "SN",
            name: t("Countries.sn", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Sen.",
            subregion: "Western Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "SEN",
            "iso-a2": "SN",
            "woe-id": "23424943",
            continent: "Africa",
          },
          id: "SN",
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [8150, 2994],
                  [8136, 2982],
                  [8114, 2985],
                  [8154, 2955],
                  [8150, 2994],
                ],
              ],
              [
                [
                  [8018, 3016],
                  [8010, 3083],
                  [7995, 3089],
                  [7992, 3031],
                  [8018, 3016],
                ],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.06,
            "hc-middle-y": 0.28,
            "hc-key": "COM",
            "hc-a2": "KM",
            name: t("Countries.km", { ns: region }),
            labelrank: "6",
            "country-abbrev": "Com.",
            subregion: "Eastern Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "COM",
            "iso-a2": "KM",
            "woe-id": "23424786",
            continent: "Africa",
          },
          id: "KM",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [7824, 6048],
                [7820, 6082],
                [7903, 6205],
                [7847, 6260],
                [7817, 6310],
                [7749, 6360],
                [7702, 6426],
                [7607, 6476],
                [7529, 6490],
                [7489, 6473],
                [7472, 6500],
                [7386, 6471],
                [7316, 6533],
                [7273, 6431],
                [7237, 6477],
                [7208, 6454],
                [7136, 6451],
                [7117, 6358],
                [7097, 6330],
                [7079, 6241],
                [7016, 6225],
                [6962, 6135],
                [6940, 6118],
                [6927, 5999],
                [6879, 6000],
                [6839, 5959],
                [6845, 5919],
                [6811, 5812],
                [6816, 5703],
                [6797, 5679],
                [6693, 5674],
                [6676, 5595],
                [6763, 5575],
                [6839, 5485],
                [6896, 5441],
                [6928, 5337],
                [6972, 5272],
                [7036, 5267],
                [7032, 5196],
                [7050, 5177],
                [7066, 5154],
                [7171, 5152],
                [7335, 5044],
                [7386, 5045],
                [7522, 5016],
                [7563, 5076],
                [7683, 5129],
                [7729, 5087],
                [7830, 5088],
                [7863, 5117],
                [7948, 5127],
                [7992, 5174],
                [8103, 5213],
                [8230, 5206],
                [8427, 5411],
                [8632, 5606],
                [8501, 5607],
                [8115, 5741],
                [8036, 5798],
                [7961, 5904],
                [7937, 5961],
                [7973, 6009],
                [7933, 6021],
                [7846, 6002],
                [7824, 6022],
                [7810, 6035],
                [7824, 6048],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.46,
            "hc-middle-y": 0.6,
            "hc-key": "ETH",
            "hc-a2": "ET",
            name: t("Countries.et", { ns: region }),
            labelrank: "2",
            "country-abbrev": "Eth.",
            subregion: "Eastern Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "ETH",
            "iso-a2": "ET",
            "woe-id": "23424808",
            continent: "Africa",
          },
          id: "ET",
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [1942, 5218],
                  [1943, 5220],
                  [1924, 5220],
                  [1942, 5218],
                ],
              ],
              [
                [
                  [1235, 5530],
                  [1260, 5475],
                  [1255, 5425],
                  [1220, 5390],
                  [1313, 5363],
                  [1328, 5324],
                  [1375, 5308],
                  [1384, 5272],
                  [1359, 5205],
                  [1366, 5113],
                  [1447, 5154],
                  [1585, 5205],
                  [1828, 5234],
                  [1917, 5221],
                  [1979, 5226],
                  [1986, 5282],
                  [1961, 5287],
                  [1921, 5417],
                  [1949, 5477],
                  [1974, 5575],
                  [2017, 5627],
                  [2001, 5721],
                  [1981, 5738],
                  [1991, 5795],
                  [1982, 5782],
                  [1923, 5850],
                  [1863, 5854],
                  [1730, 5817],
                  [1692, 5846],
                  [1658, 5901],
                  [1618, 5914],
                  [1581, 5912],
                  [1554, 5882],
                  [1524, 5895],
                  [1523, 5952],
                  [1500, 5930],
                  [1467, 5942],
                  [1464, 5901],
                  [1430, 5880],
                  [1337, 5912],
                  [1295, 5874],
                  [1271, 5845],
                  [1286, 5773],
                  [1313, 5775],
                  [1302, 5692],
                  [1337, 5670],
                  [1265, 5648],
                  [1295, 5605],
                  [1269, 5529],
                  [1235, 5530],
                ],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.5,
            "hc-middle-y": 0.52,
            "hc-key": "CIV",
            "hc-a2": "CI",
            name: t("Countries.ci", { ns: region }),
            labelrank: "3",
            "country-abbrev": "I.C.",
            subregion: "Western Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "CIV",
            "iso-a2": "CI",
            "woe-id": "23424854",
            continent: "Africa",
          },
          id: "CI",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [1942, 5218],
                [2043, 5197],
                [2078, 5173],
                [2145, 5211],
                [2246, 5238],
                [2301, 5275],
                [2392, 5313],
                [2480, 5322],
                [2504, 5356],
                [2449, 5397],
                [2416, 5451],
                [2432, 5516],
                [2421, 5631],
                [2438, 5642],
                [2394, 5699],
                [2414, 5789],
                [2374, 5812],
                [2395, 5905],
                [2331, 5951],
                [2344, 6008],
                [2320, 6017],
                [2250, 5998],
                [1981, 5993],
                [1959, 5958],
                [1991, 5795],
                [1981, 5738],
                [2001, 5721],
                [2017, 5627],
                [1974, 5575],
                [1949, 5477],
                [1921, 5417],
                [1961, 5287],
                [1986, 5282],
                [1979, 5226],
                [1959, 5220],
                [1943, 5220],
                [1942, 5218],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.44,
            "hc-middle-y": 0.38,
            "hc-key": "GHA",
            "hc-a2": "GH",
            name: t("Countries.gh", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Ghana",
            subregion: "Western Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "GHA",
            "iso-a2": "GH",
            "woe-id": "23424824",
            continent: "Africa",
          },
          id: "GH",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [6109, 2414],
                [6122, 2479],
                [6193, 2523],
                [6248, 2536],
                [6321, 2533],
                [6297, 2621],
                [6685, 2748],
                [6659, 2744],
                [6634, 2790],
                [6659, 2858],
                [6654, 2919],
                [6708, 2946],
                [6693, 2996],
                [6690, 3092],
                [6711, 3125],
                [6702, 3170],
                [6748, 3202],
                [6709, 3291],
                [6651, 3355],
                [6581, 3392],
                [6529, 3400],
                [6472, 3448],
                [6423, 3463],
                [6405, 3436],
                [6375, 3467],
                [6333, 3474],
                [6346, 3511],
                [6131, 3479],
                [6128, 3478],
                [6161, 3453],
                [6143, 3412],
                [6079, 3361],
                [6099, 3305],
                [6094, 3211],
                [6057, 3089],
                [6077, 3033],
                [6145, 2967],
                [6206, 2957],
                [6202, 2984],
                [6245, 2995],
                [6244, 2828],
                [6215, 2854],
                [6162, 2827],
                [6055, 2957],
                [5964, 2978],
                [5905, 3074],
                [5842, 3015],
                [5751, 3029],
                [5667, 3064],
                [5658, 3122],
                [5529, 3098],
                [5541, 3133],
                [5487, 3165],
                [5500, 3097],
                [5487, 3067],
                [5496, 2966],
                [5474, 2913],
                [5492, 2885],
                [5230, 2884],
                [5231, 2463],
                [5247, 2412],
                [5331, 2330],
                [5412, 2265],
                [5521, 2287],
                [5616, 2277],
                [5655, 2244],
                [5710, 2242],
                [5748, 2217],
                [5777, 2232],
                [5843, 2207],
                [5883, 2222],
                [5922, 2294],
                [5981, 2372],
                [6011, 2371],
                [6067, 2412],
                [6109, 2414],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.36,
            "hc-middle-y": 0.65,
            "hc-key": "ZMB",
            "hc-a2": "ZM",
            name: t("Countries.zm", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Zambia",
            subregion: "Eastern Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "ZMB",
            "iso-a2": "ZM",
            "woe-id": "23425003",
            continent: "Africa",
          },
          id: "ZM",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [5412, 2265],
                [5156, 2215],
                [5079, 2212],
                [5018, 2235],
                [4979, 2230],
                [4814, 2249],
                [4773, 2298],
                [4224, 2296],
                [4190, 2293],
                [4089, 2354],
                [4010, 2315],
                [3942, 2326],
                [3908, 2312],
                [3902, 2272],
                [3920, 2192],
                [3977, 2117],
                [4090, 1919],
                [4121, 1828],
                [4179, 1741],
                [4194, 1695],
                [4251, 1627],
                [4270, 1547],
                [4263, 1365],
                [4303, 1274],
                [4312, 1138],
                [4328, 1056],
                [4371, 915],
                [4422, 824],
                [4508, 736],
                [4526, 734],
                [4566, 764],
                [4578, 806],
                [4636, 785],
                [4644, 715],
                [4742, 687],
                [4817, 696],
                [4860, 679],
                [4922, 741],
                [4976, 762],
                [4974, 1284],
                [4973, 1668],
                [5103, 1674],
                [5101, 2173],
                [5166, 2176],
                [5360, 2214],
                [5403, 2215],
                [5439, 2152],
                [5516, 2212],
                [5558, 2208],
                [5616, 2245],
                [5655, 2244],
                [5616, 2277],
                [5521, 2287],
                [5412, 2265],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.43,
            "hc-middle-y": 0.4,
            "hc-key": "NAM",
            "hc-a2": "NA",
            name: t("Countries.na", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Nam.",
            subregion: "Southern Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "NAM",
            "iso-a2": "NA",
            "woe-id": "23424987",
            continent: "Africa",
          },
          id: "NA",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [6335, 4441],
                [6260, 4389],
                [6219, 4399],
                [6190, 4384],
                [6172, 4362],
                [6191, 4316],
                [6127, 4259],
                [6129, 4236],
                [6145, 4227],
                [6234, 4215],
                [6261, 4236],
                [6265, 4279],
                [6346, 4268],
                [6382, 4275],
                [6382, 4372],
                [6335, 4441],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.83,
            "hc-middle-y": 0.39,
            "hc-key": "RWA",
            "hc-a2": "RW",
            name: t("Countries.rw", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Rwa.",
            subregion: "Eastern Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "RWA",
            "iso-a2": "RW",
            "woe-id": "23424937",
            continent: "Africa",
          },
          id: "RW",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                // [8763, 6034],
                // [8726, 6046],
                // [8661, 6022],
                // [8556, 6027],
                // [8435, 5964],
                // [8351, 5989],
                // [8240, 5929],
                // [8150, 5936],
                // [8092, 5982],
                // [8015, 6074],
                // [7973, 6009],
                // [7937, 5961],
                // [7961, 5904],
                // [8036, 5798],
                // [8115, 5741],
                // [8501, 5607],
                // [8632, 5606],
                // [8760, 5796],
                // [8763, 6034],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.72,
            "hc-middle-y": 0.52,
            "hc-key": "sx",
            "hc-a2": "SX",
            name: "somaliii",
            labelrank: "5",
            "country-abbrev": "Solnd.",
            subregion: "Eastern Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "-99",
            "iso-a2": "SX",
            "woe-id": "-99",
            continent: "Africa",
          },
          id: "SX",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [8632, 5606],
                [8427, 5411],
                [8230, 5206],
                [8103, 5213],
                [7992, 5174],
                [7948, 5127],
                [7863, 5117],
                [7830, 5088],
                [7758, 4987],
                [7710, 4941],
                [7707, 4459],
                [7777, 4368],
                [7778, 4352],
                [7850, 4459],
                [8033, 4650],
                [8175, 4771],
                [8369, 4883],
                [8448, 4958],
                [8623, 5143],
                [8716, 5275],
                [8768, 5362],
                [8813, 5477],
                [8873, 5570],
                [8876, 5599],
                [8936, 5667],
                [8954, 5716],
                [9009, 5794],
                [9022, 5909],
                [9084, 5928],
                [9055, 5940],
                [9044, 6023],
                [9073, 6109],
                [9008, 6130],
                [8938, 6078],
                [8847, 6062],
                [8763, 6034],
                [8726, 6046],
                [8661, 6022],
                [8556, 6027],
                [8435, 5964],
                [8351, 5989],
                [8240, 5929],
                [8150, 5936],
                [8092, 5982],
                [8015, 6074],
                [7973, 6009],
                [7937, 5961],
                [7961, 5904],
                [8036, 5798],
                [8115, 5741],
                [8501, 5607],
                [8632, 5606],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.29,
            "hc-middle-y": 0.64,
            "hc-key": "SOM",
            "hc-a2": "SO",
            name: t("Countries.so", { ns: region }),
            labelrank: "6",
            "country-abbrev": "Som.",
            subregion: "Eastern Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "SOM",
            "iso-a2": "SO",
            "woe-id": "-90",
            continent: "Africa",
          },
          id: "SO",
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [4218, 6293],
                  [4185, 6292],
                  [4201, 6200],
                  [4265, 6171],
                  [4256, 6082],
                  [4200, 6047],
                  [4176, 6052],
                  [4122, 5972],
                  [4105, 5903],
                  [4080, 5893],
                  [4074, 5822],
                  [4030, 5800],
                  [4023, 5728],
                  [3948, 5669],
                  [3944, 5614],
                  [3884, 5521],
                  [3904, 5500],
                  [3862, 5470],
                  [3831, 5412],
                  [3736, 5493],
                  [3722, 5469],
                  [3673, 5484],
                  [3509, 5333],
                  [3502, 5243],
                  [3475, 5198],
                  [3465, 5160],
                  [3520, 5164],
                  [3525, 5105],
                  [3570, 5083],
                  [3610, 5087],
                  [3614, 5032],
                  [3655, 4973],
                  [3635, 4877],
                  [3660, 4854],
                  [3834, 4855],
                  [3838, 4873],
                  [4085, 4871],
                  [4092, 4856],
                  [4219, 4856],
                  [4258, 4863],
                  [4301, 4837],
                  [4346, 4841],
                  [4467, 4803],
                  [4471, 4868],
                  [4457, 4949],
                  [4336, 5065],
                  [4314, 5149],
                  [4276, 5177],
                  [4258, 5347],
                  [4234, 5360],
                  [4276, 5391],
                  [4341, 5521],
                  [4375, 5557],
                  [4335, 5683],
                  [4225, 5773],
                  [4172, 5835],
                  [4203, 5880],
                  [4275, 5873],
                  [4400, 5883],
                  [4350, 5925],
                  [4318, 5988],
                  [4312, 6040],
                  [4327, 6087],
                  [4315, 6160],
                  [4296, 6168],
                  [4285, 6234],
                  [4243, 6279],
                  [4212, 6267],
                  [4218, 6293],
                ],
              ],
              [
                [
                  [4226, 6293],
                  [4223, 6293],
                  [4227, 6291],
                  [4226, 6293],
                ],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.51,
            "hc-middle-y": 0.76,
            "hc-key": "CMR",
            "hc-a2": "CM",
            name: t("Countries.cm", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Cam.",
            subregion: "Middle Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "CMR",
            "iso-a2": "CM",
            "woe-id": "23424785",
            continent: "Africa",
          },
          id: "CM",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [4092, 4856],
                [4073, 4785],
                [4087, 4734],
                [4158, 4762],
                [4209, 4756],
                [4246, 4695],
                [4169, 4602],
                [4164, 4550],
                [4202, 4537],
                [4251, 4495],
                [4238, 4444],
                [4247, 4376],
                [4198, 4252],
                [4154, 4304],
                [4118, 4260],
                [4053, 4269],
                [4031, 4327],
                [3981, 4329],
                [3986, 4273],
                [3935, 4262],
                [3869, 4270],
                [3886, 4164],
                [3920, 4147],
                [3882, 4098],
                [3860, 4120],
                [3812, 4064],
                [3905, 3976],
                [3930, 3924],
                [3979, 3978],
                [4039, 4005],
                [4068, 3975],
                [4105, 3954],
                [4151, 3969],
                [4237, 4022],
                [4241, 3943],
                [4297, 3953],
                [4345, 4015],
                [4393, 4054],
                [4434, 4066],
                [4478, 4151],
                [4471, 4204],
                [4478, 4302],
                [4516, 4337],
                [4557, 4414],
                [4617, 4446],
                [4675, 4511],
                [4671, 4553],
                [4701, 4640],
                [4690, 4710],
                [4717, 4780],
                [4716, 4859],
                [4787, 4985],
                [4788, 5030],
                [4768, 5050],
                [4686, 5038],
                [4636, 5060],
                [4519, 5028],
                [4508, 4946],
                [4471, 4868],
                [4467, 4803],
                [4346, 4841],
                [4301, 4837],
                [4258, 4863],
                [4219, 4856],
                [4092, 4856],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.64,
            "hc-middle-y": 0.37,
            "hc-key": "COG",
            "hc-a2": "CG",
            name: t("Countries.cg", { ns: region }),
            labelrank: "4",
            "country-abbrev": "Rep. Congo",
            subregion: "Middle Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "COG",
            "iso-a2": "CG",
            "woe-id": "23424779",
            continent: "Africa",
          },
          id: "CG",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                // [78, 7293],
                // [89.2768207942265, 7373.138537822513],
                // [609, 7383],
                // [596, 7547],
                // [586, 7583],
                // [605, 7622],
                // [656, 7659],
                // [735, 7692],
                // [729, 8054],
                // [1166, 8061],
                // [1167, 8251],
                // [1166, 8307],
                // [1148, 8306],
                // [1167, 8251],
                // [598.001671239214, 8334.999688156773],
                // [571.9918933537288, 8300.029789104587],
                // [572.3510754369488, 8299.48411413983],
                // [572.1199822948779, 8299.93396624727],
                // [514.6675820630205, 8152.527988785943],
                // [514.7989078143814, 8152.235492125746],
                // [514.6675820630205, 8152.527988785943],
                [412.4649650301809, 8087.1778309055535],
                [365.3295640260019, 7970.408454594457],
                [350.9038391157199, 7856.527070910059],
                [412.4649650301809, 8087.1778309055535],
                // [241.48828077579128, 7737.295450829355],
                // [174.1040531249414, 7598.884604843825],
                // [144.28976795316134, 7513.283317676764],
                // [119.97469316672249, 7507.012526050083],
                // [95.83836677151432, 7454.89134131804],
                // [87.48701396599543, 7436.980519361708],
                // [87.06083201358638, 7435.981890007623],
                // [89.28040240060889, 7373.254900809162],
                // [89.08811878283055, 7372.701329851148],
                // [72, 7303],
                // [78, 7293],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.8,
            "hc-middle-y": 0.22,
            "hc-key": "ESH",
            "hc-a2": "EH",
            name: t("Countries.eh", { ns: region }),
            labelrank: "7",
            "country-abbrev": "W. Sah.",
            subregion: "Northern Africa",
            "region-wb": "Middle East & North Africa",
            "iso-a3": "ESH",
            "iso-a2": "EH",
            "woe-id": "23424990",
            continent: "Africa",
          },
          id: "EH",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [2703, 5394],
                [2711, 5480],
                [2696, 5593],
                [2708, 5747],
                [2750, 5756],
                [2754, 5796],
                [2804, 5852],
                [2811, 5910],
                [2846, 5952],
                [2830, 6020],
                [2798, 6057],
                [2812, 6097],
                [2713, 6190],
                [2650, 6165],
                [2654, 6123],
                [2605, 6059],
                [2530, 6065],
                [2488, 6008],
                [2460, 6000],
                [2443, 5917],
                [2518, 5869],
                [2531, 5775],
                [2554, 5744],
                [2561, 5474],
                [2553, 5432],
                [2582, 5380],
                [2561, 5372],
                [2596, 5380],
                [2703, 5394],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.48,
            "hc-middle-y": 0.27,
            "hc-key": "BEN",
            "hc-a2": "BJ",
            name: t("Countries.bj", { ns: region }),
            labelrank: "5",
            "country-abbrev": "Benin",
            subregion: "Western Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "BEN",
            "iso-a2": "BJ",
            "woe-id": "23424764",
            continent: "Africa",
          },
          id: "BJ",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [2654, 6123],
                [2611, 6177],
                [2634, 6193],
                [2616, 6230],
                [2541, 6222],
                [2466, 6277],
                [2462, 6346],
                [2419, 6359],
                [2356, 6475],
                [2364, 6524],
                [2304, 6544],
                [2236, 6544],
                [2198, 6509],
                [2113, 6465],
                [2078, 6463],
                [2071, 6424],
                [2013, 6435],
                [1964, 6402],
                [1957, 6349],
                [1908, 6357],
                [1911, 6300],
                [1884, 6283],
                [1816, 6323],
                [1767, 6275],
                [1786, 6235],
                [1750, 6221],
                [1763, 6196],
                [1741, 6145],
                [1647, 6102],
                [1656, 6047],
                [1619, 5998],
                [1618, 5914],
                [1658, 5901],
                [1692, 5846],
                [1730, 5817],
                [1863, 5854],
                [1923, 5850],
                [1982, 5782],
                [1991, 5795],
                [1959, 5958],
                [1981, 5993],
                [2250, 5998],
                [2320, 6017],
                [2405, 6001],
                [2460, 6000],
                [2488, 6008],
                [2530, 6065],
                [2605, 6059],
                [2654, 6123],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.54,
            "hc-middle-y": 0.41,
            "hc-key": "BFA",
            "hc-a2": "BF",
            name: t("Countries.bf", { ns: region }),
            labelrank: "3",
            "country-abbrev": "B.F.",
            subregion: "Western Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "BFA",
            "iso-a2": "BF",
            "woe-id": "23424978",
            continent: "Africa",
          },
          id: "BF",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [2561, 5372],
                [2582, 5380],
                [2553, 5432],
                [2561, 5474],
                [2554, 5744],
                [2531, 5775],
                [2518, 5869],
                [2443, 5917],
                [2460, 6000],
                [2405, 6001],
                [2320, 6017],
                [2344, 6008],
                [2331, 5951],
                [2395, 5905],
                [2374, 5812],
                [2414, 5789],
                [2394, 5699],
                [2438, 5642],
                [2421, 5631],
                [2432, 5516],
                [2416, 5451],
                [2449, 5397],
                [2504, 5356],
                [2536, 5367],
                [2561, 5372],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.75,
            "hc-middle-y": 0.91,
            "hc-key": "TGO",
            "hc-a2": "TG",
            name: t("Countries.tg", { ns: region }),
            labelrank: "6",
            "country-abbrev": "Togo",
            subregion: "Western Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "TGO",
            "iso-a2": "TG",
            "woe-id": "23424965",
            continent: "Africa",
          },
          id: "TG",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [2812, 6097],
                [2818, 6209],
                [2875, 6272],
                [2880, 6336],
                [2929, 6366],
                [3030, 6375],
                [3067, 6391],
                [3174, 6359],
                [3245, 6277],
                [3309, 6291],
                [3357, 6320],
                [3399, 6318],
                [3478, 6267],
                [3605, 6255],
                [3642, 6298],
                [3740, 6330],
                [3840, 6329],
                [3922, 6296],
                [3976, 6289],
                [3988, 6313],
                [4092, 6377],
                [4125, 6376],
                [4104, 6467],
                [4145, 6513],
                [4154, 6554],
                [4224, 6653],
                [4368, 6813],
                [4401, 7225],
                [4429, 7291],
                [4375, 7350],
                [4384, 7371],
                [4327, 7449],
                [4325, 7518],
                [4299, 7660],
                [4201, 7606],
                [4101, 7685],
                [3901, 7732],
                [3312, 7353],
                [3097, 7157],
                [2886, 7108],
                [2889, 6813],
                [2883, 6734],
                [2843, 6638],
                [2796, 6589],
                [2510, 6576],
                [2463, 6536],
                [2364, 6524],
                [2356, 6475],
                [2419, 6359],
                [2462, 6346],
                [2466, 6277],
                [2541, 6222],
                [2616, 6230],
                [2634, 6193],
                [2611, 6177],
                [2654, 6123],
                [2650, 6165],
                [2713, 6190],
                [2812, 6097],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.63,
            "hc-middle-y": 0.47,
            "hc-key": "NER",
            "hc-a2": "NE",
            name: t("Countries.ne", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Niger",
            subregion: "Western Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "NER",
            "iso-a2": "NE",
            "woe-id": "23424906",
            continent: "Africa",
          },
          id: "NE",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [4299, 7660],
                [4432, 7725],
                [5487, 7171],
                [5487, 7240],
                [5619, 7241],
                [5619, 7521],
                [5619, 8569],
                [5580, 8715],
                [5621, 8813],
                [5603, 8905],
                [5642, 8948],
                [5619, 8996],
                [5501, 9002],
                [5369, 9051],
                [5368, 9102],
                [5243, 9149],
                [5172, 9146],
                [5033, 9088],
                [4968, 9028],
                [4948, 8956],
                [4978, 8879],
                [4964, 8818],
                [4926, 8770],
                [4872, 8738],
                [4822, 8735],
                [4717, 8812],
                [4610, 8858],
                [4525, 8879],
                [4435, 8886],
                [4361, 8946],
                [4321, 9059],
                [4225, 9079],
                [4186, 9110],
                [4076, 9138],
                [3994, 9121],
                [3943, 9126],
                [3831, 9180],
                [3824, 9095],
                [3840, 9068],
                [3748, 9016],
                [3648, 8903],
                [3670, 8827],
                [3617, 8740],
                [3571, 8721],
                [3540, 8703],
                [3591, 8627],
                [3613, 8554],
                [3607, 8425],
                [3629, 8365],
                [3601, 8280],
                [3626, 8214],
                [3617, 8164],
                [3570, 8141],
                [3560, 8106],
                [3636, 8002],
                [3644, 7923],
                [3692, 7869],
                [3736, 7880],
                [3848, 7840],
                [3901, 7732],
                [4101, 7685],
                [4201, 7606],
                [4299, 7660],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.51,
            "hc-middle-y": 0.47,
            "hc-key": "LBY",
            "hc-a2": "LY",
            name: t("Countries.ly", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Libya",
            subregion: "Northern Africa",
            "region-wb": "Middle East & North Africa",
            "iso-a3": "LBY",
            "iso-a2": "LY",
            "woe-id": "23424882",
            continent: "Africa",
          },
          id: "LY",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [1235, 5530],
                [1209, 5548],
                [1187, 5492],
                [1152, 5481],
                [1107, 5512],
                [1122, 5537],
                [1101, 5631],
                [1060, 5652],
                [998, 5648],
                [988, 5604],
                [955, 5585],
                [956, 5553],
                [858, 5469],
                [845, 5440],
                [862, 5412],
                [988, 5345],
                [1137, 5213],
                [1271, 5141],
                [1366, 5113],
                [1359, 5205],
                [1384, 5272],
                [1375, 5308],
                [1328, 5324],
                [1313, 5363],
                [1220, 5390],
                [1255, 5425],
                [1260, 5475],
                [1235, 5530],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.37,
            "hc-middle-y": 0.54,
            "hc-key": "LBR",
            "hc-a2": "LR",
            name: t("Countries.lr", { ns: region }),
            labelrank: "4",
            "country-abbrev": "Liberia",
            subregion: "Western Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "LBR",
            "iso-a2": "LR",
            "woe-id": "23424876",
            continent: "Africa",
          },
          id: "LR",
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [6803, 3340],
                  [6802, 3341],
                  [6801, 3341],
                  [6803, 3340],
                ],
              ],
              [
                [
                  [6651, 3355],
                  [6709, 3291],
                  [6748, 3202],
                  [6702, 3170],
                  [6711, 3125],
                  [6690, 3092],
                  [6693, 2996],
                  [6708, 2946],
                  [6654, 2919],
                  [6659, 2858],
                  [6634, 2790],
                  [6659, 2744],
                  [6685, 2748],
                  [6742, 2670],
                  [6752, 2685],
                  [6833, 2698],
                  [6853, 2673],
                  [6862, 2580],
                  [6818, 2498],
                  [6837, 2458],
                  [6917, 2373],
                  [6927, 2332],
                  [6954, 2331],
                  [6953, 2388],
                  [6934, 2410],
                  [6966, 2463],
                  [7020, 2481],
                  [7019, 2590],
                  [7028, 2660],
                  [6929, 2789],
                  [6900, 2814],
                  [6926, 2785],
                  [6950, 2696],
                  [6901, 2749],
                  [6880, 2713],
                  [6857, 2752],
                  [6871, 2789],
                  [6831, 2830],
                  [6833, 2881],
                  [6794, 2990],
                  [6831, 3055],
                  [6818, 3195],
                  [6826, 3219],
                  [6786, 3277],
                  [6780, 3314],
                  [6714, 3329],
                  [6651, 3355],
                ],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.23,
            "hc-middle-y": 0.33,
            "hc-key": "MWI",
            "hc-a2": "MW",
            name: t("Countries.mw", { ns: region }),
            labelrank: "6",
            "country-abbrev": "Mal.",
            subregion: "Eastern Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "MWI",
            "iso-a2": "MW",
            "woe-id": "23424889",
            continent: "Africa",
          },
          id: "MW",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [138, 6241],
                [149, 6254],
                [259, 6255],
                [260, 6277],
                [338, 6293],
                [349, 6315],
                [448, 6270],
                [519, 6284],
                [500, 6317],
                [453, 6299],
                [421, 6326],
                [354, 6346],
                [299, 6313],
                [162, 6311],
                [128, 6277],
                [138, 6241],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.26,
            "hc-middle-y": 0.53,
            "hc-key": "GMB",
            "hc-a2": "GM",
            name: t("Countries.gm", { ns: region }),
            labelrank: "6",
            "country-abbrev": "Gambia",
            subregion: "Western Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "GMB",
            "iso-a2": "GM",
            "woe-id": "23424821",
            continent: "Africa",
          },
          id: "GM",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [4243, 6279],
                [4285, 6234],
                [4296, 6168],
                [4315, 6160],
                [4327, 6087],
                [4312, 6040],
                [4318, 5988],
                [4350, 5925],
                [4400, 5883],
                [4275, 5873],
                [4203, 5880],
                [4172, 5835],
                [4225, 5773],
                [4335, 5683],
                [4375, 5557],
                [4416, 5549],
                [4491, 5577],
                [4514, 5603],
                [4543, 5562],
                [4663, 5619],
                [4782, 5628],
                [4851, 5710],
                [4818, 5735],
                [4848, 5755],
                [5023, 5772],
                [5074, 5809],
                [5099, 5852],
                [5195, 5941],
                [5192, 5970],
                [5288, 6019],
                [5341, 6008],
                [5348, 6071],
                [5298, 6109],
                [5308, 6162],
                [5255, 6251],
                [5219, 6237],
                [5219, 6293],
                [5263, 6330],
                [5237, 6389],
                [5297, 6436],
                [5275, 6493],
                [5315, 6512],
                [5354, 6585],
                [5349, 6631],
                [5371, 6650],
                [5488, 6653],
                [5487, 7171],
                [4432, 7725],
                [4299, 7660],
                [4325, 7518],
                [4327, 7449],
                [4384, 7371],
                [4375, 7350],
                [4429, 7291],
                [4401, 7225],
                [4368, 6813],
                [4224, 6653],
                [4154, 6554],
                [4145, 6513],
                [4104, 6467],
                [4125, 6376],
                [4185, 6292],
                [4218, 6293],
                [4213, 6300],
                [4223, 6293],
                [4226, 6293],
                [4247, 6316],
                [4278, 6292],
                [4243, 6279],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.5,
            "hc-middle-y": 0.5,
            "hc-key": "TCD",
            "hc-a2": "TD",
            name: t("Countries.td", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Chad",
            subregion: "Middle Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "TCD",
            "iso-a2": "TD",
            "woe-id": "23424777",
            continent: "Africa",
          },
          id: "TD",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [3637, 4703],
                [3606, 4698],
                [3616, 4651],
                [3574, 4654],
                [3598, 4610],
                [3640, 4588],
                [3598, 4587],
                [3573, 4614],
                [3568, 4519],
                [3539, 4480],
                [3494, 4496],
                [3538, 4404],
                [3581, 4398],
                [3570, 4329],
                [3653, 4223],
                [3749, 4144],
                [3751, 4126],
                [3812, 4064],
                [3860, 4120],
                [3882, 4098],
                [3920, 4147],
                [3886, 4164],
                [3869, 4270],
                [3935, 4262],
                [3986, 4273],
                [3981, 4329],
                [4031, 4327],
                [4053, 4269],
                [4118, 4260],
                [4154, 4304],
                [4198, 4252],
                [4247, 4376],
                [4238, 4444],
                [4251, 4495],
                [4202, 4537],
                [4164, 4550],
                [4169, 4602],
                [4246, 4695],
                [4209, 4756],
                [4158, 4762],
                [4087, 4734],
                [4073, 4785],
                [4092, 4856],
                [4085, 4871],
                [3838, 4873],
                [3834, 4855],
                [3837, 4704],
                [3637, 4703],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.57,
            "hc-middle-y": 0.47,
            "hc-key": "GAB",
            "hc-a2": "GA",
            name: t("Countries.ga", { ns: region }),
            labelrank: "4",
            "country-abbrev": "Gabon",
            subregion: "Middle Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "GAB",
            "iso-a2": "GA",
            "woe-id": "23424822",
            continent: "Africa",
          },
          id: "GA",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [7973, 6009],
                [8015, 6074],
                [7950, 6084],
                [7952, 6103],
                [8034, 6142],
                [8028, 6207],
                [8001, 6236],
                [7943, 6190],
                [7903, 6205],
                [7820, 6082],
                [7824, 6048],
                [7836, 6033],
                [7824, 6022],
                [7846, 6002],
                [7933, 6021],
                [7973, 6009],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.8,
            "hc-middle-y": 0.21,
            "hc-key": "DJI",
            "hc-a2": "DJ",
            name: t("Countries.dj", { ns: region }),
            labelrank: "5",
            "country-abbrev": "Dji.",
            subregion: "Eastern Africa",
            "region-wb": "Middle East & North Africa",
            "iso-a3": "DJI",
            "iso-a2": "DJ",
            "woe-id": "23424797",
            continent: "Africa",
          },
          id: "DJ",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [6228, 4002],
                [6273, 4025],
                [6334, 4124],
                [6377, 4155],
                [6381, 4193],
                [6328, 4210],
                [6346, 4268],
                [6265, 4279],
                [6261, 4236],
                [6234, 4215],
                [6145, 4227],
                [6174, 4185],
                [6170, 4147],
                [6187, 4092],
                [6228, 4002],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.2,
            "hc-middle-y": 0.59,
            "hc-key": "BDI",
            "hc-a2": "BI",
            name: t("Countries.bi", { ns: region }),
            labelrank: "6",
            "country-abbrev": "Bur.",
            subregion: "Eastern Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "BDI",
            "iso-a2": "BI",
            "woe-id": "23424774",
            continent: "Africa",
          },
          id: "BI",
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [3957, 3828],
                  [3995, 3833],
                  [3987, 3920],
                  [4068, 3975],
                  [4039, 4005],
                  [3979, 3978],
                  [3930, 3924],
                  [3959, 3864],
                  [3957, 3828],
                ],
              ],
              [
                [
                  [4550, 3708],
                  [4528, 3809],
                  [4491, 3818],
                  [4281, 3814],
                  [4083, 3816],
                  [4026, 3791],
                  [3965, 3782],
                  [4011, 3702],
                  [4038, 3680],
                  [4041, 3633],
                  [4109, 3495],
                  [4111, 3439],
                  [4061, 3394],
                  [4088, 3314],
                  [4161, 3191],
                  [4173, 3130],
                  [4167, 3043],
                  [4147, 2980],
                  [4112, 2935],
                  [4057, 2905],
                  [4058, 2883],
                  [4002, 2822],
                  [4001, 2767],
                  [3979, 2735],
                  [3972, 2648],
                  [3936, 2532],
                  [3905, 2507],
                  [3915, 2416],
                  [3908, 2312],
                  [3942, 2326],
                  [4010, 2315],
                  [4089, 2354],
                  [4190, 2293],
                  [4224, 2296],
                  [4773, 2298],
                  [4814, 2249],
                  [4979, 2230],
                  [5018, 2235],
                  [5079, 2212],
                  [5156, 2215],
                  [5412, 2265],
                  [5331, 2330],
                  [5247, 2412],
                  [5231, 2463],
                  [5230, 2884],
                  [5492, 2885],
                  [5474, 2913],
                  [5496, 2966],
                  [5487, 3067],
                  [5500, 3097],
                  [5487, 3165],
                  [5470, 3145],
                  [5426, 3153],
                  [5364, 3135],
                  [5302, 3144],
                  [5263, 3116],
                  [5253, 3168],
                  [5273, 3231],
                  [5253, 3289],
                  [5213, 3330],
                  [5223, 3487],
                  [5200, 3539],
                  [5203, 3634],
                  [5039, 3634],
                  [5051, 3682],
                  [5009, 3671],
                  [4909, 3671],
                  [4908, 3608],
                  [4887, 3596],
                  [4888, 3540],
                  [4734, 3540],
                  [4652, 3529],
                  [4592, 3625],
                  [4550, 3708],
                ],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.5,
            "hc-middle-y": 0.63,
            "hc-key": "AGO",
            "hc-a2": "AO",
            name: t("Countries.ao", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Ang.",
            subregion: "Middle Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "AGO",
            "iso-a2": "AO",
            "woe-id": "23424745",
            continent: "Africa",
          },
          id: "AO",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [601, 5715],
                [637, 5723],
                [679, 5766],
                [703, 5825],
                [781, 5844],
                [865, 5845],
                [945, 5756],
                [972, 5673],
                [940, 5626],
                [998, 5648],
                [1060, 5652],
                [1101, 5631],
                [1122, 5537],
                [1107, 5512],
                [1152, 5481],
                [1187, 5492],
                [1209, 5548],
                [1235, 5530],
                [1269, 5529],
                [1295, 5605],
                [1265, 5648],
                [1337, 5670],
                [1302, 5692],
                [1313, 5775],
                [1286, 5773],
                [1271, 5845],
                [1295, 5874],
                [1254, 5924],
                [1251, 5985],
                [1211, 6002],
                [1242, 6034],
                [1179, 6071],
                [1186, 6105],
                [1159, 6168],
                [1117, 6162],
                [1064, 6118],
                [992, 6143],
                [934, 6098],
                [908, 6139],
                [871, 6114],
                [829, 6137],
                [844, 6165],
                [754, 6164],
                [717, 6150],
                [622, 6176],
                [622, 6192],
                [536, 6196],
                [540, 6142],
                [506, 6126],
                [539, 6106],
                [539, 6067],
                [467, 6060],
                [414, 6038],
                [371, 5965],
                [425, 5930],
                [446, 5868],
                [561, 5811],
                [601, 5715],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.38,
            "hc-middle-y": 0.28,
            "hc-key": "GIN",
            "hc-a2": "GN",
            name: t("Countries.gn", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Gin.",
            subregion: "Western Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "GIN",
            "iso-a2": "GN",
            "woe-id": "23424835",
            continent: "Africa",
          },
          id: "GN",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [5655, 2244],
                [5651, 2226],
                [5743, 2092],
                [5768, 2013],
                [5845, 1953],
                [5908, 1929],
                [5915, 1876],
                [5970, 1875],
                [5967, 1795],
                [6013, 1727],
                [6143, 1697],
                [6147, 1662],
                [6183, 1643],
                [6236, 1650],
                [6306, 1622],
                [6376, 1629],
                [6434, 1613],
                [6579, 1766],
                [6593, 1865],
                [6610, 1866],
                [6657, 1938],
                [6660, 1972],
                [6626, 2016],
                [6639, 2063],
                [6617, 2102],
                [6642, 2108],
                [6661, 2169],
                [6649, 2231],
                [6660, 2301],
                [6635, 2358],
                [6654, 2392],
                [6566, 2423],
                [6517, 2427],
                [6433, 2481],
                [6321, 2485],
                [6321, 2533],
                [6248, 2536],
                [6193, 2523],
                [6122, 2479],
                [6109, 2414],
                [6140, 2403],
                [6103, 2377],
                [6025, 2372],
                [6016, 2340],
                [5970, 2324],
                [5883, 2222],
                [5843, 2207],
                [5777, 2232],
                [5748, 2217],
                [5710, 2242],
                [5655, 2244],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.63,
            "hc-middle-y": 0.52,
            "hc-key": "ZWE",
            "hc-a2": "ZW",
            name: t("Countries.zw", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Zimb.",
            subregion: "Eastern Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "ZWE",
            "iso-a2": "ZW",
            "woe-id": "23425004",
            continent: "Africa",
          },
          id: "ZW",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [6538, 985],
                [6522, 990],
                [6519, 917],
                [6415, 933],
                [6369, 990],
                [6367, 1039],
                [6410, 1119],
                [6450, 1143],
                [6517, 1112],
                [6523, 1329],
                [6506, 1396],
                [6463, 1471],
                [6465, 1507],
                [6434, 1613],
                [6376, 1629],
                [6306, 1622],
                [6236, 1650],
                [6183, 1643],
                [6144, 1638],
                [6127, 1606],
                [6053, 1588],
                [5977, 1499],
                [5880, 1440],
                [5860, 1355],
                [5803, 1301],
                [5734, 1285],
                [5697, 1161],
                [5596, 1132],
                [5483, 1160],
                [5423, 1209],
                [5365, 1205],
                [5344, 1181],
                [5328, 1109],
                [5195, 984],
                [5066, 979],
                [5057, 1046],
                [5086, 1088],
                [5056, 1188],
                [5024, 1244],
                [4974, 1284],
                [4976, 762],
                [4922, 741],
                [4860, 679],
                [4817, 696],
                [4742, 687],
                [4644, 715],
                [4636, 785],
                [4578, 806],
                [4566, 764],
                [4526, 734],
                [4567, 660],
                [4629, 473],
                [4708, 325],
                [4744, 277],
                [4767, 188],
                [4758, 129],
                [4703, 103],
                [4786, -57],
                [4764, -102],
                [4833, -101],
                [4827, -134],
                [4887, -140],
                [4934, -197],
                [4974, -203],
                [5047, -147],
                [5097, -133],
                [5198, -137],
                [5309, -76],
                [5417, -94],
                [5446, -74],
                [5603, -105],
                [5616, -74],
                [5712, -80],
                [5709, -45],
                [5744, -32],
                [5816, -39],
                [5897, 3],
                [5994, 70],
                [6119, 184],
                [6186, 267],
                [6266, 334],
                [6315, 400],
                [6418, 590],
                [6491, 677],
                [6572, 737],
                [6593, 790],
                [6639, 984],
                [6569, 982],
                [6538, 985],
              ],
              [
                [6035, 487],
                [6017, 429],
                [5974, 438],
                [5919, 507],
                [5881, 582],
                [5933, 615],
                [5975, 687],
                [6057, 728],
                [6089, 736],
                [6192, 623],
                [6157, 575],
                [6156, 539],
                [6035, 487],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.44,
            "hc-middle-y": 0.59,
            "hc-key": "ZAF",
            "hc-a2": "ZA",
            name: t("Countries.za", { ns: region }),
            labelrank: "2",
            "country-abbrev": "S.Af.",
            subregion: "Southern Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "ZAF",
            "iso-a2": "ZA",
            "woe-id": "23424942",
            continent: "Africa",
          },
          id: "ZA",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [6639, 984],
                [6651, 1110],
                [6632, 1064],
                [6591, 1113],
                [6637, 1170],
                [6747, 1232],
                [6866, 1273],
                [6925, 1303],
                [6976, 1371],
                [6963, 1409],
                [6980, 1540],
                [6975, 1653],
                [6953, 1609],
                [6948, 1715],
                [6917, 1793],
                [6913, 1841],
                [6871, 1883],
                [6881, 1957],
                [6931, 1982],
                [7001, 2059],
                [7107, 2134],
                [7186, 2230],
                [7293, 2298],
                [7451, 2363],
                [7552, 2424],
                [7586, 2490],
                [7642, 2548],
                [7645, 2590],
                [7674, 2638],
                [7675, 2683],
                [7637, 2793],
                [7644, 2883],
                [7625, 3057],
                [7650, 3162],
                [7627, 3210],
                [7571, 3167],
                [7477, 3122],
                [7426, 3121],
                [7373, 3089],
                [7343, 3107],
                [7293, 3102],
                [7281, 3070],
                [7235, 3049],
                [7156, 3069],
                [7123, 3048],
                [7075, 3052],
                [7027, 3091],
                [6995, 3066],
                [6915, 3070],
                [6903, 3008],
                [6880, 2989],
                [6896, 2920],
                [6887, 2890],
                [6900, 2814],
                [6929, 2789],
                [7028, 2660],
                [7019, 2590],
                [7020, 2481],
                [6966, 2463],
                [6934, 2410],
                [6953, 2388],
                [6954, 2331],
                [6927, 2332],
                [6917, 2373],
                [6837, 2458],
                [6818, 2498],
                [6862, 2580],
                [6853, 2673],
                [6833, 2698],
                [6752, 2685],
                [6742, 2670],
                [6685, 2748],
                [6297, 2621],
                [6321, 2533],
                [6321, 2485],
                [6433, 2481],
                [6517, 2427],
                [6566, 2423],
                [6654, 2392],
                [6635, 2358],
                [6660, 2301],
                [6649, 2231],
                [6661, 2169],
                [6642, 2108],
                [6617, 2102],
                [6639, 2063],
                [6626, 2016],
                [6660, 1972],
                [6657, 1938],
                [6610, 1866],
                [6593, 1865],
                [6579, 1766],
                [6434, 1613],
                [6465, 1507],
                [6463, 1471],
                [6506, 1396],
                [6523, 1329],
                [6517, 1112],
                [6529, 1065],
                [6538, 985],
                [6569, 982],
                [6639, 984],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.73,
            "hc-middle-y": 0.24,
            "hc-key": "MOZ",
            "hc-a2": "MZ",
            name: t("Countries.mz", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Moz.",
            subregion: "Eastern Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "MOZ",
            "iso-a2": "MZ",
            "woe-id": "23424902",
            continent: "Africa",
          },
          id: "MZ",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [6517, 1112],
                [6450, 1143],
                [6410, 1119],
                [6367, 1039],
                [6369, 990],
                [6415, 933],
                [6519, 917],
                [6522, 990],
                [6538, 985],
                [6529, 1065],
                [6517, 1112],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.52,
            "hc-middle-y": 0.48,
            "hc-key": "SWZ",
            "hc-a2": "SZ",
            name: t("Countries.sz", { ns: region }),
            labelrank: "4",
            "country-abbrev": "Swz.",
            subregion: "Southern Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "SWZ",
            "iso-a2": "SZ",
            "woe-id": "23424993",
            continent: "Africa",
          },
          id: "SZ",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [1682, 7923],
                [1448, 7919],
                [1544, 7141],
                [1593, 6733],
                [1629, 6704],
                [1610, 6593],
                [1105, 6586],
                [1042, 6568],
                [923, 6573],
                [900, 6529],
                [834, 6596],
                [793, 6587],
                [782, 6500],
                [724, 6482],
                [730, 6430],
                [765, 6366],
                [748, 6338],
                [813, 6293],
                [844, 6236],
                [844, 6165],
                [829, 6137],
                [871, 6114],
                [908, 6139],
                [934, 6098],
                [992, 6143],
                [1064, 6118],
                [1117, 6162],
                [1159, 6168],
                [1186, 6105],
                [1179, 6071],
                [1242, 6034],
                [1211, 6002],
                [1251, 5985],
                [1254, 5924],
                [1295, 5874],
                [1337, 5912],
                [1430, 5880],
                [1464, 5901],
                [1467, 5942],
                [1500, 5930],
                [1523, 5952],
                [1524, 5895],
                [1554, 5882],
                [1581, 5912],
                [1618, 5914],
                [1619, 5998],
                [1656, 6047],
                [1647, 6102],
                [1741, 6145],
                [1763, 6196],
                [1750, 6221],
                [1786, 6235],
                [1767, 6275],
                [1816, 6323],
                [1884, 6283],
                [1911, 6300],
                [1908, 6357],
                [1957, 6349],
                [1964, 6402],
                [2013, 6435],
                [2071, 6424],
                [2078, 6463],
                [2113, 6465],
                [2198, 6509],
                [2236, 6544],
                [2304, 6544],
                [2364, 6524],
                [2463, 6536],
                [2510, 6576],
                [2796, 6589],
                [2843, 6638],
                [2883, 6734],
                [2889, 6813],
                [2886, 7108],
                [2765, 7085],
                [2737, 7108],
                [2757, 7138],
                [2751, 7198],
                [2643, 7233],
                [2614, 7264],
                [2576, 7257],
                [2543, 7297],
                [2480, 7326],
                [2477, 7378],
                [1682, 7923],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.6,
            "hc-middle-y": 0.42,
            "hc-key": "MLI",
            "hc-a2": "ML",
            name: t("Countries.ml", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Mali",
            subregion: "Western Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "MLI",
            "iso-a2": "ML",
            "woe-id": "23424891",
            continent: "Africa",
          },
          id: "ML",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [4974, 1284],
                [5024, 1244],
                [5056, 1188],
                [5086, 1088],
                [5057, 1046],
                [5066, 979],
                [5195, 984],
                [5328, 1109],
                [5344, 1181],
                [5365, 1205],
                [5423, 1209],
                [5483, 1160],
                [5596, 1132],
                [5697, 1161],
                [5734, 1285],
                [5803, 1301],
                [5860, 1355],
                [5880, 1440],
                [5977, 1499],
                [6053, 1588],
                [6127, 1606],
                [6144, 1638],
                [6183, 1643],
                [6147, 1662],
                [6143, 1697],
                [6013, 1727],
                [5967, 1795],
                [5970, 1875],
                [5915, 1876],
                [5908, 1929],
                [5845, 1953],
                [5768, 2013],
                [5743, 2092],
                [5651, 2226],
                [5655, 2244],
                [5616, 2245],
                [5558, 2208],
                [5516, 2212],
                [5439, 2152],
                [5403, 2215],
                [5360, 2214],
                [5166, 2176],
                [5101, 2173],
                [5103, 1674],
                [4973, 1668],
                [4974, 1284],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.45,
            "hc-middle-y": 0.5,
            "hc-key": "BWA",
            "hc-a2": "BW",
            name: t("Countries.bw", { ns: region }),
            labelrank: "4",
            "country-abbrev": "Bwa.",
            subregion: "Southern Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "BWA",
            "iso-a2": "BW",
            "woe-id": "23424755",
            continent: "Africa",
          },
          id: "BW",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [7189, 7517],
                [6446, 7520],
                [5619, 7521],
                [5619, 7241],
                [5487, 7240],
                [5487, 7171],
                [5488, 6653],
                [5371, 6650],
                [5349, 6631],
                [5354, 6585],
                [5315, 6512],
                [5275, 6493],
                [5297, 6436],
                [5237, 6389],
                [5263, 6330],
                [5219, 6293],
                [5219, 6237],
                [5255, 6251],
                [5308, 6162],
                [5298, 6109],
                [5348, 6071],
                [5341, 6008],
                [5397, 5945],
                [5441, 5874],
                [5442, 5791],
                [5422, 5777],
                [5423, 5726],
                [5513, 5713],
                [5564, 5739],
                [5594, 5860],
                [5633, 5925],
                [5732, 5942],
                [5740, 5912],
                [5826, 5823],
                [5894, 5834],
                [6001, 5833],
                [6021, 5798],
                [6126, 5797],
                [6147, 5833],
                [6209, 5854],
                [6227, 5893],
                [6279, 5921],
                [6375, 5850],
                [6439, 5858],
                [6496, 5913],
                [6532, 5972],
                [6594, 6024],
                [6586, 6112],
                [6551, 6150],
                [6638, 6151],
                [6637, 6179],
                [6699, 6178],
                [6682, 6095],
                [6695, 5996],
                [6789, 5909],
                [6789, 5812],
                [6811, 5812],
                [6845, 5919],
                [6839, 5959],
                [6879, 6000],
                [6927, 5999],
                [6940, 6118],
                [6962, 6135],
                [7016, 6225],
                [7079, 6241],
                [7097, 6330],
                [7117, 6358],
                [7136, 6451],
                [7123, 6566],
                [7193, 6720],
                [7184, 6758],
                [7201, 6832],
                [7254, 6826],
                [7268, 6866],
                [7360, 6893],
                [7412, 6959],
                [7343, 7007],
                [7291, 7061],
                [7274, 7057],
                [7246, 7119],
                [7226, 7285],
                [7233, 7315],
                [7219, 7415],
                [7189, 7468],
                [7189, 7517],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.48,
            "hc-middle-y": 0.45,
            "hc-key": "SDN",
            "hc-a2": "SD",
            name: t("Countries.sd", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Sudan",
            subregion: "Northern Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "SDN",
            "iso-a2": "SD",
            "woe-id": "-90",
            continent: "Africa",
          },
          id: "SD",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [89.08811878283055, 7372.701329851148],
                [89.28040240060889, 7373.254900809162],
                [87.06083201358638, 7435.981890007623],
                [87.48701396599543, 7436.980519361708],
                [95.83836677151432, 7454.89134131804],
                [119.97469316672249, 7507.012526050083],
                [144.28976795316134, 7513.283317676764],
                [174.1040531249414, 7598.884604843825],
                [241.48828077579128, 7737.295450829355],
                [350.9038391157199, 7856.527070910059],
                [365.3295640260019, 7970.408454594457],
                [412.4649650301809, 8087.1778309055535],
                [514.6675820630205, 8152.527988785943],
                [514.7989078143814, 8152.235492125746],
                [514.6675820630205, 8152.527988785943],
                [572.1199822948779, 8299.93396624727],
                [572.3510754369488, 8299.48411413983],
                [571.9918933537288, 8300.029789104587],
                [598.001671239214, 8334.999688156773],
                [1148, 8306],
                [1166, 8307],
                [1163, 8457],
                [1302, 8568],
                [1365, 8587],
                [1549, 8605],
                [1578, 8592],
                [1612, 8648],
                [1730, 8744],
                [1826, 8777],
                [1837, 8814],
                [1802, 8870],
                [1822, 8921],
                [1932, 8945],
                [1917, 8984],
                [1973, 8998],
                [2141, 8992],
                [2167, 9061],
                [2116, 9095],
                [2082, 9173],
                [2080, 9311],
                [2053, 9389],
                [2067, 9412],
                [2006, 9468],
                [1918, 9476],
                [1906, 9503],
                [1847, 9483],
                [1813, 9497],
                [1720, 9474],
                [1667, 9488],
                [1603, 9543],
                [1582, 9598],
                [1515, 9576],
                [1466, 9427],
                [1397, 9291],
                [1309, 9227],
                [1173, 9165],
                [1077, 9055],
                [1065, 8968],
                [1002, 8871],
                [999, 8760],
                [1036, 8718],
                [1031, 8675],
                [968, 8568],
                [912, 8501],
                [850, 8466],
                [793, 8399],
                [718, 8363],
                [598, 8335],
                [572, 8300],
                [514.7989078143814, 8152.587155159368],
                [412, 8087],
                [364.9904554911195, 7970.074040709202],
                [351, 7856],
                [240, 7735],
                [173, 7597],
                [144, 7513],
                [120, 7507],
                [87, 7436],
                [89.08811878283055, 7372.701329851148],
                //hello
                [78, 7293],
                [89.2768207942265, 7373.138537822513],
                [609, 7383],
                [596, 7547],
                [586, 7583],
                [605, 7622],
                [656, 7659],
                [735, 7692],
                [729, 8054],
                [1166, 8061],
                [1167, 8251],
                [1166, 8307],
                [1148, 8306],
                [598.001671239214, 8334.999688156773],
                [571.9918933537288, 8300.029789104587],
                [572.3510754369488, 8299.48411413983],
                [572.1199822948779, 8299.93396624727],
                [514.6675820630205, 8152.527988785943],
                [514.7989078143814, 8152.235492125746],
                [514.6675820630205, 8152.527988785943],
                [412.4649650301809, 8087.1778309055535],
                [365.3295640260019, 7970.408454594457],
                [350.9038391157199, 7856.527070910059],
                [241.48828077579128, 7737.295450829355],
                [174.1040531249414, 7598.884604843825],
                [144.28976795316134, 7513.283317676764],
                [119.97469316672249, 7507.012526050083],
                [95.83836677151432, 7454.89134131804],
                [87.48701396599543, 7436.980519361708],
                [87.06083201358638, 7435.981890007623],
                [89.28040240060889, 7373.254900809162],
                [89.08811878283055, 7372.701329851148],
                [72, 7303],
                [78, 7293],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.73,
            "hc-middle-y": 0.27,
            "hc-key": "MAR",
            "hc-a2": "MA",
            name: t("Countries.ma", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Mor.",
            subregion: "Northern Africa",
            "region-wb": "Middle East & North Africa",
            "iso-a3": "MAR",
            "iso-a2": "MA",
            "woe-id": "23424893",
            continent: "Africa",
          },
          id: "MA",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [7189, 7517],
                [7099, 7610],
                [7033, 7651],
                [7006, 7731],
                [7010, 7800],
                [7037, 7802],
                [6973, 7861],
                [6883, 8054],
                [6813, 8184],
                [6812, 8219],
                [6746, 8337],
                [6748, 8384],
                [6663, 8477],
                [6631, 8536],
                [6627, 8593],
                [6593, 8631],
                [6624, 8685],
                [6644, 8611],
                [6699, 8545],
                [6712, 8475],
                [6823, 8360],
                [6869, 8387],
                [6866, 8435],
                [6897, 8505],
                [6923, 8651],
                [6841, 8892],
                [6768, 8862],
                [6696, 8881],
                [6629, 8854],
                [6593, 8886],
                [6561, 8857],
                [6519, 8891],
                [6539, 8926],
                [6486, 8914],
                [6446, 8935],
                [6356, 8906],
                [6332, 8924],
                [6218, 8839],
                [6155, 8819],
                [6073, 8859],
                [6006, 8864],
                [5932, 8903],
                [5731, 8941],
                [5675, 8924],
                [5642, 8948],
                [5603, 8905],
                [5621, 8813],
                [5580, 8715],
                [5619, 8569],
                [5619, 7521],
                [6446, 7520],
                [7189, 7517],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.38,
            "hc-middle-y": 0.57,
            "hc-key": "EGY",
            "hc-a2": "EG",
            name: t("Countries.eg", { ns: region }),
            labelrank: "2",
            "country-abbrev": "Egypt",
            subregion: "Northern Africa",
            "region-wb": "Middle East & North Africa",
            "iso-a3": "EGY",
            "iso-a2": "EG",
            "woe-id": "23424802",
            continent: "Africa",
          },
          id: "EG",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [6035, 487],
                [6156, 539],
                [6157, 575],
                [6192, 623],
                [6089, 736],
                [6057, 728],
                [5975, 687],
                [5933, 615],
                [5881, 582],
                [5919, 507],
                [5974, 438],
                [6017, 429],
                [6035, 487],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.5,
            "hc-middle-y": 0.48,
            "hc-key": "LSO",
            "hc-a2": "LS",
            name: t("Countries.ls", { ns: region }),
            labelrank: "6",
            "country-abbrev": "Les.",
            subregion: "Southern Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "LSO",
            "iso-a2": "LS",
            "woe-id": "23424880",
            continent: "Africa",
          },
          id: "LS",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [6796, 5126],
                [6849, 5178],
                [6984, 5231],
                [7010, 5177],
                [7050, 5177],
                [7032, 5196],
                [7036, 5267],
                [6972, 5272],
                [6928, 5337],
                [6896, 5441],
                [6839, 5485],
                [6763, 5575],
                [6676, 5595],
                [6693, 5674],
                [6797, 5679],
                [6816, 5703],
                [6811, 5812],
                [6789, 5812],
                [6789, 5909],
                [6695, 5996],
                [6682, 6095],
                [6699, 6178],
                [6637, 6179],
                [6638, 6151],
                [6551, 6150],
                [6586, 6112],
                [6594, 6024],
                [6532, 5972],
                [6496, 5913],
                [6439, 5858],
                [6375, 5850],
                [6279, 5921],
                [6227, 5893],
                [6209, 5854],
                [6147, 5833],
                [6126, 5797],
                [6021, 5798],
                [6001, 5833],
                [5894, 5834],
                [5826, 5823],
                [5740, 5912],
                [5732, 5942],
                [5633, 5925],
                [5594, 5860],
                [5564, 5739],
                [5513, 5713],
                [5508, 5668],
                [5600, 5645],
                [5658, 5578],
                [5669, 5535],
                [5756, 5491],
                [5802, 5446],
                [5790, 5411],
                [5815, 5374],
                [5900, 5330],
                [5941, 5239],
                [5984, 5177],
                [6067, 5135],
                [6113, 5171],
                [6167, 5144],
                [6204, 5185],
                [6302, 5092],
                [6344, 5081],
                [6346, 5048],
                [6385, 5032],
                [6425, 5071],
                [6472, 5054],
                [6508, 5074],
                [6560, 5036],
                [6586, 5063],
                [6670, 5082],
                [6737, 5068],
                [6796, 5126],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.51,
            "hc-middle-y": 0.49,
            "hc-key": "SSD",
            "hc-a2": "SS",
            name: t("Countries.ss", { ns: region }),
            labelrank: "3",
            "country-abbrev": "S. Sud.",
            subregion: "Eastern Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "SSD",
            "iso-a2": "SS",
            "woe-id": "-99",
            continent: "Africa",
          },
          id: "SS",
        },
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [5513, 5713],
                [5423, 5726],
                [5422, 5777],
                [5442, 5791],
                [5441, 5874],
                [5397, 5945],
                [5341, 6008],
                [5288, 6019],
                [5192, 5970],
                [5195, 5941],
                [5099, 5852],
                [5074, 5809],
                [5023, 5772],
                [4848, 5755],
                [4818, 5735],
                [4851, 5710],
                [4782, 5628],
                [4663, 5619],
                [4543, 5562],
                [4514, 5603],
                [4491, 5577],
                [4416, 5549],
                [4375, 5557],
                [4341, 5521],
                [4276, 5391],
                [4234, 5360],
                [4258, 5347],
                [4276, 5177],
                [4314, 5149],
                [4336, 5065],
                [4457, 4949],
                [4471, 4868],
                [4508, 4946],
                [4519, 5028],
                [4636, 5060],
                [4686, 5038],
                [4768, 5050],
                [4788, 5030],
                [4791, 5096],
                [4776, 5138],
                [4800, 5148],
                [4848, 5217],
                [4890, 5246],
                [4931, 5247],
                [5012, 5200],
                [5046, 5152],
                [5082, 5158],
                [5126, 5137],
                [5193, 5138],
                [5285, 5117],
                [5347, 5207],
                [5411, 5176],
                [5554, 5243],
                [5594, 5220],
                [5662, 5234],
                [5669, 5270],
                [5730, 5255],
                [5769, 5264],
                [5813, 5238],
                [5866, 5235],
                [5899, 5256],
                [5941, 5239],
                [5900, 5330],
                [5815, 5374],
                [5790, 5411],
                [5802, 5446],
                [5756, 5491],
                [5669, 5535],
                [5658, 5578],
                [5600, 5645],
                [5508, 5668],
                [5513, 5713],
              ],
            ],
          },
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.51,
            "hc-middle-y": 0.45,
            "hc-key": "CAF",
            "hc-a2": "CF",
            name: t("Countries.cf", { ns: region }),
            labelrank: "4",
            "country-abbrev": "C.A.R.",
            subregion: "Middle Africa",
            "region-wb": "Sub-Saharan Africa",
            "iso-a3": "CAF",
            "iso-a2": "CF",
            "woe-id": "23424792",
            continent: "Africa",
          },
          id: "CF",
        },
      ],
    };
  } else if (region === "escap") {
    return {
      title: "Asia and Pacific",
      version: "2.0.1",
      type: "FeatureCollection",
      copyright:
        "Copyright (c) 2022 Highsoft AS, Based on data from Natural Earth",
      copyrightShort: "Natural Earth",
      copyrightUrl: "http://www.naturalearthdata.com",
      crs: { type: "name", properties: { name: "urn:ogc:def:crs:EPSG:54003" } },
      "hc-transform": {
        default: {
          crs: "+proj=mill +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R_A +datum=WGS84 +units=m +no_defs",
          scale: 1.70830296554e-5,
          jsonres: 15.5,
          jsonmarginX: -999,
          jsonmarginY: 9851.0,
          xoffset: -19816494.5204,
          yoffset: 12635908.1982,
        },
      },
      features: [
        {
          type: "Feature",
          id: "LK",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.67,
            "hc-middle-y": 0.87,
            "hc-key": "lk",
            "hc-a2": "LK",
            name: "",
            labelrank: "3",
            "country-abbrev": "Sri L.",
            subregion: "Southern Asia",
            "region-wb": "South Asia",
            "iso-a3": "LKA",
            "iso-a2": "LK",
            "woe-id": "23424778",
            continent: "Asia",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [6603, 6788],
                [6607, 6793],
                [6626, 6780],
                [6644, 6754],
                [6646, 6743],
                [6657, 6728],
                [6659, 6711],
                [6653, 6694],
                [6644, 6687],
                [6621, 6679],
                [6609, 6682],
                [6600, 6705],
                [6596, 6740],
                [6602, 6761],
                [6601, 6767],
                [6609, 6783],
                [6603, 6788],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "HK",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.41,
            "hc-middle-y": 0.56,
            "hc-key": "HKG",
            "hc-a2": "HK",
            name: t("Countries.hk", { ns: region }),
            labelrank: "2",
            "country-abbrev": "Hong Kong",
            subregion: "Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "HKG",
            "iso-a2": "HK",
            "woe-id": "	24865698",
            continent: "Asia",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                // [7579, 7118],
                // [7585, 7122],
                // [7590, 7120],
                // [7596, 7119],
                // [7605, 7120],
                // [7608, 7113],
                // [7599, 7100],
                // [7579, 7118],
                [7599, 7173],
                [7605, 7177],
                [7610, 7175],
                [7616, 7174],
                [7625, 7175],
                [7628, 7168],
                [7619, 7155],
                [7599, 7173],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "JP",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.67,
            "hc-middle-y": 0.5,
            "hc-key": "JPN",
            "hc-a2": "JP",
            name: t("Countries.jp", { ns: region }),
            labelrank: "2",
            "country-abbrev": "Japan",
            subregion: "Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "JPN",
            "iso-a2": "JP",
            "woe-id": "23424856",
            continent: "Asia",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [8213, 7550],
                  [8222, 7560],
                  [8222, 7549],
                  [8211, 7542],
                  [8216, 7535],
                  [8205, 7528],
                  [8199, 7515],
                  [8191, 7524],
                  [8182, 7524],
                  [8172, 7519],
                  [8163, 7501],
                  [8151, 7499],
                  [8146, 7523],
                  [8155, 7531],
                  [8162, 7545],
                  [8167, 7539],
                  [8179, 7539],
                  [8183, 7546],
                  [8198, 7553],
                  [8206, 7547],
                  [8213, 7550],
                ],
              ],
              [
                [
                  [8108, 7435],
                  [8104, 7422],
                  [8089, 7418],
                  [8090, 7425],
                  [8101, 7425],
                  [8103, 7432],
                  [8095, 7442],
                  [8099, 7453],
                  [8094, 7464],
                  [8095, 7448],
                  [8082, 7450],
                  [8086, 7463],
                  [8081, 7468],
                  [8082, 7477],
                  [8095, 7496],
                  [8076, 7481],
                  [8081, 7501],
                  [8071, 7497],
                  [8065, 7507],
                  [8076, 7502],
                  [8074, 7508],
                  [8059, 7514],
                  [8043, 7496],
                  [8036, 7494],
                  [8049, 7508],
                  [8050, 7515],
                  [8057, 7513],
                  [8059, 7519],
                  [8070, 7519],
                  [8080, 7528],
                  [8087, 7527],
                  [8090, 7535],
                  [8105, 7539],
                  [8107, 7529],
                  [8127, 7526],
                  [8120, 7516],
                  [8132, 7516],
                  [8135, 7505],
                  [8125, 7492],
                  [8115, 7454],
                  [8111, 7457],
                  [8103, 7446],
                  [8108, 7435],
                ],
              ],
              [
                [
                  [8411, 7783],
                  [8412, 7766],
                  [8422, 7756],
                  [8428, 7743],
                  [8431, 7727],
                  [8425, 7709],
                  [8418, 7708],
                  [8413, 7697],
                  [8415, 7683],
                  [8402, 7687],
                  [8398, 7670],
                  [8401, 7653],
                  [8398, 7639],
                  [8394, 7636],
                  [8387, 7616],
                  [8396, 7597],
                  [8384, 7592],
                  [8382, 7580],
                  [8368, 7570],
                  [8364, 7584],
                  [8373, 7593],
                  [8364, 7591],
                  [8359, 7578],
                  [8357, 7584],
                  [8345, 7581],
                  [8345, 7569],
                  [8336, 7560],
                  [8335, 7577],
                  [8328, 7577],
                  [8318, 7564],
                  [8294, 7562],
                  [8282, 7559],
                  [8291, 7566],
                  [8278, 7565],
                  [8278, 7575],
                  [8272, 7573],
                  [8268, 7561],
                  [8279, 7555],
                  [8279, 7550],
                  [8266, 7548],
                  [8259, 7542],
                  [8251, 7527],
                  [8236, 7525],
                  [8225, 7536],
                  [8225, 7549],
                  [8235, 7559],
                  [8233, 7564],
                  [8222, 7561],
                  [8215, 7566],
                  [8194, 7560],
                  [8204, 7554],
                  [8185, 7558],
                  [8163, 7547],
                  [8166, 7553],
                  [8151, 7545],
                  [8149, 7552],
                  [8141, 7548],
                  [8138, 7536],
                  [8127, 7542],
                  [8113, 7538],
                  [8101, 7544],
                  [8104, 7554],
                  [8117, 7554],
                  [8147, 7579],
                  [8153, 7588],
                  [8167, 7593],
                  [8176, 7589],
                  [8201, 7592],
                  [8209, 7596],
                  [8221, 7595],
                  [8230, 7599],
                  [8228, 7592],
                  [8247, 7591],
                  [8255, 7599],
                  [8251, 7606],
                  [8265, 7621],
                  [8275, 7636],
                  [8274, 7652],
                  [8291, 7658],
                  [8282, 7647],
                  [8281, 7636],
                  [8292, 7632],
                  [8294, 7638],
                  [8318, 7646],
                  [8327, 7653],
                  [8337, 7668],
                  [8326, 7670],
                  [8319, 7667],
                  [8320, 7680],
                  [8324, 7676],
                  [8342, 7672],
                  [8353, 7680],
                  [8358, 7696],
                  [8364, 7702],
                  [8372, 7726],
                  [8369, 7739],
                  [8363, 7738],
                  [8371, 7755],
                  [8366, 7763],
                  [8379, 7773],
                  [8380, 7787],
                  [8388, 7785],
                  [8390, 7774],
                  [8396, 7778],
                  [8403, 7773],
                  [8408, 7783],
                  [8404, 7787],
                  [8394, 7782],
                  [8397, 7797],
                  [8408, 7790],
                  [8411, 7783],
                ],
              ],
              [
                [
                  [8477, 7836],
                  [8469, 7824],
                  [8465, 7810],
                  [8421, 7835],
                  [8399, 7825],
                  [8392, 7833],
                  [8381, 7831],
                  [8379, 7822],
                  [8391, 7817],
                  [8405, 7805],
                  [8391, 7806],
                  [8376, 7792],
                  [8370, 7797],
                  [8374, 7812],
                  [8364, 7821],
                  [8367, 7836],
                  [8378, 7840],
                  [8386, 7849],
                  [8380, 7856],
                  [8385, 7861],
                  [8394, 7855],
                  [8405, 7853],
                  [8413, 7861],
                  [8410, 7874],
                  [8418, 7882],
                  [8423, 7905],
                  [8417, 7926],
                  [8409, 7926],
                  [8401, 7930],
                  [8417, 7929],
                  [8428, 7939],
                  [8458, 7905],
                  [8480, 7888],
                  [8494, 7888],
                  [8501, 7882],
                  [8512, 7882],
                  [8527, 7896],
                  [8520, 7875],
                  [8528, 7859],
                  [8536, 7859],
                  [8510, 7845],
                  [8493, 7847],
                  [8477, 7836],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "NZ",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.26,
            "hc-middle-y": 0.8,
            "hc-key": "NZL",
            "hc-a2": "NZ",
            name: t("Countries.nz", { ns: region }),
            labelrank: "2",
            "country-abbrev": "N.Z.",
            subregion: "Australia and New Zealand",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "NZL",
            "iso-a2": "NZ",
            "woe-id": "23424916",
            continent: "Oceania",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [9186, 5025],
                  [9192, 5029],
                  [9202, 5014],
                  [9180, 5007],
                  [9189, 5021],
                  [9186, 5025],
                ],
              ],
              [
                [
                  [9263, 5054],
                  [9260, 5048],
                  [9243, 5033],
                  [9225, 5029],
                  [9219, 5033],
                  [9202, 5034],
                  [9201, 5041],
                  [9190, 5039],
                  [9186, 5047],
                  [9177, 5045],
                  [9158, 5046],
                  [9150, 5053],
                  [9159, 5078],
                  [9174, 5095],
                  [9187, 5105],
                  [9206, 5125],
                  [9217, 5126],
                  [9230, 5135],
                  [9246, 5142],
                  [9262, 5158],
                  [9274, 5164],
                  [9287, 5177],
                  [9297, 5204],
                  [9308, 5209],
                  [9314, 5218],
                  [9315, 5237],
                  [9331, 5250],
                  [9333, 5241],
                  [9342, 5240],
                  [9345, 5222],
                  [9364, 5231],
                  [9365, 5236],
                  [9365, 5223],
                  [9377, 5234],
                  [9373, 5215],
                  [9380, 5207],
                  [9368, 5189],
                  [9358, 5180],
                  [9350, 5164],
                  [9336, 5156],
                  [9334, 5147],
                  [9345, 5132],
                  [9325, 5136],
                  [9320, 5131],
                  [9293, 5116],
                  [9289, 5106],
                  [9289, 5094],
                  [9280, 5076],
                  [9272, 5065],
                  [9274, 5057],
                  [9263, 5054],
                ],
              ],
              [
                [
                  [9455, 5261],
                  [9440, 5243],
                  [9429, 5224],
                  [9410, 5211],
                  [9406, 5218],
                  [9397, 5218],
                  [9397, 5225],
                  [9389, 5223],
                  [9399, 5234],
                  [9406, 5248],
                  [9408, 5258],
                  [9400, 5270],
                  [9388, 5274],
                  [9381, 5281],
                  [9365, 5288],
                  [9365, 5295],
                  [9388, 5308],
                  [9392, 5333],
                  [9396, 5344],
                  [9382, 5382],
                  [9382, 5396],
                  [9371, 5400],
                  [9372, 5395],
                  [9345, 5430],
                  [9348, 5435],
                  [9332, 5454],
                  [9344, 5457],
                  [9347, 5442],
                  [9356, 5437],
                  [9368, 5437],
                  [9377, 5426],
                  [9382, 5430],
                  [9388, 5417],
                  [9386, 5404],
                  [9397, 5391],
                  [9405, 5397],
                  [9413, 5401],
                  [9414, 5388],
                  [9420, 5378],
                  [9426, 5380],
                  [9430, 5349],
                  [9464, 5337],
                  [9472, 5337],
                  [9489, 5352],
                  [9506, 5346],
                  [9499, 5336],
                  [9498, 5318],
                  [9488, 5310],
                  [9485, 5299],
                  [9471, 5299],
                  [9461, 5295],
                  [9457, 5287],
                  [9461, 5276],
                  [9455, 5261],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "IN",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.35,
            "hc-middle-y": 0.44,
            "hc-key": "IND",
            "hc-a2": "IN",
            name: t("Countries.in", { ns: region }),
            labelrank: "2",
            "country-abbrev": "India",
            subregion: "Southern Asia",
            "region-wb": "South Asia",
            "iso-a3": "IND",
            "iso-a2": "IN",
            "woe-id": "23424848",
            continent: "Asia",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [6987, 6907],
                  [6989, 6895],
                  [6984, 6890],
                  [6986, 6873],
                  [6980, 6859],
                  [6976, 6839],
                  [6975, 6849],
                  [6982, 6895],
                  [6987, 6907],
                ],
              ],
              [
                [
                  [6870, 7163],
                  [6870, 7157],
                  [6870, 7153],
                  [6869, 7147],
                  [6856, 7146],
                  [6841, 7148],
                  [6846, 7162],
                  [6830, 7149],
                  [6816, 7145],
                  [6805, 7134],
                  [6810, 7119],
                  [6792, 7098],
                  [6764, 7088],
                  [6768, 7094],
                  [6757, 7090],
                  [6761, 7085],
                  [6747, 7074],
                  [6724, 7046],
                  [6710, 7039],
                  [6699, 7025],
                  [6676, 7013],
                  [6671, 7008],
                  [6672, 6995],
                  [6655, 6987],
                  [6640, 6987],
                  [6638, 6977],
                  [6627, 6969],
                  [6620, 6974],
                  [6611, 6967],
                  [6605, 6948],
                  [6609, 6934],
                  [6607, 6925],
                  [6610, 6908],
                  [6605, 6906],
                  [6614, 6898],
                  [6608, 6872],
                  [6600, 6858],
                  [6596, 6845],
                  [6599, 6838],
                  [6599, 6807],
                  [6586, 6808],
                  [6572, 6783],
                  [6575, 6778],
                  [6552, 6768],
                  [6547, 6751],
                  [6530, 6742],
                  [6515, 6750],
                  [6502, 6766],
                  [6495, 6784],
                  [6493, 6798],
                  [6481, 6831],
                  [6472, 6849],
                  [6462, 6858],
                  [6451, 6883],
                  [6444, 6914],
                  [6435, 6938],
                  [6424, 6950],
                  [6424, 6957],
                  [6411, 6979],
                  [6407, 6994],
                  [6406, 7010],
                  [6397, 7040],
                  [6393, 7061],
                  [6397, 7068],
                  [6392, 7073],
                  [6387, 7093],
                  [6394, 7114],
                  [6394, 7125],
                  [6386, 7137],
                  [6386, 7144],
                  [6395, 7150],
                  [6384, 7150],
                  [6384, 7164],
                  [6377, 7166],
                  [6372, 7159],
                  [6377, 7149],
                  [6371, 7135],
                  [6338, 7120],
                  [6325, 7123],
                  [6311, 7133],
                  [6278, 7168],
                  [6298, 7170],
                  [6314, 7177],
                  [6321, 7188],
                  [6301, 7182],
                  [6287, 7185],
                  [6269, 7196],
                  [6256, 7216],
                  [6256, 7216],
                  [6256, 7216],
                  [6263, 7220],
                  [6272, 7220],
                  [6272, 7230],
                  [6296, 7230],
                  [6308, 7226],
                  [6324, 7234],
                  [6331, 7228],
                  [6341, 7234],
                  [6340, 7242],
                  [6328, 7266],
                  [6328, 7274],
                  [6317, 7274],
                  [6311, 7283],
                  [6314, 7300],
                  [6304, 7302],
                  [6293, 7309],
                  [6297, 7321],
                  [6319, 7347],
                  [6334, 7337],
                  [6364, 7345],
                  [6379, 7371],
                  [6395, 7379],
                  [6404, 7395],
                  [6408, 7408],
                  [6425, 7416],
                  [6422, 7421],
                  [6437, 7439],
                  [6446, 7445],
                  [6441, 7465],
                  [6451, 7476],
                  [6467, 7483],
                  [6457, 7490],
                  [6448, 7490],
                  [6447, 7502],
                  [6436, 7501],
                  [6436, 7506],
                  [6427, 7513],
                  [6431, 7525],
                  [6426, 7529],
                  [6435, 7539],
                  [6425, 7541],
                  [6427, 7547],
                  [6420, 7552],
                  [6425, 7561],
                  [6435, 7566],
                  [6479, 7557],
                  [6487, 7563],
                  [6502, 7564],
                  [6517, 7577],
                  [6539, 7590],
                  [6545, 7582],
                  [6553, 7562],
                  [6572, 7553],
                  [6566, 7543],
                  [6568, 7525],
                  [6573, 7518],
                  [6585, 7513],
                  [6588, 7496],
                  [6572, 7486],
                  [6566, 7496],
                  [6556, 7492],
                  [6558, 7482],
                  [6567, 7474],
                  [6566, 7453],
                  [6576, 7456],
                  [6591, 7440],
                  [6599, 7441],
                  [6610, 7433],
                  [6609, 7428],
                  [6625, 7423],
                  [6633, 7416],
                  [6618, 7404],
                  [6610, 7391],
                  [6612, 7388],
                  [6605, 7373],
                  [6614, 7366],
                  [6623, 7366],
                  [6637, 7358],
                  [6642, 7350],
                  [6659, 7342],
                  [6664, 7343],
                  [6674, 7336],
                  [6682, 7337],
                  [6685, 7330],
                  [6716, 7328],
                  [6724, 7331],
                  [6738, 7325],
                  [6740, 7316],
                  [6759, 7306],
                  [6768, 7310],
                  [6775, 7301],
                  [6789, 7303],
                  [6801, 7296],
                  [6811, 7302],
                  [6819, 7294],
                  [6841, 7298],
                  [6844, 7307],
                  [6838, 7318],
                  [6843, 7342],
                  [6857, 7350],
                  [6864, 7341],
                  [6861, 7332],
                  [6865, 7325],
                  [6861, 7320],
                  [6871, 7309],
                  [6879, 7310],
                  [6893, 7305],
                  [6909, 7311],
                  [6915, 7308],
                  [6943, 7308],
                  [6959, 7313],
                  [6956, 7330],
                  [6950, 7328],
                  [6946, 7339],
                  [6956, 7338],
                  [6975, 7344],
                  [6976, 7350],
                  [6999, 7368],
                  [7005, 7368],
                  [7026, 7379],
                  [7034, 7388],
                  [7039, 7383],
                  [7054, 7380],
                  [7067, 7389],
                  [7079, 7390],
                  [7092, 7369],
                  [7103, 7357],
                  [7114, 7353],
                  [7114, 7343],
                  [7100, 7334],
                  [7108, 7319],
                  [7097, 7326],
                  [7079, 7323],
                  [7046, 7298],
                  [7050, 7285],
                  [7045, 7275],
                  [7034, 7264],
                  [7037, 7253],
                  [7024, 7231],
                  [7019, 7216],
                  [6995, 7222],
                  [6999, 7210],
                  [6997, 7194],
                  [6990, 7190],
                  [6991, 7171],
                  [6986, 7159],
                  [6977, 7164],
                  [6974, 7159],
                  [6967, 7199],
                  [6961, 7213],
                  [6949, 7198],
                  [6945, 7188],
                  [6936, 7194],
                  [6932, 7209],
                  [6938, 7224],
                  [6960, 7234],
                  [6964, 7249],
                  [6970, 7251],
                  [6957, 7258],
                  [6934, 7258],
                  [6909, 7257],
                  [6892, 7264],
                  [6893, 7281],
                  [6888, 7290],
                  [6885, 7282],
                  [6870, 7291],
                  [6863, 7291],
                  [6853, 7298],
                  [6841, 7280],
                  [6855, 7268],
                  [6862, 7268],
                  [6866, 7257],
                  [6852, 7257],
                  [6840, 7241],
                  [6843, 7236],
                  [6861, 7228],
                  [6855, 7210],
                  [6862, 7204],
                  [6860, 7197],
                  [6867, 7196],
                  [6864, 7189],
                  [6870, 7163],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "PG",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.12,
            "hc-middle-y": 0.45,
            "hc-key": "PNG",
            "hc-a2": "PG",
            name: "",
            labelrank: "2",
            "country-abbrev": "P.N.G.",
            subregion: "Melanesia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "PNG",
            "iso-a2": "PG",
            "woe-id": "23424926",
            continent: "Oceania",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [8675, 6226],
                  [8687, 6229],
                  [8693, 6223],
                  [8701, 6206],
                  [8693, 6209],
                  [8687, 6221],
                  [8675, 6226],
                ],
              ],
              [
                [
                  [8801, 6345],
                  [8812, 6343],
                  [8825, 6325],
                  [8839, 6314],
                  [8840, 6308],
                  [8833, 6304],
                  [8822, 6308],
                  [8819, 6319],
                  [8805, 6331],
                  [8805, 6342],
                  [8801, 6345],
                ],
              ],
              [
                [
                  [8678, 6427],
                  [8670, 6427],
                  [8663, 6433],
                  [8671, 6435],
                  [8689, 6430],
                  [8714, 6415],
                  [8722, 6428],
                  [8725, 6410],
                  [8740, 6393],
                  [8752, 6388],
                  [8757, 6380],
                  [8750, 6363],
                  [8743, 6375],
                  [8744, 6383],
                  [8732, 6401],
                  [8718, 6407],
                  [8697, 6422],
                  [8678, 6427],
                ],
              ],
              [
                [
                  [8399, 6238],
                  [8399, 6303],
                  [8395, 6309],
                  [8399, 6320],
                  [8399, 6429],
                  [8429, 6419],
                  [8431, 6416],
                  [8459, 6407],
                  [8474, 6405],
                  [8488, 6394],
                  [8503, 6393],
                  [8519, 6378],
                  [8528, 6377],
                  [8538, 6366],
                  [8547, 6372],
                  [8541, 6363],
                  [8539, 6346],
                  [8560, 6341],
                  [8578, 6331],
                  [8589, 6331],
                  [8601, 6320],
                  [8601, 6309],
                  [8576, 6308],
                  [8575, 6301],
                  [8582, 6287],
                  [8598, 6273],
                  [8609, 6269],
                  [8613, 6254],
                  [8619, 6251],
                  [8622, 6240],
                  [8639, 6242],
                  [8645, 6238],
                  [8642, 6227],
                  [8666, 6220],
                  [8657, 6217],
                  [8663, 6210],
                  [8682, 6206],
                  [8675, 6201],
                  [8691, 6195],
                  [8671, 6191],
                  [8657, 6202],
                  [8605, 6207],
                  [8595, 6212],
                  [8586, 6224],
                  [8578, 6228],
                  [8574, 6238],
                  [8563, 6247],
                  [8549, 6268],
                  [8540, 6273],
                  [8529, 6273],
                  [8514, 6277],
                  [8507, 6284],
                  [8503, 6277],
                  [8494, 6277],
                  [8481, 6283],
                  [8487, 6272],
                  [8479, 6269],
                  [8472, 6255],
                  [8466, 6257],
                  [8470, 6242],
                  [8448, 6232],
                  [8436, 6236],
                  [8425, 6235],
                  [8399, 6238],
                ],
              ],
              [
                [
                  [8678, 6321],
                  [8654, 6321],
                  [8644, 6328],
                  [8636, 6329],
                  [8615, 6340],
                  [8607, 6341],
                  [8607, 6335],
                  [8599, 6344],
                  [8580, 6346],
                  [8595, 6349],
                  [8606, 6342],
                  [8635, 6345],
                  [8642, 6341],
                  [8656, 6342],
                  [8664, 6346],
                  [8683, 6342],
                  [8695, 6347],
                  [8705, 6362],
                  [8715, 6364],
                  [8710, 6383],
                  [8724, 6383],
                  [8735, 6378],
                  [8732, 6361],
                  [8723, 6360],
                  [8726, 6345],
                  [8710, 6339],
                  [8696, 6329],
                  [8678, 6321],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "BD",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.85,
            "hc-middle-y": 0.57,
            "hc-key": "BGD",
            "hc-a2": "BD",
            name: "",
            labelrank: "3",
            "country-abbrev": "Bang.",
            subregion: "Southern Asia",
            "region-wb": "South Asia",
            "iso-a3": "BGD",
            "iso-a2": "BD",
            "woe-id": "23424759",
            continent: "Asia",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [6927, 7170],
                  [6933, 7166],
                  [6923, 7165],
                  [6918, 7159],
                  [6917, 7183],
                  [6927, 7170],
                ],
              ],
              [
                [
                  [6870, 7153],
                  [6871, 7159],
                  [6870, 7163],
                  [6864, 7189],
                  [6867, 7196],
                  [6860, 7197],
                  [6862, 7204],
                  [6855, 7210],
                  [6861, 7228],
                  [6843, 7236],
                  [6840, 7241],
                  [6852, 7257],
                  [6866, 7257],
                  [6862, 7268],
                  [6855, 7268],
                  [6841, 7280],
                  [6853, 7298],
                  [6863, 7291],
                  [6870, 7291],
                  [6885, 7282],
                  [6888, 7290],
                  [6893, 7281],
                  [6892, 7264],
                  [6909, 7257],
                  [6934, 7258],
                  [6957, 7258],
                  [6970, 7251],
                  [6964, 7249],
                  [6960, 7234],
                  [6938, 7224],
                  [6932, 7209],
                  [6936, 7194],
                  [6945, 7188],
                  [6949, 7198],
                  [6961, 7213],
                  [6967, 7199],
                  [6974, 7159],
                  [6976, 7138],
                  [6966, 7143],
                  [6965, 7130],
                  [6966, 7121],
                  [6953, 7143],
                  [6954, 7155],
                  [6947, 7176],
                  [6940, 7175],
                  [6941, 7183],
                  [6933, 7182],
                  [6933, 7174],
                  [6926, 7177],
                  [6918, 7189],
                  [6912, 7181],
                  [6914, 7165],
                  [6903, 7153],
                  [6901, 7159],
                  [6875, 7148],
                  [6870, 7153],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "CN",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.42,
            "hc-middle-y": 0.55,
            "hc-key": "CHN",
            "hc-a2": "CN",
            name: t("Countries.cn", { ns: region }),
            // name: t("Countries.hk", { ns: region }),
            name: "",
            labelrank: "2",
            "country-abbrev": "China",
            subregion: "Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "CHN",
            "iso-a2": "CN",
            "woe-id": "23424781",
            continent: "Asia",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [7498, 7058],
                  [7479, 7049],
                  [7474, 7043],
                  [7448, 7053],
                  [7446, 7076],
                  [7463, 7089],
                  [7479, 7098],
                  [7487, 7095],
                  [7492, 7100],
                  [7503, 7098],
                  [7507, 7103],
                  [7514, 7098],
                  [7516, 7089],
                  [7507, 7079],
                  [7498, 7058],
                ],
              ],
              [
                [
                  [6865, 7325],
                  [6861, 7332],
                  [6864, 7341],
                  [6857, 7350],
                  [6843, 7342],
                  [6814, 7341],
                  [6796, 7349],
                  [6793, 7344],
                  [6780, 7343],
                  [6771, 7357],
                  [6753, 7356],
                  [6756, 7365],
                  [6741, 7366],
                  [6728, 7375],
                  [6724, 7386],
                  [6707, 7384],
                  [6697, 7398],
                  [6687, 7399],
                  [6678, 7408],
                  [6667, 7412],
                  [6665, 7421],
                  [6644, 7422],
                  [6636, 7411],
                  [6633, 7416],
                  [6625, 7423],
                  [6609, 7428],
                  [6610, 7433],
                  [6599, 7441],
                  [6591, 7440],
                  [6576, 7456],
                  [6566, 7453],
                  [6567, 7474],
                  [6558, 7482],
                  [6556, 7492],
                  [6566, 7496],
                  [6572, 7486],
                  [6588, 7496],
                  [6585, 7513],
                  [6573, 7518],
                  [6568, 7525],
                  [6566, 7543],
                  [6572, 7553],
                  [6553, 7562],
                  [6545, 7582],
                  [6539, 7590],
                  [6527, 7589],
                  [6509, 7595],
                  [6502, 7603],
                  [6491, 7600],
                  [6483, 7610],
                  [6485, 7622],
                  [6480, 7630],
                  [6468, 7632],
                  [6467, 7637],
                  [6443, 7641],
                  [6438, 7645],
                  [6448, 7650],
                  [6453, 7648],
                  [6461, 7654],
                  [6453, 7661],
                  [6455, 7666],
                  [6450, 7677],
                  [6450, 7692],
                  [6437, 7697],
                  [6428, 7692],
                  [6421, 7695],
                  [6422, 7708],
                  [6415, 7716],
                  [6416, 7724],
                  [6425, 7729],
                  [6422, 7736],
                  [6427, 7745],
                  [6438, 7746],
                  [6452, 7761],
                  [6462, 7758],
                  [6474, 7764],
                  [6476, 7753],
                  [6493, 7758],
                  [6495, 7755],
                  [6504, 7765],
                  [6508, 7776],
                  [6515, 7779],
                  [6529, 7777],
                  [6547, 7779],
                  [6555, 7791],
                  [6583, 7805],
                  [6609, 7813],
                  [6610, 7819],
                  [6608, 7835],
                  [6620, 7845],
                  [6614, 7849],
                  [6627, 7853],
                  [6625, 7864],
                  [6614, 7888],
                  [6614, 7907],
                  [6603, 7913],
                  [6605, 7921],
                  [6629, 7925],
                  [6655, 7932],
                  [6661, 7925],
                  [6680, 7926],
                  [6681, 7936],
                  [6671, 7939],
                  [6677, 7953],
                  [6692, 8001],
                  [6719, 7992],
                  [6741, 7993],
                  [6744, 7987],
                  [6757, 7995],
                  [6765, 7995],
                  [6771, 8008],
                  [6766, 8028],
                  [6774, 8046],
                  [6797, 8051],
                  [6802, 8057],
                  [6802, 8068],
                  [6806, 8073],
                  [6819, 8072],
                  [6834, 8075],
                  [6833, 8061],
                  [6837, 8053],
                  [6856, 8044],
                  [6856, 8039],
                  [6870, 8030],
                  [6885, 8032],
                  [6891, 8024],
                  [6899, 8026],
                  [6908, 8018],
                  [6912, 8005],
                  [6922, 7993],
                  [6929, 7977],
                  [6924, 7968],
                  [6928, 7957],
                  [6919, 7947],
                  [6917, 7938],
                  [6924, 7927],
                  [6947, 7922],
                  [6971, 7920],
                  [6979, 7921],
                  [7002, 7918],
                  [7014, 7908],
                  [7046, 7893],
                  [7056, 7894],
                  [7055, 7884],
                  [7060, 7883],
                  [7072, 7856],
                  [7083, 7846],
                  [7085, 7839],
                  [7110, 7841],
                  [7177, 7833],
                  [7193, 7837],
                  [7241, 7831],
                  [7252, 7819],
                  [7283, 7813],
                  [7302, 7804],
                  [7325, 7808],
                  [7325, 7801],
                  [7340, 7798],
                  [7346, 7804],
                  [7392, 7823],
                  [7433, 7829],
                  [7451, 7827],
                  [7472, 7829],
                  [7499, 7840],
                  [7514, 7858],
                  [7544, 7873],
                  [7541, 7882],
                  [7528, 7899],
                  [7538, 7919],
                  [7546, 7923],
                  [7559, 7922],
                  [7563, 7917],
                  [7594, 7911],
                  [7606, 7918],
                  [7620, 7934],
                  [7653, 7936],
                  [7669, 7946],
                  [7670, 7953],
                  [7681, 7968],
                  [7702, 7969],
                  [7705, 7978],
                  [7713, 7975],
                  [7729, 7983],
                  [7746, 7984],
                  [7772, 7978],
                  [7778, 7983],
                  [7772, 7999],
                  [7760, 8009],
                  [7754, 8018],
                  [7738, 8029],
                  [7728, 8032],
                  [7715, 8030],
                  [7713, 8029],
                  [7708, 8022],
                  [7702, 8018],
                  [7689, 8026],
                  [7671, 8026],
                  [7659, 8020],
                  [7649, 8035],
                  [7658, 8041],
                  [7658, 8051],
                  [7684, 8100],
                  [7695, 8094],
                  [7715, 8088],
                  [7741, 8105],
                  [7761, 8110],
                  [7762, 8120],
                  [7756, 8121],
                  [7766, 8135],
                  [7784, 8171],
                  [7798, 8181],
                  [7804, 8189],
                  [7800, 8198],
                  [7803, 8206],
                  [7794, 8209],
                  [7783, 8208],
                  [7782, 8214],
                  [7807, 8235],
                  [7817, 8235],
                  [7850, 8244],
                  [7866, 8243],
                  [7888, 8246],
                  [7906, 8239],
                  [7911, 8233],
                  [7932, 8232],
                  [7950, 8223],
                  [7974, 8190],
                  [7971, 8184],
                  [7978, 8168],
                  [7985, 8161],
                  [7985, 8148],
                  [7996, 8136],
                  [7997, 8119],
                  [8004, 8115],
                  [8002, 8100],
                  [8020, 8089],
                  [8040, 8090],
                  [8049, 8082],
                  [8061, 8084],
                  [8073, 8070],
                  [8083, 8063],
                  [8096, 8064],
                  [8091, 8055],
                  [8100, 8043],
                  [8096, 8033],
                  [8106, 8019],
                  [8150, 8020],
                  [8154, 8029],
                  [8167, 8035],
                  [8178, 8034],
                  [8185, 8040],
                  [8205, 8045],
                  [8214, 8041],
                  [8210, 8032],
                  [8216, 8020],
                  [8198, 8003],
                  [8191, 7966],
                  [8184, 7962],
                  [8177, 7941],
                  [8168, 7936],
                  [8167, 7924],
                  [8159, 7922],
                  [8156, 7929],
                  [8140, 7932],
                  [8134, 7928],
                  [8129, 7932],
                  [8118, 7919],
                  [8103, 7914],
                  [8107, 7908],
                  [8113, 7886],
                  [8110, 7867],
                  [8113, 7862],
                  [8108, 7845],
                  [8088, 7839],
                  [8091, 7831],
                  [8079, 7847],
                  [8071, 7847],
                  [8067, 7828],
                  [8056, 7828],
                  [8043, 7814],
                  [8018, 7812],
                  [8026, 7798],
                  [8021, 7791],
                  [7995, 7795],
                  [7985, 7806],
                  [7976, 7801],
                  [7973, 7793],
                  [7958, 7774],
                  [7951, 7774],
                  [7941, 7765],
                  [7925, 7760],
                  [7910, 7746],
                  [7903, 7737],
                  [7881, 7736],
                  [7854, 7723],
                  [7836, 7706],
                  [7815, 7699],
                  [7814, 7706],
                  [7831, 7711],
                  [7834, 7721],
                  [7823, 7721],
                  [7817, 7727],
                  [7827, 7732],
                  [7827, 7738],
                  [7836, 7743],
                  [7849, 7760],
                  [7836, 7772],
                  [7816, 7775],
                  [7797, 7757],
                  [7794, 7750],
                  [7768, 7739],
                  [7761, 7723],
                  [7752, 7715],
                  [7729, 7710],
                  [7724, 7716],
                  [7715, 7712],
                  [7709, 7695],
                  [7725, 7679],
                  [7738, 7676],
                  [7747, 7679],
                  [7759, 7663],
                  [7753, 7665],
                  [7751, 7650],
                  [7765, 7644],
                  [7775, 7645],
                  [7777, 7652],
                  [7790, 7663],
                  [7803, 7669],
                  [7822, 7661],
                  [7828, 7655],
                  [7844, 7659],
                  [7846, 7654],
                  [7860, 7654],
                  [7850, 7634],
                  [7841, 7640],
                  [7803, 7622],
                  [7802, 7611],
                  [7787, 7605],
                  [7778, 7594],
                  [7771, 7593],
                  [7758, 7575],
                  [7771, 7558],
                  [7789, 7551],
                  [7796, 7529],
                  [7808, 7508],
                  [7807, 7497],
                  [7822, 7487],
                  [7824, 7478],
                  [7835, 7473],
                  [7835, 7465],
                  [7819, 7470],
                  [7840, 7460],
                  [7836, 7457],
                  [7810, 7469],
                  [7832, 7451],
                  [7840, 7440],
                  [7823, 7435],
                  [7810, 7428],
                  [7803, 7418],
                  [7808, 7416],
                  [7822, 7421],
                  [7831, 7410],
                  [7843, 7415],
                  [7846, 7421],
                  [7850, 7408],
                  [7843, 7407],
                  [7828, 7393],
                  [7838, 7399],
                  [7838, 7380],
                  [7828, 7387],
                  [7830, 7373],
                  [7826, 7367],
                  [7830, 7357],
                  [7822, 7355],
                  [7815, 7346],
                  [7814, 7353],
                  [7799, 7333],
                  [7797, 7321],
                  [7788, 7313],
                  [7772, 7306],
                  [7778, 7293],
                  [7772, 7292],
                  [7769, 7273],
                  [7778, 7269],
                  [7774, 7265],
                  [7762, 7269],
                  [7751, 7261],
                  [7752, 7251],
                  [7744, 7247],
                  [7741, 7239],
                  [7735, 7241],
                  [7724, 7233],
                  [7726, 7229],
                  [7714, 7222],
                  [7710, 7213],
                  [7702, 7214],
                  [7692, 7209],
                  [7682, 7197],
                  [7678, 7188],
                  [7658, 7182],
                  [7636, 7184],
                  [7631, 7176],
                  [7628, 7184],
                  [7621, 7182],
                  [7620, 7173],
                  [7608, 7165],
                  [7602, 7172],
                  [7594, 7191],
                  [7591, 7190],
                  [7595, 7173],
                  [7591, 7165],
                  [7553, 7150],
                  [7546, 7153],
                  [7535, 7145],
                  [7508, 7139],
                  [7504, 7127],
                  [7493, 7131],
                  [7491, 7124],
                  [7503, 7113],
                  [7499, 7107],
                  [7484, 7106],
                  [7477, 7126],
                  [7479, 7143],
                  [7462, 7141],
                  [7461, 7147],
                  [7450, 7148],
                  [7441, 7155],
                  [7428, 7143],
                  [7423, 7148],
                  [7409, 7147],
                  [7388, 7159],
                  [7385, 7172],
                  [7391, 7182],
                  [7383, 7188],
                  [7365, 7187],
                  [7349, 7201],
                  [7336, 7195],
                  [7334, 7188],
                  [7320, 7180],
                  [7317, 7185],
                  [7310, 7175],
                  [7300, 7184],
                  [7296, 7177],
                  [7290, 7183],
                  [7280, 7173],
                  [7264, 7183],
                  [7255, 7171],
                  [7241, 7173],
                  [7237, 7166],
                  [7244, 7154],
                  [7243, 7133],
                  [7230, 7134],
                  [7227, 7146],
                  [7225, 7152],
                  [7213, 7144],
                  [7198, 7142],
                  [7191, 7151],
                  [7191, 7161],
                  [7167, 7164],
                  [7174, 7174],
                  [7172, 7182],
                  [7178, 7192],
                  [7159, 7196],
                  [7159, 7209],
                  [7151, 7223],
                  [7139, 7225],
                  [7123, 7217],
                  [7125, 7225],
                  [7120, 7244],
                  [7128, 7260],
                  [7137, 7264],
                  [7154, 7280],
                  [7150, 7287],
                  [7156, 7303],
                  [7154, 7333],
                  [7142, 7332],
                  [7137, 7351],
                  [7120, 7363],
                  [7114, 7353],
                  [7103, 7357],
                  [7092, 7369],
                  [7079, 7390],
                  [7067, 7389],
                  [7054, 7380],
                  [7039, 7383],
                  [7034, 7388],
                  [7026, 7379],
                  [7005, 7368],
                  [6999, 7368],
                  [6976, 7350],
                  [6975, 7344],
                  [6956, 7338],
                  [6946, 7339],
                  [6947, 7344],
                  [6936, 7349],
                  [6930, 7345],
                  [6912, 7349],
                  [6915, 7354],
                  [6905, 7358],
                  [6885, 7351],
                  [6870, 7334],
                  [6865, 7325],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "IR",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.58,
            "hc-middle-y": 0.51,
            "hc-key": "IRN",
            "hc-a2": "IR",
            name: "",
            labelrank: "2",
            "country-abbrev": "Iran",
            subregion: "Southern Asia",
            "region-wb": "Middle East & North Africa",
            "iso-a3": "IRN",
            "iso-a2": "IR",
            "woe-id": "23424851",
            continent: "Asia",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [5566, 7645],
                [5560, 7655],
                [5561, 7665],
                [5550, 7673],
                [5557, 7685],
                [5552, 7687],
                [5552, 7703],
                [5545, 7722],
                [5556, 7723],
                [5560, 7735],
                [5567, 7730],
                [5578, 7716],
                [5586, 7708],
                [5607, 7704],
                [5614, 7706],
                [5618, 7704],
                [5628, 7714],
                [5657, 7732],
                [5671, 7721],
                [5665, 7719],
                [5670, 7710],
                [5662, 7702],
                [5674, 7695],
                [5679, 7688],
                [5687, 7689],
                [5689, 7672],
                [5695, 7661],
                [5704, 7657],
                [5725, 7654],
                [5734, 7641],
                [5752, 7631],
                [5777, 7626],
                [5823, 7636],
                [5838, 7634],
                [5836, 7652],
                [5844, 7651],
                [5861, 7658],
                [5863, 7666],
                [5880, 7677],
                [5906, 7677],
                [5910, 7683],
                [5928, 7681],
                [5933, 7683],
                [5937, 7673],
                [5961, 7667],
                [5967, 7662],
                [5979, 7664],
                [5996, 7657],
                [5996, 7651],
                [6015, 7641],
                [6025, 7628],
                [6046, 7628],
                [6052, 7594],
                [6047, 7583],
                [6046, 7567],
                [6035, 7557],
                [6041, 7551],
                [6034, 7550],
                [6029, 7543],
                [6030, 7528],
                [6041, 7525],
                [6031, 7512],
                [6039, 7483],
                [6039, 7458],
                [6064, 7455],
                [6067, 7437],
                [6040, 7406],
                [6052, 7391],
                [6061, 7374],
                [6070, 7364],
                [6095, 7355],
                [6097, 7322],
                [6108, 7323],
                [6112, 7318],
                [6107, 7303],
                [6096, 7304],
                [6082, 7299],
                [6081, 7294],
                [6069, 7291],
                [6064, 7276],
                [6061, 7258],
                [6056, 7254],
                [6033, 7261],
                [6031, 7266],
                [6012, 7262],
                [5999, 7266],
                [5986, 7265],
                [5980, 7270],
                [5961, 7269],
                [5955, 7274],
                [5936, 7276],
                [5931, 7286],
                [5927, 7310],
                [5921, 7319],
                [5907, 7321],
                [5895, 7316],
                [5905, 7314],
                [5899, 7308],
                [5876, 7300],
                [5890, 7308],
                [5885, 7313],
                [5862, 7299],
                [5847, 7306],
                [5827, 7304],
                [5821, 7315],
                [5796, 7327],
                [5792, 7335],
                [5780, 7341],
                [5767, 7342],
                [5761, 7346],
                [5751, 7370],
                [5739, 7383],
                [5740, 7392],
                [5725, 7408],
                [5722, 7416],
                [5709, 7411],
                [5687, 7421],
                [5689, 7413],
                [5677, 7409],
                [5673, 7417],
                [5662, 7425],
                [5662, 7442],
                [5652, 7442],
                [5652, 7456],
                [5656, 7467],
                [5642, 7490],
                [5636, 7490],
                [5611, 7506],
                [5599, 7528],
                [5595, 7526],
                [5584, 7539],
                [5590, 7549],
                [5585, 7555],
                [5600, 7576],
                [5608, 7581],
                [5601, 7590],
                [5611, 7601],
                [5594, 7601],
                [5584, 7606],
                [5580, 7620],
                [5573, 7625],
                [5566, 7645],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "IQ",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.46,
            "hc-middle-y": 0.44,
            "hc-key": "IRQ",
            "hc-a2": "IQ",
            name: "",
            labelrank: "3",
            "country-abbrev": "Iraq",
            subregion: "Western Asia",
            "region-wb": "Middle East & North Africa",
            "iso-a3": "IRQ",
            "iso-a2": "IQ",
            "woe-id": "23424855",
            continent: "Asia",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [5677, 7409],
                [5668, 7411],
                [5660, 7410],
                [5643, 7413],
                [5635, 7409],
                [5628, 7392],
                [5618, 7381],
                [5613, 7380],
                [5564, 7385],
                [5510, 7426],
                [5487, 7445],
                [5438, 7472],
                [5401, 7479],
                [5403, 7486],
                [5398, 7491],
                [5390, 7520],
                [5446, 7551],
                [5455, 7554],
                [5461, 7566],
                [5461, 7579],
                [5466, 7595],
                [5462, 7608],
                [5468, 7624],
                [5480, 7627],
                [5495, 7644],
                [5506, 7652],
                [5517, 7653],
                [5528, 7649],
                [5550, 7649],
                [5553, 7640],
                [5566, 7645],
                [5573, 7625],
                [5580, 7620],
                [5584, 7606],
                [5594, 7601],
                [5611, 7601],
                [5601, 7590],
                [5608, 7581],
                [5600, 7576],
                [5585, 7555],
                [5590, 7549],
                [5584, 7539],
                [5595, 7526],
                [5599, 7528],
                [5611, 7506],
                [5636, 7490],
                [5642, 7490],
                [5656, 7467],
                [5652, 7456],
                [5652, 7442],
                [5662, 7442],
                [5662, 7425],
                [5673, 7417],
                [5677, 7409],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "MV",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.57,
            "hc-middle-y": 0.53,
            "hc-key": "mv",
            "hc-a2": "MV",
            name: "",
            labelrank: "5",
            "country-abbrev": "Mald.",
            subregion: "Southern Asia",
            "region-wb": "South Asia",
            "iso-a3": "MDV",
            "iso-a2": "MV",
            "woe-id": "23424899",
            continent: "Seven seas (open ocean)",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [6404, 6668],
                [6411, 6657],
                [6402, 6657],
                [6406, 6662],
                [6404, 6668],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "ID",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.38,
            "hc-middle-y": 0.4,
            "hc-key": "IDN",
            "hc-a2": "ID",
            name: t("Countries.id", { ns: region }),
            labelrank: "2",
            "country-abbrev": "Indo.",
            subregion: "South-Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "IDN",
            "iso-a2": "ID",
            "woe-id": "23424846",
            continent: "Asia",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [7782, 6231],
                  [7789, 6222],
                  [7795, 6222],
                  [7806, 6209],
                  [7795, 6203],
                  [7781, 6212],
                  [7750, 6224],
                  [7757, 6230],
                  [7782, 6231],
                ],
              ],
              [
                [
                  [7685, 6259],
                  [7680, 6244],
                  [7664, 6244],
                  [7664, 6258],
                  [7675, 6265],
                  [7685, 6259],
                ],
              ],
              [
                [
                  [7908, 6261],
                  [7907, 6265],
                  [7931, 6266],
                  [7932, 6260],
                  [7911, 6257],
                  [7908, 6261],
                ],
              ],
              [
                [
                  [7650, 6251],
                  [7640, 6249],
                  [7632, 6257],
                  [7623, 6259],
                  [7618, 6268],
                  [7630, 6265],
                  [7640, 6269],
                  [7655, 6260],
                  [7650, 6251],
                ],
              ],
              [
                [
                  [7979, 6280],
                  [7972, 6272],
                  [7960, 6274],
                  [7952, 6270],
                  [7956, 6280],
                  [7979, 6280],
                ],
              ],
              [
                [
                  [8105, 6286],
                  [8116, 6287],
                  [8121, 6295],
                  [8124, 6283],
                  [8110, 6266],
                  [8102, 6263],
                  [8110, 6276],
                  [8105, 6286],
                ],
              ],
              [
                [
                  [7613, 6298],
                  [7607, 6301],
                  [7591, 6293],
                  [7567, 6295],
                  [7571, 6303],
                  [7602, 6304],
                  [7613, 6298],
                ],
              ],
              [
                [
                  [7863, 6360],
                  [7856, 6346],
                  [7848, 6348],
                  [7852, 6367],
                  [7862, 6369],
                  [7863, 6360],
                ],
              ],
              [
                [
                  [7876, 6368],
                  [7871, 6366],
                  [7868, 6354],
                  [7876, 6350],
                  [7866, 6345],
                  [7865, 6339],
                  [7857, 6344],
                  [7862, 6351],
                  [7867, 6374],
                  [7876, 6368],
                ],
              ],
              [
                [
                  [7993, 6394],
                  [7991, 6398],
                  [7980, 6392],
                  [7963, 6400],
                  [7958, 6410],
                  [7970, 6415],
                  [7983, 6415],
                  [7995, 6406],
                  [7993, 6394],
                ],
              ],
              [
                [
                  [7413, 6421],
                  [7418, 6430],
                  [7430, 6429],
                  [7436, 6425],
                  [7434, 6413],
                  [7424, 6416],
                  [7417, 6410],
                  [7413, 6421],
                ],
              ],
              [
                [
                  [7941, 6453],
                  [7968, 6452],
                  [7957, 6450],
                  [7957, 6435],
                  [7954, 6444],
                  [7938, 6451],
                  [7910, 6447],
                  [7910, 6456],
                  [7918, 6457],
                  [7941, 6453],
                ],
              ],
              [
                [
                  [7399, 6421],
                  [7384, 6415],
                  [7369, 6423],
                  [7363, 6442],
                  [7349, 6443],
                  [7344, 6449],
                  [7357, 6461],
                  [7370, 6459],
                  [7380, 6433],
                  [7394, 6430],
                  [7387, 6419],
                  [7399, 6421],
                ],
              ],
              [
                [
                  [8006, 6468],
                  [8021, 6459],
                  [8018, 6455],
                  [7999, 6457],
                  [8006, 6468],
                ],
              ],
              [
                [
                  [7885, 6462],
                  [7887, 6455],
                  [7873, 6460],
                  [7874, 6467],
                  [7866, 6459],
                  [7867, 6471],
                  [7882, 6470],
                  [7885, 6462],
                ],
              ],
              [
                [
                  [7180, 6446],
                  [7206, 6417],
                  [7204, 6413],
                  [7193, 6422],
                  [7192, 6432],
                  [7181, 6439],
                  [7160, 6456],
                  [7151, 6470],
                  [7153, 6477],
                  [7161, 6478],
                  [7171, 6453],
                  [7180, 6446],
                ],
              ],
              [
                [
                  [8235, 6486],
                  [8248, 6485],
                  [8258, 6474],
                  [8250, 6470],
                  [8245, 6481],
                  [8235, 6486],
                ],
              ],
              [
                [
                  [7997, 6495],
                  [8008, 6492],
                  [8009, 6479],
                  [7995, 6492],
                  [7992, 6483],
                  [7991, 6497],
                  [7997, 6495],
                ],
              ],
              [
                [
                  [8093, 6493],
                  [8084, 6502],
                  [8100, 6505],
                  [8114, 6501],
                  [8112, 6494],
                  [8093, 6493],
                ],
              ],
              [
                [
                  [7115, 6550],
                  [7132, 6534],
                  [7130, 6524],
                  [7125, 6522],
                  [7106, 6547],
                  [7115, 6550],
                ],
              ],
              [
                [
                  [8212, 6315],
                  [8203, 6304],
                  [8195, 6307],
                  [8198, 6324],
                  [8212, 6315],
                ],
              ],
              [
                [
                  [8203, 6324],
                  [8202, 6332],
                  [8208, 6346],
                  [8216, 6339],
                  [8212, 6331],
                  [8214, 6320],
                  [8203, 6324],
                ],
              ],
              [
                [
                  [7294, 6534],
                  [7296, 6527],
                  [7328, 6541],
                  [7317, 6526],
                  [7314, 6533],
                  [7295, 6524],
                  [7294, 6534],
                ],
              ],
              [
                [
                  [7709, 6260],
                  [7708, 6266],
                  [7726, 6267],
                  [7731, 6260],
                  [7752, 6262],
                  [7753, 6252],
                  [7736, 6245],
                  [7734, 6251],
                  [7727, 6245],
                  [7693, 6238],
                  [7686, 6241],
                  [7688, 6256],
                  [7699, 6260],
                  [7709, 6260],
                ],
              ],
              [
                [
                  [8010, 6410],
                  [8005, 6410],
                  [8016, 6420],
                  [8048, 6423],
                  [8050, 6419],
                  [8059, 6424],
                  [8093, 6414],
                  [8101, 6401],
                  [8101, 6392],
                  [8062, 6409],
                  [8061, 6404],
                  [8045, 6407],
                  [8043, 6411],
                  [8037, 6401],
                  [8022, 6396],
                  [8018, 6400],
                  [8031, 6404],
                  [8021, 6415],
                  [8015, 6401],
                  [8010, 6410],
                ],
              ],
              [
                [
                  [7912, 6236],
                  [7916, 6236],
                  [7926, 6242],
                  [7928, 6236],
                  [7930, 6227],
                  [7911, 6207],
                  [7894, 6201],
                  [7883, 6201],
                  [7882, 6192],
                  [7865, 6184],
                  [7881, 6199],
                  [7879, 6204],
                  [7892, 6209],
                  [7887, 6211],
                  [7890, 6223],
                  [7900, 6231],
                  [7907, 6226],
                  [7912, 6236],
                ],
              ],
              [
                [
                  [7720, 6627],
                  [7713, 6622],
                  [7714, 6627],
                  [7715, 6627],
                  [7720, 6627],
                ],
              ],
              [
                [
                  [8399, 6429],
                  [8399, 6320],
                  [8395, 6309],
                  [8399, 6303],
                  [8399, 6238],
                  [8368, 6268],
                  [8351, 6265],
                  [8347, 6269],
                  [8338, 6262],
                  [8336, 6267],
                  [8337, 6269],
                  [8332, 6265],
                  [8338, 6259],
                  [8301, 6258],
                  [8312, 6282],
                  [8318, 6287],
                  [8335, 6289],
                  [8343, 6283],
                  [8340, 6277],
                  [8343, 6284],
                  [8332, 6294],
                  [8332, 6311],
                  [8325, 6318],
                  [8319, 6333],
                  [8313, 6337],
                  [8313, 6347],
                  [8288, 6358],
                  [8277, 6361],
                  [8252, 6373],
                  [8230, 6375],
                  [8203, 6392],
                  [8203, 6388],
                  [8185, 6400],
                  [8184, 6414],
                  [8181, 6401],
                  [8171, 6386],
                  [8163, 6385],
                  [8156, 6397],
                  [8162, 6401],
                  [8144, 6419],
                  [8134, 6420],
                  [8141, 6427],
                  [8156, 6423],
                  [8165, 6433],
                  [8188, 6428],
                  [8193, 6435],
                  [8187, 6439],
                  [8173, 6441],
                  [8155, 6438],
                  [8137, 6444],
                  [8129, 6461],
                  [8111, 6461],
                  [8098, 6469],
                  [8094, 6479],
                  [8107, 6477],
                  [8106, 6468],
                  [8113, 6474],
                  [8112, 6481],
                  [8131, 6485],
                  [8138, 6491],
                  [8156, 6495],
                  [8176, 6484],
                  [8193, 6484],
                  [8202, 6466],
                  [8196, 6456],
                  [8198, 6438],
                  [8207, 6421],
                  [8211, 6434],
                  [8214, 6419],
                  [8223, 6408],
                  [8237, 6407],
                  [8260, 6430],
                  [8264, 6440],
                  [8260, 6449],
                  [8226, 6461],
                  [8217, 6475],
                  [8219, 6478],
                  [8226, 6462],
                  [8236, 6458],
                  [8286, 6453],
                  [8305, 6462],
                  [8331, 6453],
                  [8335, 6449],
                  [8366, 6436],
                  [8375, 6437],
                  [8399, 6429],
                ],
              ],
              [
                [
                  [7364, 6398],
                  [7368, 6393],
                  [7364, 6381],
                  [7366, 6374],
                  [7363, 6335],
                  [7357, 6335],
                  [7349, 6345],
                  [7343, 6336],
                  [7329, 6344],
                  [7331, 6332],
                  [7319, 6340],
                  [7301, 6360],
                  [7278, 6374],
                  [7261, 6388],
                  [7258, 6399],
                  [7241, 6410],
                  [7232, 6425],
                  [7225, 6429],
                  [7219, 6446],
                  [7204, 6468],
                  [7201, 6481],
                  [7187, 6497],
                  [7185, 6504],
                  [7172, 6512],
                  [7146, 6505],
                  [7152, 6510],
                  [7167, 6513],
                  [7166, 6523],
                  [7149, 6562],
                  [7132, 6572],
                  [7126, 6572],
                  [7114, 6565],
                  [7124, 6576],
                  [7122, 6589],
                  [7097, 6615],
                  [7087, 6617],
                  [7058, 6646],
                  [7051, 6660],
                  [7051, 6668],
                  [7058, 6671],
                  [7071, 6667],
                  [7078, 6660],
                  [7103, 6660],
                  [7112, 6656],
                  [7119, 6659],
                  [7131, 6648],
                  [7133, 6638],
                  [7142, 6635],
                  [7143, 6625],
                  [7185, 6598],
                  [7192, 6591],
                  [7191, 6584],
                  [7198, 6584],
                  [7209, 6568],
                  [7218, 6564],
                  [7216, 6571],
                  [7223, 6572],
                  [7231, 6565],
                  [7241, 6567],
                  [7245, 6562],
                  [7239, 6554],
                  [7255, 6546],
                  [7252, 6552],
                  [7266, 6549],
                  [7266, 6534],
                  [7275, 6539],
                  [7282, 6536],
                  [7283, 6528],
                  [7277, 6526],
                  [7283, 6519],
                  [7287, 6526],
                  [7303, 6512],
                  [7294, 6495],
                  [7318, 6491],
                  [7328, 6508],
                  [7333, 6500],
                  [7324, 6496],
                  [7328, 6492],
                  [7321, 6486],
                  [7326, 6451],
                  [7336, 6438],
                  [7358, 6435],
                  [7363, 6421],
                  [7370, 6418],
                  [7371, 6410],
                  [7364, 6398],
                ],
              ],
              [
                [
                  [7868, 6265],
                  [7881, 6261],
                  [7893, 6265],
                  [7886, 6254],
                  [7874, 6257],
                  [7852, 6249],
                  [7834, 6245],
                  [7822, 6247],
                  [7808, 6243],
                  [7799, 6247],
                  [7779, 6245],
                  [7763, 6249],
                  [7764, 6258],
                  [7772, 6251],
                  [7788, 6262],
                  [7810, 6261],
                  [7826, 6253],
                  [7840, 6258],
                  [7849, 6252],
                  [7868, 6265],
                ],
              ],
              [
                [
                  [7568, 6285],
                  [7584, 6277],
                  [7605, 6282],
                  [7618, 6276],
                  [7615, 6259],
                  [7622, 6248],
                  [7614, 6253],
                  [7604, 6252],
                  [7581, 6263],
                  [7566, 6258],
                  [7540, 6263],
                  [7536, 6260],
                  [7501, 6267],
                  [7488, 6274],
                  [7468, 6279],
                  [7457, 6277],
                  [7454, 6282],
                  [7438, 6276],
                  [7419, 6281],
                  [7411, 6286],
                  [7384, 6288],
                  [7380, 6293],
                  [7385, 6301],
                  [7368, 6305],
                  [7354, 6304],
                  [7347, 6307],
                  [7353, 6306],
                  [7364, 6317],
                  [7371, 6333],
                  [7384, 6328],
                  [7398, 6327],
                  [7400, 6332],
                  [7412, 6325],
                  [7431, 6320],
                  [7439, 6322],
                  [7446, 6307],
                  [7468, 6304],
                  [7501, 6302],
                  [7507, 6315],
                  [7514, 6318],
                  [7521, 6309],
                  [7531, 6311],
                  [7548, 6303],
                  [7564, 6303],
                  [7568, 6285],
                ],
              ],
              [
                [
                  [7865, 6375],
                  [7843, 6373],
                  [7839, 6345],
                  [7835, 6351],
                  [7835, 6364],
                  [7825, 6369],
                  [7829, 6386],
                  [7821, 6389],
                  [7808, 6402],
                  [7813, 6412],
                  [7813, 6424],
                  [7804, 6429],
                  [7787, 6419],
                  [7793, 6411],
                  [7794, 6396],
                  [7792, 6390],
                  [7794, 6370],
                  [7789, 6354],
                  [7798, 6330],
                  [7796, 6316],
                  [7795, 6334],
                  [7791, 6344],
                  [7769, 6340],
                  [7762, 6348],
                  [7770, 6379],
                  [7761, 6405],
                  [7750, 6401],
                  [7745, 6421],
                  [7756, 6434],
                  [7762, 6448],
                  [7762, 6470],
                  [7773, 6487],
                  [7775, 6512],
                  [7783, 6527],
                  [7798, 6528],
                  [7808, 6545],
                  [7825, 6538],
                  [7854, 6535],
                  [7865, 6529],
                  [7869, 6533],
                  [7894, 6530],
                  [7917, 6540],
                  [7915, 6545],
                  [7933, 6556],
                  [7933, 6547],
                  [7926, 6534],
                  [7909, 6517],
                  [7877, 6515],
                  [7872, 6520],
                  [7834, 6518],
                  [7831, 6520],
                  [7808, 6518],
                  [7792, 6519],
                  [7785, 6510],
                  [7781, 6499],
                  [7784, 6486],
                  [7793, 6479],
                  [7801, 6464],
                  [7813, 6464],
                  [7825, 6480],
                  [7831, 6491],
                  [7843, 6497],
                  [7846, 6483],
                  [7868, 6484],
                  [7862, 6486],
                  [7877, 6488],
                  [7883, 6483],
                  [7879, 6474],
                  [7864, 6478],
                  [7851, 6462],
                  [7834, 6455],
                  [7831, 6449],
                  [7820, 6453],
                  [7828, 6442],
                  [7835, 6438],
                  [7841, 6426],
                  [7849, 6420],
                  [7848, 6398],
                  [7860, 6391],
                  [7860, 6385],
                  [7876, 6388],
                  [7875, 6382],
                  [7867, 6382],
                  [7865, 6375],
                ],
              ],
              [
                [
                  [8012, 6494],
                  [7999, 6506],
                  [7999, 6516],
                  [8004, 6518],
                  [7999, 6541],
                  [8005, 6556],
                  [8014, 6569],
                  [8021, 6572],
                  [8034, 6582],
                  [8037, 6578],
                  [8031, 6565],
                  [8025, 6565],
                  [8017, 6555],
                  [8014, 6539],
                  [8006, 6534],
                  [8011, 6529],
                  [8030, 6550],
                  [8038, 6551],
                  [8037, 6536],
                  [8026, 6532],
                  [8026, 6525],
                  [8037, 6521],
                  [8042, 6512],
                  [8016, 6519],
                  [8014, 6505],
                  [8018, 6493],
                  [8030, 6479],
                  [8018, 6484],
                  [8012, 6494],
                ],
              ],
              [
                [
                  [7710, 6627],
                  [7705, 6625],
                  [7717, 6618],
                  [7715, 6612],
                  [7696, 6612],
                  [7713, 6605],
                  [7703, 6600],
                  [7711, 6595],
                  [7725, 6571],
                  [7718, 6560],
                  [7744, 6542],
                  [7752, 6533],
                  [7746, 6529],
                  [7724, 6532],
                  [7717, 6529],
                  [7707, 6508],
                  [7706, 6490],
                  [7711, 6493],
                  [7711, 6482],
                  [7701, 6482],
                  [7694, 6470],
                  [7679, 6462],
                  [7675, 6454],
                  [7677, 6446],
                  [7672, 6442],
                  [7681, 6440],
                  [7671, 6417],
                  [7673, 6391],
                  [7666, 6386],
                  [7664, 6398],
                  [7623, 6383],
                  [7623, 6397],
                  [7619, 6403],
                  [7606, 6407],
                  [7594, 6404],
                  [7593, 6412],
                  [7586, 6409],
                  [7576, 6420],
                  [7576, 6413],
                  [7564, 6405],
                  [7555, 6408],
                  [7541, 6401],
                  [7538, 6423],
                  [7534, 6417],
                  [7525, 6419],
                  [7506, 6415],
                  [7502, 6421],
                  [7495, 6417],
                  [7488, 6457],
                  [7488, 6468],
                  [7482, 6473],
                  [7472, 6467],
                  [7459, 6498],
                  [7466, 6505],
                  [7455, 6515],
                  [7453, 6530],
                  [7460, 6551],
                  [7467, 6562],
                  [7476, 6566],
                  [7473, 6560],
                  [7482, 6546],
                  [7495, 6534],
                  [7503, 6530],
                  [7522, 6537],
                  [7541, 6535],
                  [7549, 6539],
                  [7551, 6548],
                  [7560, 6551],
                  [7576, 6550],
                  [7594, 6541],
                  [7602, 6547],
                  [7619, 6547],
                  [7629, 6561],
                  [7628, 6571],
                  [7640, 6579],
                  [7636, 6588],
                  [7648, 6594],
                  [7652, 6606],
                  [7650, 6619],
                  [7659, 6634],
                  [7675, 6631],
                  [7699, 6633],
                  [7710, 6627],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "AU",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.55,
            "hc-middle-y": 0.43,
            "hc-key": "AUS",
            "hc-a2": "AU",
            name: t("Countries.au", { ns: region }),
            labelrank: "2",
            "country-abbrev": "Auz.",
            subregion: "Australia and New Zealand",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "AUS",
            "iso-a2": "AU",
            "woe-id": "-90",
            continent: "Oceania",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [8615, 5257],
                  [8620, 5253],
                  [8606, 5253],
                  [8609, 5258],
                  [8599, 5272],
                  [8604, 5278],
                  [8615, 5269],
                  [8615, 5257],
                ],
              ],
              [
                [
                  [8300, 5418],
                  [8299, 5413],
                  [8313, 5412],
                  [8295, 5401],
                  [8288, 5404],
                  [8273, 5402],
                  [8270, 5411],
                  [8300, 5418],
                ],
              ],
              [
                [
                  [8276, 6099],
                  [8273, 6091],
                  [8279, 6084],
                  [8265, 6087],
                  [8265, 6099],
                  [8274, 6104],
                  [8276, 6099],
                ],
              ],
              [
                [
                  [8094, 6158],
                  [8077, 6158],
                  [8087, 6175],
                  [8097, 6171],
                  [8112, 6176],
                  [8121, 6168],
                  [8105, 6155],
                  [8094, 6158],
                ],
              ],
              [
                [
                  [8563, 5143],
                  [8548, 5143],
                  [8525, 5176],
                  [8523, 5191],
                  [8530, 5185],
                  [8523, 5199],
                  [8515, 5208],
                  [8506, 5233],
                  [8509, 5251],
                  [8514, 5254],
                  [8509, 5245],
                  [8521, 5239],
                  [8559, 5227],
                  [8577, 5234],
                  [8589, 5232],
                  [8605, 5242],
                  [8615, 5233],
                  [8613, 5205],
                  [8615, 5193],
                  [8608, 5194],
                  [8604, 5175],
                  [8605, 5154],
                  [8600, 5154],
                  [8593, 5163],
                  [8584, 5157],
                  [8586, 5144],
                  [8579, 5152],
                  [8572, 5139],
                  [8563, 5143],
                ],
              ],
              [
                [
                  [8543, 6002],
                  [8551, 5984],
                  [8547, 5968],
                  [8557, 5961],
                  [8555, 5946],
                  [8560, 5941],
                  [8580, 5930],
                  [8589, 5932],
                  [8596, 5918],
                  [8622, 5911],
                  [8631, 5902],
                  [8625, 5895],
                  [8642, 5879],
                  [8653, 5844],
                  [8666, 5831],
                  [8662, 5842],
                  [8666, 5847],
                  [8671, 5839],
                  [8683, 5832],
                  [8679, 5844],
                  [8689, 5830],
                  [8687, 5815],
                  [8692, 5804],
                  [8700, 5804],
                  [8707, 5789],
                  [8717, 5789],
                  [8728, 5770],
                  [8735, 5766],
                  [8743, 5751],
                  [8750, 5749],
                  [8760, 5760],
                  [8764, 5758],
                  [8755, 5733],
                  [8759, 5729],
                  [8755, 5718],
                  [8759, 5694],
                  [8766, 5695],
                  [8769, 5683],
                  [8766, 5662],
                  [8770, 5655],
                  [8771, 5636],
                  [8763, 5622],
                  [8762, 5610],
                  [8753, 5577],
                  [8755, 5571],
                  [8751, 5552],
                  [8739, 5530],
                  [8739, 5521],
                  [8727, 5510],
                  [8719, 5507],
                  [8704, 5483],
                  [8702, 5472],
                  [8692, 5459],
                  [8687, 5431],
                  [8681, 5430],
                  [8669, 5407],
                  [8669, 5393],
                  [8662, 5372],
                  [8666, 5361],
                  [8664, 5353],
                  [8649, 5343],
                  [8615, 5342],
                  [8594, 5333],
                  [8573, 5314],
                  [8552, 5310],
                  [8561, 5310],
                  [8559, 5297],
                  [8550, 5308],
                  [8545, 5305],
                  [8541, 5314],
                  [8521, 5318],
                  [8531, 5328],
                  [8526, 5328],
                  [8516, 5319],
                  [8512, 5323],
                  [8521, 5331],
                  [8517, 5340],
                  [8503, 5333],
                  [8500, 5326],
                  [8474, 5307],
                  [8441, 5324],
                  [8422, 5327],
                  [8419, 5323],
                  [8398, 5334],
                  [8391, 5334],
                  [8381, 5340],
                  [8377, 5348],
                  [8363, 5364],
                  [8361, 5372],
                  [8366, 5383],
                  [8357, 5401],
                  [8348, 5414],
                  [8349, 5426],
                  [8341, 5419],
                  [8317, 5415],
                  [8315, 5419],
                  [8324, 5425],
                  [8327, 5446],
                  [8314, 5466],
                  [8302, 5431],
                  [8294, 5433],
                  [8277, 5429],
                  [8283, 5440],
                  [8295, 5440],
                  [8295, 5465],
                  [8309, 5486],
                  [8306, 5494],
                  [8312, 5498],
                  [8306, 5517],
                  [8305, 5503],
                  [8295, 5498],
                  [8288, 5482],
                  [8270, 5473],
                  [8251, 5452],
                  [8253, 5438],
                  [8241, 5441],
                  [8235, 5449],
                  [8229, 5474],
                  [8218, 5482],
                  [8213, 5496],
                  [8202, 5498],
                  [8196, 5512],
                  [8202, 5514],
                  [8183, 5532],
                  [8168, 5529],
                  [8158, 5537],
                  [8142, 5535],
                  [8121, 5548],
                  [8110, 5553],
                  [8100, 5549],
                  [8080, 5549],
                  [8046, 5546],
                  [8017, 5533],
                  [7996, 5527],
                  [7978, 5525],
                  [7963, 5528],
                  [7920, 5506],
                  [7903, 5499],
                  [7898, 5484],
                  [7885, 5472],
                  [7872, 5474],
                  [7849, 5473],
                  [7826, 5476],
                  [7781, 5473],
                  [7769, 5465],
                  [7760, 5453],
                  [7747, 5455],
                  [7734, 5440],
                  [7713, 5436],
                  [7682, 5435],
                  [7663, 5442],
                  [7652, 5455],
                  [7638, 5458],
                  [7633, 5467],
                  [7634, 5486],
                  [7642, 5482],
                  [7654, 5494],
                  [7652, 5514],
                  [7656, 5525],
                  [7649, 5536],
                  [7656, 5534],
                  [7654, 5547],
                  [7639, 5574],
                  [7633, 5593],
                  [7633, 5617],
                  [7620, 5647],
                  [7610, 5661],
                  [7605, 5686],
                  [7593, 5706],
                  [7584, 5715],
                  [7573, 5739],
                  [7575, 5743],
                  [7581, 5726],
                  [7584, 5727],
                  [7592, 5709],
                  [7599, 5708],
                  [7601, 5716],
                  [7595, 5720],
                  [7588, 5736],
                  [7591, 5739],
                  [7602, 5728],
                  [7608, 5713],
                  [7612, 5732],
                  [7596, 5754],
                  [7588, 5773],
                  [7587, 5788],
                  [7597, 5805],
                  [7599, 5819],
                  [7594, 5833],
                  [7605, 5855],
                  [7610, 5835],
                  [7615, 5836],
                  [7624, 5856],
                  [7647, 5866],
                  [7652, 5871],
                  [7646, 5891],
                  [7662, 5880],
                  [7688, 5896],
                  [7703, 5890],
                  [7715, 5892],
                  [7726, 5901],
                  [7747, 5904],
                  [7758, 5913],
                  [7769, 5910],
                  [7788, 5915],
                  [7809, 5923],
                  [7826, 5941],
                  [7835, 5959],
                  [7850, 5968],
                  [7845, 5974],
                  [7845, 5995],
                  [7857, 6009],
                  [7868, 6016],
                  [7886, 5987],
                  [7887, 6004],
                  [7895, 5997],
                  [7890, 6011],
                  [7885, 6014],
                  [7891, 6025],
                  [7906, 6021],
                  [7911, 6023],
                  [7912, 6054],
                  [7926, 6053],
                  [7929, 6064],
                  [7938, 6059],
                  [7941, 6063],
                  [7933, 6070],
                  [7936, 6075],
                  [7952, 6080],
                  [7959, 6078],
                  [7962, 6090],
                  [7971, 6094],
                  [7976, 6086],
                  [7980, 6099],
                  [7986, 6101],
                  [7991, 6094],
                  [7998, 6096],
                  [8022, 6072],
                  [8019, 6059],
                  [8033, 6071],
                  [8048, 6067],
                  [8070, 6067],
                  [8057, 6081],
                  [8067, 6093],
                  [8073, 6110],
                  [8083, 6114],
                  [8080, 6125],
                  [8094, 6140],
                  [8107, 6142],
                  [8105, 6147],
                  [8120, 6144],
                  [8136, 6143],
                  [8155, 6148],
                  [8153, 6163],
                  [8146, 6169],
                  [8137, 6167],
                  [8128, 6173],
                  [8134, 6178],
                  [8141, 6170],
                  [8140, 6178],
                  [8152, 6181],
                  [8154, 6167],
                  [8160, 6172],
                  [8170, 6161],
                  [8188, 6161],
                  [8206, 6151],
                  [8216, 6154],
                  [8225, 6145],
                  [8249, 6157],
                  [8253, 6139],
                  [8263, 6145],
                  [8256, 6151],
                  [8266, 6154],
                  [8273, 6144],
                  [8280, 6142],
                  [8267, 6127],
                  [8271, 6124],
                  [8249, 6113],
                  [8249, 6101],
                  [8260, 6098],
                  [8250, 6094],
                  [8234, 6072],
                  [8237, 6065],
                  [8259, 6050],
                  [8268, 6042],
                  [8284, 6044],
                  [8282, 6037],
                  [8304, 6026],
                  [8317, 6012],
                  [8342, 6006],
                  [8349, 6019],
                  [8359, 6021],
                  [8350, 6011],
                  [8345, 6000],
                  [8349, 5993],
                  [8370, 5982],
                  [8385, 5984],
                  [8395, 5990],
                  [8405, 6012],
                  [8412, 6031],
                  [8411, 6035],
                  [8419, 6063],
                  [8415, 6079],
                  [8415, 6106],
                  [8420, 6116],
                  [8417, 6123],
                  [8424, 6133],
                  [8417, 6137],
                  [8423, 6151],
                  [8427, 6149],
                  [8433, 6172],
                  [8433, 6192],
                  [8438, 6204],
                  [8439, 6194],
                  [8447, 6190],
                  [8455, 6171],
                  [8455, 6157],
                  [8465, 6153],
                  [8461, 6143],
                  [8471, 6134],
                  [8476, 6107],
                  [8474, 6100],
                  [8482, 6081],
                  [8486, 6078],
                  [8502, 6088],
                  [8508, 6076],
                  [8528, 6065],
                  [8525, 6047],
                  [8531, 6031],
                  [8529, 6020],
                  [8543, 6002],
                ],
              ],
            ],
          },
        },

        {
          type: "Feature",
          id: "PH",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.43,
            "hc-middle-y": 0.15,
            "hc-key": "PHL",
            "hc-a2": "PH",
            name: t("Countries.ph", { ns: region }),
            labelrank: "2",
            "country-abbrev": "Phil.",
            subregion: "South-Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "PHL",
            "iso-a2": "PH",
            "woe-id": "23424934",
            continent: "Asia",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [7915, 6801],
                  [7914, 6792],
                  [7908, 6787],
                  [7896, 6788],
                  [7893, 6793],
                  [7905, 6803],
                  [7915, 6801],
                ],
              ],
              [
                [
                  [7884, 6775],
                  [7888, 6772],
                  [7871, 6770],
                  [7866, 6779],
                  [7858, 6782],
                  [7852, 6794],
                  [7866, 6802],
                  [7864, 6814],
                  [7870, 6826],
                  [7876, 6828],
                  [7887, 6823],
                  [7874, 6795],
                  [7874, 6787],
                  [7884, 6775],
                ],
              ],
              [
                [
                  [7894, 6833],
                  [7901, 6836],
                  [7900, 6813],
                  [7889, 6800],
                  [7884, 6786],
                  [7879, 6784],
                  [7882, 6800],
                  [7897, 6827],
                  [7894, 6833],
                ],
              ],
              [
                [
                  [7838, 6867],
                  [7844, 6878],
                  [7859, 6872],
                  [7859, 6866],
                  [7844, 6874],
                  [7839, 6856],
                  [7858, 6844],
                  [7862, 6846],
                  [7875, 6842],
                  [7874, 6834],
                  [7863, 6827],
                  [7859, 6812],
                  [7858, 6819],
                  [7847, 6818],
                  [7839, 6811],
                  [7843, 6848],
                  [7836, 6851],
                  [7838, 6867],
                ],
              ],
              [
                [
                  [7887, 6876],
                  [7891, 6876],
                  [7893, 6863],
                  [7900, 6857],
                  [7901, 6850],
                  [7882, 6864],
                  [7875, 6856],
                  [7878, 6870],
                  [7887, 6876],
                ],
              ],
              [
                [
                  [7789, 6908],
                  [7793, 6903],
                  [7817, 6901],
                  [7827, 6890],
                  [7827, 6877],
                  [7818, 6864],
                  [7805, 6879],
                  [7804, 6888],
                  [7789, 6908],
                ],
              ],
              [
                [
                  [7909, 6848],
                  [7915, 6848],
                  [7918, 6837],
                  [7930, 6850],
                  [7925, 6851],
                  [7911, 6864],
                  [7907, 6874],
                  [7933, 6875],
                  [7943, 6865],
                  [7942, 6857],
                  [7945, 6836],
                  [7936, 6831],
                  [7930, 6836],
                  [7929, 6822],
                  [7934, 6816],
                  [7938, 6797],
                  [7929, 6810],
                  [7929, 6799],
                  [7922, 6803],
                  [7922, 6823],
                  [7911, 6826],
                  [7909, 6848],
                ],
              ],
              [
                [
                  [7931, 6677],
                  [7906, 6686],
                  [7901, 6694],
                  [7900, 6714],
                  [7906, 6722],
                  [7890, 6734],
                  [7875, 6725],
                  [7873, 6732],
                  [7864, 6719],
                  [7864, 6732],
                  [7855, 6731],
                  [7842, 6703],
                  [7850, 6699],
                  [7839, 6693],
                  [7835, 6699],
                  [7842, 6719],
                  [7844, 6734],
                  [7849, 6740],
                  [7867, 6744],
                  [7872, 6755],
                  [7892, 6758],
                  [7895, 6744],
                  [7906, 6746],
                  [7911, 6758],
                  [7921, 6754],
                  [7922, 6771],
                  [7932, 6764],
                  [7935, 6772],
                  [7944, 6770],
                  [7940, 6789],
                  [7943, 6802],
                  [7948, 6812],
                  [7950, 6795],
                  [7947, 6788],
                  [7956, 6791],
                  [7960, 6800],
                  [7963, 6792],
                  [7956, 6784],
                  [7967, 6762],
                  [7972, 6746],
                  [7970, 6735],
                  [7975, 6731],
                  [7976, 6718],
                  [7965, 6703],
                  [7964, 6690],
                  [7960, 6706],
                  [7952, 6721],
                  [7952, 6714],
                  [7944, 6711],
                  [7940, 6698],
                  [7945, 6696],
                  [7948, 6679],
                  [7940, 6668],
                  [7931, 6677],
                ],
              ],
              [
                [
                  [7723, 6776],
                  [7738, 6792],
                  [7747, 6804],
                  [7760, 6814],
                  [7758, 6826],
                  [7767, 6841],
                  [7775, 6840],
                  [7781, 6851],
                  [7778, 6867],
                  [7792, 6860],
                  [7785, 6859],
                  [7783, 6850],
                  [7767, 6827],
                  [7773, 6814],
                  [7762, 6808],
                  [7758, 6800],
                  [7745, 6795],
                  [7737, 6778],
                  [7726, 6773],
                  [7723, 6766],
                  [7710, 6759],
                  [7700, 6750],
                  [7703, 6745],
                  [7693, 6734],
                  [7702, 6759],
                  [7712, 6771],
                  [7723, 6776],
                ],
              ],
              [
                [
                  [7835, 6898],
                  [7844, 6910],
                  [7832, 6916],
                  [7823, 6907],
                  [7812, 6907],
                  [7808, 6915],
                  [7800, 6912],
                  [7798, 6923],
                  [7810, 6932],
                  [7806, 6940],
                  [7797, 6942],
                  [7799, 6932],
                  [7784, 6941],
                  [7778, 6960],
                  [7778, 6973],
                  [7775, 6975],
                  [7776, 6988],
                  [7790, 6978],
                  [7791, 7001],
                  [7794, 7018],
                  [7791, 7024],
                  [7799, 7054],
                  [7814, 7057],
                  [7839, 7046],
                  [7847, 7053],
                  [7845, 7026],
                  [7856, 7010],
                  [7847, 6987],
                  [7828, 6975],
                  [7829, 6967],
                  [7822, 6956],
                  [7826, 6949],
                  [7836, 6949],
                  [7840, 6948],
                  [7838, 6936],
                  [7829, 6938],
                  [7832, 6923],
                  [7847, 6915],
                  [7854, 6928],
                  [7865, 6926],
                  [7872, 6917],
                  [7891, 6915],
                  [7900, 6907],
                  [7903, 6919],
                  [7911, 6914],
                  [7904, 6903],
                  [7905, 6889],
                  [7901, 6874],
                  [7883, 6889],
                  [7875, 6883],
                  [7868, 6891],
                  [7858, 6893],
                  [7846, 6906],
                  [7840, 6894],
                  [7835, 6898],
                ],
              ],
            ],
          },
        },

        {
          type: "Feature",
          id: "VU",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.54,
            "hc-middle-y": 0.87,
            "hc-key": "VUT",
            "hc-a2": "VU",
            name: t("Countries.vu", { ns: region }),
            labelrank: "4",
            "country-abbrev": "Van.",
            subregion: "Melanesia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "VUT",
            "iso-a2": "VU",
            "woe-id": "23424907",
            continent: "Oceania",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [9190, 6049],
                  [9198, 6051],
                  [9199, 6064],
                  [9202, 6037],
                  [9201, 6018],
                  [9192, 6025],
                  [9200, 6031],
                  [9199, 6049],
                  [9190, 6049],
                ],
              ],
              [
                [
                  [9175, 6036],
                  [9178, 6030],
                  [9190, 6019],
                  [9180, 6016],
                  [9175, 6030],
                  [9169, 6031],
                  [9170, 6047],
                  [9159, 6043],
                  [9154, 6052],
                  [9151, 6068],
                  [9154, 6074],
                  [9159, 6059],
                  [9167, 6064],
                  [9175, 6036],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "SG",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.51,
            "hc-middle-y": 0.58,
            "hc-key": "SGP",
            "hc-a2": "SG",
            name: t("Countries.sg", { ns: region }),
            labelrank: "6",
            "country-abbrev": "Sing.",
            subregion: "South-Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "SGP",
            "iso-a2": "SG",
            "woe-id": "23424948",
            continent: "Asia",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [7306, 6547],
                [7310, 6546],
                [7306, 6542],
                [7300, 6543],
                [7306, 6547],
              ],
            ],
          },
        },

        {
          type: "Feature",
          id: "RU",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.58,
            "hc-middle-y": 0.57,
            "hc-key": "RUS",
            "hc-a2": "RU",
            name: t("Countries.ru", { ns: region }),
            labelrank: "2",
            "country-abbrev": "Rus.",
            subregion: "Eastern Europe",
            "region-wb": "Europe & Central Asia",
            "iso-a3": "RUS",
            "iso-a2": "RU",
            "woe-id": "23424936",
            continent: "Europe",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [8557, 7899],
                  [8541, 7882],
                  [8539, 7885],
                  [8550, 7902],
                  [8557, 7899],
                ],
              ],
              [
                [
                  [8630, 7932],
                  [8612, 7927],
                  [8605, 7920],
                  [8597, 7920],
                  [8593, 7914],
                  [8575, 7899],
                  [8573, 7902],
                  [8591, 7920],
                  [8602, 7928],
                  [8615, 7930],
                  [8624, 7938],
                  [8630, 7932],
                ],
              ],
              [
                [
                  [8681, 7965],
                  [8670, 7954],
                  [8654, 7942],
                  [8648, 7941],
                  [8671, 7963],
                  [8681, 7965],
                ],
              ],
              [
                [
                  [8832, 8138],
                  [8853, 8140],
                  [8853, 8132],
                  [8847, 8133],
                  [8838, 8116],
                  [8819, 8109],
                  [8818, 8118],
                  [8833, 8123],
                  [8838, 8133],
                  [8832, 8138],
                ],
              ],
              [
                [
                  [8282, 8301],
                  [8272, 8301],
                  [8283, 8309],
                  [8295, 8306],
                  [8300, 8313],
                  [8315, 8305],
                  [8303, 8289],
                  [8296, 8300],
                  [8282, 8301],
                ],
              ],
              [
                [
                  [9134, 8320],
                  [9144, 8317],
                  [9143, 8311],
                  [9155, 8298],
                  [9146, 8298],
                  [9134, 8320],
                ],
              ],
              [
                [
                  [9094, 8481],
                  [9095, 8467],
                  [9082, 8466],
                  [9065, 8454],
                  [9076, 8474],
                  [9094, 8481],
                ],
              ],
              [
                [
                  [6288, 8834],
                  [6312, 8829],
                  [6310, 8819],
                  [6296, 8824],
                  [6288, 8834],
                ],
              ],
              [
                [
                  [5723, 8943],
                  [5727, 8953],
                  [5706, 8934],
                  [5679, 8931],
                  [5668, 8941],
                  [5670, 8960],
                  [5685, 8971],
                  [5699, 8972],
                  [5725, 8959],
                  [5730, 8953],
                  [5723, 8943],
                ],
              ],
              [
                [
                  [9236, 8985],
                  [9230, 8975],
                  [9220, 8975],
                  [9200, 8982],
                  [9187, 8989],
                  [9202, 8999],
                  [9236, 8991],
                  [9236, 8985],
                ],
              ],
              [
                [
                  [5996, 9016],
                  [6001, 9009],
                  [6015, 9003],
                  [6029, 8993],
                  [6029, 8983],
                  [6002, 8983],
                  [5998, 8992],
                  [5984, 8995],
                  [5973, 9002],
                  [5971, 9015],
                  [5986, 9023],
                  [5996, 9016],
                ],
              ],
              [
                [
                  [5801, 9073],
                  [5815, 9059],
                  [5809, 9049],
                  [5802, 9060],
                  [5787, 9066],
                  [5787, 9070],
                  [5801, 9073],
                ],
              ],
              [
                [
                  [6538, 9122],
                  [6513, 9122],
                  [6513, 9126],
                  [6533, 9141],
                  [6551, 9137],
                  [6556, 9133],
                  [6538, 9122],
                ],
              ],
              [
                [
                  [8056, 9148],
                  [8026, 9151],
                  [8046, 9157],
                  [8058, 9154],
                  [8056, 9148],
                ],
              ],
              [
                [
                  [6590, 9157],
                  [6591, 9147],
                  [6571, 9147],
                  [6562, 9153],
                  [6578, 9167],
                  [6590, 9157],
                ],
              ],
              [
                [
                  [6452, 9166],
                  [6441, 9156],
                  [6430, 9163],
                  [6433, 9168],
                  [6452, 9166],
                ],
              ],
              [
                [
                  [6343, 9181],
                  [6346, 9185],
                  [6358, 9174],
                  [6361, 9164],
                  [6350, 9171],
                  [6312, 9162],
                  [6305, 9163],
                  [6311, 9176],
                  [6308, 9184],
                  [6323, 9189],
                  [6345, 9187],
                  [6343, 9181],
                ],
              ],
              [
                [
                  [6491, 9193],
                  [6507, 9188],
                  [6505, 9172],
                  [6501, 9172],
                  [6502, 9189],
                  [6488, 9191],
                  [6471, 9187],
                  [6475, 9193],
                  [6491, 9193],
                ],
              ],
              [
                [
                  [6689, 9226],
                  [6709, 9225],
                  [6718, 9220],
                  [6733, 9221],
                  [6733, 9216],
                  [6694, 9223],
                  [6673, 9223],
                  [6679, 9228],
                  [6689, 9226],
                ],
              ],
              [
                [
                  [8245, 9228],
                  [8260, 9218],
                  [8256, 9211],
                  [8236, 9227],
                  [8245, 9228],
                ],
              ],
              [
                [
                  [8386, 9213],
                  [8375, 9222],
                  [8377, 9231],
                  [8396, 9234],
                  [8403, 9228],
                  [8401, 9218],
                  [8386, 9213],
                ],
              ],
              [
                [
                  [7586, 9239],
                  [7569, 9223],
                  [7551, 9226],
                  [7533, 9233],
                  [7530, 9238],
                  [7543, 9239],
                  [7546, 9249],
                  [7584, 9246],
                  [7586, 9239],
                ],
              ],
              [
                [
                  [6769, 9248],
                  [6760, 9245],
                  [6758, 9252],
                  [6780, 9252],
                  [6786, 9249],
                  [6774, 9244],
                  [6769, 9248],
                ],
              ],
              [
                [
                  [6665, 9286],
                  [6659, 9295],
                  [6648, 9299],
                  [6668, 9307],
                  [6671, 9296],
                  [6664, 9297],
                  [6665, 9286],
                ],
              ],
              [
                [
                  [8248, 9299],
                  [8236, 9299],
                  [8243, 9328],
                  [8250, 9317],
                  [8257, 9314],
                  [8248, 9299],
                ],
              ],
              [
                [
                  [7087, 9357],
                  [7101, 9358],
                  [7105, 9351],
                  [7096, 9347],
                  [7095, 9354],
                  [7085, 9352],
                  [7086, 9346],
                  [7054, 9349],
                  [7069, 9355],
                  [7079, 9351],
                  [7087, 9357],
                ],
              ],
              [
                [
                  [7061, 9380],
                  [7082, 9374],
                  [7055, 9377],
                  [7025, 9372],
                  [7049, 9380],
                  [7061, 9380],
                ],
              ],
              [
                [
                  [7089, 9403],
                  [7065, 9395],
                  [7072, 9400],
                  [7053, 9397],
                  [7090, 9411],
                  [7089, 9403],
                ],
              ],
              [
                [
                  [6873, 9406],
                  [6863, 9397],
                  [6859, 9403],
                  [6870, 9407],
                  [6878, 9417],
                  [6886, 9417],
                  [6891, 9408],
                  [6873, 9406],
                ],
              ],
              [
                [
                  [7375, 9473],
                  [7369, 9475],
                  [7383, 9483],
                  [7383, 9471],
                  [7415, 9473],
                  [7412, 9464],
                  [7381, 9469],
                  [7375, 9473],
                ],
              ],
              [
                [
                  [6494, 9568],
                  [6533, 9561],
                  [6532, 9558],
                  [6506, 9557],
                  [6491, 9563],
                  [6494, 9568],
                ],
              ],
              [
                [
                  [5722, 9596],
                  [5706, 9603],
                  [5717, 9608],
                  [5727, 9607],
                  [5727, 9592],
                  [5737, 9591],
                  [5750, 9599],
                  [5758, 9596],
                  [5762, 9586],
                  [5722, 9590],
                  [5722, 9596],
                ],
              ],
              [
                [
                  [6012, 9604],
                  [6013, 9592],
                  [5980, 9584],
                  [5963, 9588],
                  [5979, 9595],
                  [6012, 9604],
                ],
              ],
              [
                [
                  [5929, 9615],
                  [5930, 9600],
                  [5925, 9596],
                  [5888, 9599],
                  [5898, 9605],
                  [5897, 9615],
                  [5929, 9615],
                ],
              ],
              [
                [
                  [5819, 9619],
                  [5834, 9611],
                  [5823, 9604],
                  [5798, 9604],
                  [5785, 9611],
                  [5796, 9612],
                  [5804, 9619],
                  [5819, 9619],
                ],
              ],
              [
                [
                  [5993, 9615],
                  [5973, 9615],
                  [5958, 9610],
                  [5968, 9608],
                  [5968, 9603],
                  [5953, 9604],
                  [5955, 9599],
                  [5939, 9601],
                  [5933, 9608],
                  [5934, 9618],
                  [5925, 9625],
                  [5969, 9624],
                  [5993, 9615],
                ],
              ],
              [
                [
                  [5845, 9620],
                  [5832, 9624],
                  [5835, 9633],
                  [5846, 9632],
                  [5853, 9622],
                  [5864, 9628],
                  [5875, 9621],
                  [5881, 9610],
                  [5870, 9607],
                  [5868, 9623],
                  [5854, 9617],
                  [5850, 9607],
                  [5845, 9620],
                ],
              ],
              [
                [
                  [5917, 9643],
                  [5924, 9637],
                  [5892, 9635],
                  [5880, 9641],
                  [5913, 9646],
                  [5917, 9643],
                ],
              ],
              [
                [
                  [5985, 9647],
                  [5968, 9643],
                  [5951, 9648],
                  [5978, 9654],
                  [5985, 9647],
                ],
              ],
              [
                [
                  [5878, 9651],
                  [5897, 9647],
                  [5864, 9641],
                  [5838, 9648],
                  [5870, 9654],
                  [5878, 9651],
                ],
              ],
              [
                [
                  [6607, 9657],
                  [6616, 9656],
                  [6613, 9651],
                  [6578, 9647],
                  [6574, 9651],
                  [6581, 9657],
                  [6607, 9657],
                ],
              ],
              [
                [
                  [6053, 9659],
                  [6044, 9655],
                  [6025, 9657],
                  [6017, 9661],
                  [6033, 9667],
                  [6064, 9668],
                  [6053, 9659],
                ],
              ],
              [
                [
                  [5952, 9662],
                  [5958, 9668],
                  [5975, 9663],
                  [5972, 9657],
                  [5951, 9650],
                  [5932, 9654],
                  [5920, 9662],
                  [5901, 9667],
                  [5918, 9668],
                  [5925, 9665],
                  [5952, 9662],
                ],
              ],
              [
                [
                  [5883, 9661],
                  [5898, 9663],
                  [5946, 9648],
                  [5943, 9643],
                  [5928, 9639],
                  [5917, 9647],
                  [5891, 9650],
                  [5877, 9659],
                  [5850, 9661],
                  [5857, 9669],
                  [5883, 9661],
                ],
              ],
              [
                [
                  [6153, 9675],
                  [6169, 9670],
                  [6175, 9655],
                  [6162, 9647],
                  [6145, 9642],
                  [6107, 9638],
                  [6089, 9650],
                  [6107, 9658],
                  [6134, 9659],
                  [6141, 9672],
                  [6153, 9675],
                ],
              ],
              [
                [
                  [6937, 9666],
                  [6933, 9664],
                  [6898, 9668],
                  [6900, 9675],
                  [6941, 9674],
                  [6937, 9666],
                ],
              ],
              [
                [
                  [5953, 9677],
                  [5958, 9675],
                  [5947, 9670],
                  [5926, 9672],
                  [5928, 9678],
                  [5915, 9673],
                  [5904, 9676],
                  [5892, 9673],
                  [5881, 9683],
                  [5913, 9678],
                  [5907, 9687],
                  [5918, 9688],
                  [5953, 9681],
                  [5953, 9677],
                ],
              ],
              [
                [
                  [6007, 9674],
                  [5986, 9674],
                  [5987, 9680],
                  [5970, 9683],
                  [5986, 9689],
                  [6007, 9674],
                ],
              ],
              [
                [
                  [5950, 9698],
                  [5968, 9694],
                  [5973, 9689],
                  [5950, 9687],
                  [5939, 9691],
                  [5919, 9692],
                  [5927, 9698],
                  [5950, 9698],
                ],
              ],
              [
                [
                  [6079, 9700],
                  [6069, 9700],
                  [6080, 9710],
                  [6123, 9709],
                  [6117, 9702],
                  [6094, 9703],
                  [6089, 9707],
                  [6079, 9700],
                ],
              ],
              [
                [
                  [5968, 9704],
                  [5965, 9701],
                  [5953, 9710],
                  [5955, 9718],
                  [5992, 9721],
                  [5996, 9713],
                  [5965, 9711],
                  [5968, 9704],
                ],
              ],
              [
                [
                  [6934, 9588],
                  [6931, 9595],
                  [6950, 9596],
                  [6976, 9591],
                  [7008, 9587],
                  [7006, 9581],
                  [6975, 9570],
                  [6955, 9570],
                  [6967, 9574],
                  [6960, 9579],
                  [6930, 9582],
                  [6934, 9588],
                ],
              ],
              [
                [
                  [6046, 9650],
                  [6062, 9653],
                  [6076, 9652],
                  [6082, 9645],
                  [6076, 9634],
                  [6045, 9619],
                  [6024, 9626],
                  [6006, 9621],
                  [5992, 9628],
                  [5992, 9636],
                  [6000, 9647],
                  [6020, 9650],
                  [6024, 9647],
                  [6046, 9650],
                ],
              ],
              [
                [
                  [9598, 9052],
                  [9567, 9046],
                  [9548, 9050],
                  [9538, 9044],
                  [9522, 9044],
                  [9514, 9041],
                  [9507, 9053],
                  [9516, 9064],
                  [9535, 9075],
                  [9556, 9083],
                  [9575, 9083],
                  [9595, 9080],
                  [9623, 9064],
                  [9609, 9053],
                  [9598, 9052],
                ],
              ],
              [
                [
                  [8379, 9183],
                  [8369, 9180],
                  [8367, 9188],
                  [8385, 9189],
                  [8396, 9206],
                  [8403, 9211],
                  [8430, 9213],
                  [8446, 9208],
                  [8470, 9192],
                  [8475, 9174],
                  [8464, 9171],
                  [8415, 9178],
                  [8393, 9184],
                  [8379, 9183],
                ],
              ],
              [
                [
                  [5648, 9650],
                  [5670, 9649],
                  [5683, 9633],
                  [5663, 9637],
                  [5655, 9644],
                  [5643, 9639],
                  [5632, 9629],
                  [5622, 9630],
                  [5617, 9623],
                  [5605, 9622],
                  [5605, 9630],
                  [5588, 9627],
                  [5576, 9636],
                  [5630, 9643],
                  [5636, 9649],
                  [5648, 9650],
                ],
              ],
              [
                [
                  [8091, 7831],
                  [8088, 7839],
                  [8108, 7845],
                  [8113, 7862],
                  [8110, 7867],
                  [8113, 7886],
                  [8107, 7908],
                  [8103, 7914],
                  [8118, 7919],
                  [8129, 7932],
                  [8134, 7928],
                  [8136, 7913],
                  [8145, 7903],
                  [8152, 7909],
                  [8159, 7922],
                  [8167, 7924],
                  [8168, 7936],
                  [8177, 7941],
                  [8184, 7962],
                  [8191, 7966],
                  [8198, 8003],
                  [8216, 8020],
                  [8210, 8032],
                  [8214, 8041],
                  [8205, 8045],
                  [8185, 8040],
                  [8178, 8034],
                  [8167, 8035],
                  [8154, 8029],
                  [8150, 8020],
                  [8106, 8019],
                  [8096, 8033],
                  [8100, 8043],
                  [8091, 8055],
                  [8096, 8064],
                  [8083, 8063],
                  [8073, 8070],
                  [8061, 8084],
                  [8049, 8082],
                  [8040, 8090],
                  [8020, 8089],
                  [8002, 8100],
                  [8004, 8115],
                  [7997, 8119],
                  [7996, 8136],
                  [7985, 8148],
                  [7985, 8161],
                  [7978, 8168],
                  [7971, 8184],
                  [7974, 8190],
                  [7950, 8223],
                  [7932, 8232],
                  [7911, 8233],
                  [7906, 8239],
                  [7888, 8246],
                  [7866, 8243],
                  [7850, 8244],
                  [7817, 8235],
                  [7807, 8235],
                  [7782, 8214],
                  [7783, 8208],
                  [7794, 8209],
                  [7803, 8206],
                  [7800, 8198],
                  [7804, 8189],
                  [7798, 8181],
                  [7784, 8171],
                  [7766, 8135],
                  [7756, 8121],
                  [7762, 8120],
                  [7761, 8110],
                  [7741, 8105],
                  [7715, 8088],
                  [7695, 8094],
                  [7684, 8100],
                  [7670, 8107],
                  [7656, 8102],
                  [7645, 8103],
                  [7627, 8116],
                  [7613, 8117],
                  [7581, 8100],
                  [7576, 8091],
                  [7547, 8084],
                  [7526, 8082],
                  [7508, 8074],
                  [7492, 8075],
                  [7462, 8082],
                  [7444, 8081],
                  [7426, 8094],
                  [7426, 8104],
                  [7405, 8107],
                  [7388, 8119],
                  [7376, 8118],
                  [7369, 8122],
                  [7349, 8125],
                  [7322, 8118],
                  [7314, 8112],
                  [7300, 8112],
                  [7269, 8123],
                  [7261, 8128],
                  [7256, 8149],
                  [7257, 8158],
                  [7233, 8163],
                  [7207, 8174],
                  [7193, 8174],
                  [7160, 8189],
                  [7155, 8178],
                  [7143, 8173],
                  [7135, 8163],
                  [7128, 8145],
                  [7134, 8131],
                  [7142, 8127],
                  [7137, 8109],
                  [7113, 8096],
                  [7103, 8102],
                  [7086, 8102],
                  [7071, 8107],
                  [7061, 8102],
                  [7034, 8107],
                  [7026, 8116],
                  [7023, 8128],
                  [6987, 8131],
                  [6985, 8137],
                  [6976, 8133],
                  [6966, 8139],
                  [6962, 8133],
                  [6950, 8133],
                  [6940, 8124],
                  [6928, 8123],
                  [6887, 8103],
                  [6889, 8095],
                  [6865, 8085],
                  [6844, 8085],
                  [6843, 8079],
                  [6834, 8075],
                  [6819, 8072],
                  [6808, 8081],
                  [6798, 8091],
                  [6798, 8099],
                  [6785, 8086],
                  [6768, 8092],
                  [6764, 8091],
                  [6759, 8091],
                  [6750, 8110],
                  [6745, 8111],
                  [6729, 8117],
                  [6727, 8126],
                  [6716, 8140],
                  [6705, 8145],
                  [6685, 8142],
                  [6676, 8134],
                  [6656, 8137],
                  [6647, 8135],
                  [6645, 8144],
                  [6635, 8143],
                  [6637, 8151],
                  [6624, 8157],
                  [6616, 8152],
                  [6617, 8144],
                  [6604, 8139],
                  [6590, 8161],
                  [6559, 8210],
                  [6541, 8235],
                  [6533, 8242],
                  [6501, 8263],
                  [6497, 8270],
                  [6505, 8269],
                  [6511, 8283],
                  [6475, 8268],
                  [6457, 8256],
                  [6440, 8251],
                  [6439, 8243],
                  [6425, 8250],
                  [6410, 8241],
                  [6405, 8249],
                  [6404, 8250],
                  [6407, 8254],
                  [6408, 8256],
                  [6411, 8259],
                  [6413, 8262],
                  [6399, 8263],
                  [6386, 8270],
                  [6381, 8260],
                  [6375, 8278],
                  [6370, 8270],
                  [6360, 8271],
                  [6348, 8272],
                  [6344, 8268],
                  [6344, 8277],
                  [6344, 8294],
                  [6339, 8296],
                  [6333, 8317],
                  [6322, 8316],
                  [6315, 8310],
                  [6300, 8318],
                  [6285, 8318],
                  [6278, 8323],
                  [6268, 8313],
                  [6258, 8313],
                  [6255, 8303],
                  [6205, 8293],
                  [6191, 8289],
                  [6175, 8290],
                  [6168, 8278],
                  [6159, 8280],
                  [6132, 8276],
                  [6106, 8268],
                  [6074, 8264],
                  [6069, 8263],
                  [6062, 8262],
                  [6050, 8265],
                  [6044, 8249],
                  [6053, 8246],
                  [6050, 8235],
                  [6057, 8233],
                  [6075, 8229],
                  [6076, 8224],
                  [6058, 8224],
                  [6046, 8221],
                  [6035, 8211],
                  [6045, 8198],
                  [6030, 8190],
                  [6019, 8180],
                  [6029, 8176],
                  [6025, 8171],
                  [6042, 8169],
                  [6045, 8164],
                  [6058, 8162],
                  [6064, 8155],
                  [6055, 8137],
                  [6036, 8132],
                  [6024, 8133],
                  [6015, 8140],
                  [6008, 8127],
                  [5999, 8129],
                  [5983, 8133],
                  [5977, 8137],
                  [5973, 8140],
                  [5965, 8151],
                  [5949, 8150],
                  [5947, 8141],
                  [5942, 8141],
                  [5937, 8141],
                  [5931, 8149],
                  [5912, 8148],
                  [5899, 8135],
                  [5887, 8127],
                  [5869, 8141],
                  [5857, 8146],
                  [5858, 8130],
                  [5849, 8131],
                  [5852, 8140],
                  [5836, 8152],
                  [5828, 8154],
                  [5819, 8165],
                  [5794, 8164],
                  [5789, 8175],
                  [5775, 8172],
                  [5773, 8164],
                  [5759, 8164],
                  [5761, 8170],
                  [5737, 8170],
                  [5731, 8158],
                  [5726, 8156],
                  [5714, 8149],
                  [5703, 8149],
                  [5703, 8139],
                  [5693, 8135],
                  [5681, 8129],
                  [5687, 8107],
                  [5674, 8099],
                  [5648, 8124],
                  [5641, 8117],
                  [5641, 8108],
                  [5629, 8100],
                  [5625, 8081],
                  [5633, 8076],
                  [5625, 8065],
                  [5617, 8046],
                  [5634, 8041],
                  [5635, 8024],
                  [5644, 8023],
                  [5663, 8022],
                  [5677, 8009],
                  [5691, 7985],
                  [5675, 7981],
                  [5683, 7976],
                  [5698, 7969],
                  [5682, 7961],
                  [5667, 7947],
                  [5650, 7946],
                  [5638, 7919],
                  [5624, 7908],
                  [5623, 7900],
                  [5639, 7892],
                  [5650, 7875],
                  [5646, 7849],
                  [5678, 7807],
                  [5678, 7807],
                  [5672, 7798],
                  [5663, 7794],
                  [5658, 7785],
                  [5640, 7788],
                  [5624, 7807],
                  [5615, 7809],
                  [5591, 7821],
                  [5594, 7831],
                  [5584, 7831],
                  [5569, 7840],
                  [5560, 7839],
                  [5542, 7832],
                  [5538, 7839],
                  [5520, 7846],
                  [5514, 7852],
                  [5497, 7856],
                  [5472, 7856],
                  [5445, 7867],
                  [5433, 7869],
                  [5425, 7862],
                  [5396, 7889],
                  [5372, 7899],
                  [5363, 7909],
                  [5352, 7908],
                  [5346, 7917],
                  [5326, 7927],
                  [5333, 7936],
                  [5341, 7929],
                  [5359, 7931],
                  [5355, 7944],
                  [5366, 7958],
                  [5383, 7961],
                  [5366, 7970],
                  [5359, 7981],
                  [5368, 7980],
                  [5379, 7987],
                  [5404, 7994],
                  [5404, 8003],
                  [5373, 7997],
                  [5377, 8016],
                  [5389, 8019],
                  [5391, 8025],
                  [5419, 8024],
                  [5426, 8041],
                  [5417, 8059],
                  [5424, 8063],
                  [5416, 8069],
                  [5430, 8078],
                  [5429, 8091],
                  [5420, 8089],
                  [5402, 8101],
                  [5395, 8099],
                  [5372, 8109],
                  [5367, 8103],
                  [5350, 8123],
                  [5326, 8115],
                  [5311, 8123],
                  [5299, 8120],
                  [5292, 8125],
                  [5292, 8132],
                  [5282, 8152],
                  [5255, 8155],
                  [5258, 8160],
                  [5253, 8172],
                  [5261, 8177],
                  [5252, 8182],
                  [5243, 8198],
                  [5226, 8199],
                  [5218, 8194],
                  [5201, 8197],
                  [5197, 8188],
                  [5183, 8188],
                  [5178, 8197],
                  [5176, 8218],
                  [5168, 8225],
                  [5173, 8232],
                  [5193, 8227],
                  [5212, 8242],
                  [5204, 8252],
                  [5183, 8256],
                  [5185, 8266],
                  [5170, 8273],
                  [5166, 8289],
                  [5154, 8296],
                  [5161, 8306],
                  [5155, 8316],
                  [5158, 8329],
                  [5145, 8337],
                  [5128, 8339],
                  [5116, 8333],
                  [5113, 8344],
                  [5096, 8343],
                  [5091, 8349],
                  [5077, 8352],
                  [5076, 8368],
                  [5066, 8382],
                  [5062, 8381],
                  [5068, 8400],
                  [5054, 8410],
                  [5059, 8422],
                  [5067, 8424],
                  [5062, 8430],
                  [5076, 8424],
                  [5071, 8438],
                  [5058, 8440],
                  [5066, 8450],
                  [5064, 8473],
                  [5066, 8477],
                  [5068, 8480],
                  [5071, 8485],
                  [5073, 8486],
                  [5075, 8487],
                  [5075, 8487],
                  [5075, 8487],
                  [5075, 8487],
                  [5075, 8487],
                  [5078, 8489],
                  [5076, 8492],
                  [5073, 8494],
                  [5075, 8508],
                  [5084, 8502],
                  [5088, 8511],
                  [5101, 8509],
                  [5107, 8517],
                  [5137, 8512],
                  [5127, 8524],
                  [5102, 8526],
                  [5093, 8537],
                  [5093, 8550],
                  [5079, 8541],
                  [5067, 8541],
                  [5096, 8566],
                  [5108, 8572],
                  [5125, 8588],
                  [5150, 8615],
                  [5168, 8629],
                  [5178, 8648],
                  [5168, 8661],
                  [5146, 8674],
                  [5131, 8687],
                  [5146, 8698],
                  [5148, 8709],
                  [5132, 8718],
                  [5130, 8726],
                  [5137, 8729],
                  [5133, 8736],
                  [5125, 8737],
                  [5119, 8746],
                  [5127, 8756],
                  [5123, 8777],
                  [5134, 8778],
                  [5129, 8800],
                  [5117, 8819],
                  [5105, 8836],
                  [5105, 8843],
                  [5117, 8859],
                  [5129, 8869],
                  [5132, 8878],
                  [5121, 8885],
                  [5111, 8898],
                  [5092, 8904],
                  [5086, 8922],
                  [5096, 8937],
                  [5086, 8940],
                  [5101, 8947],
                  [5109, 8951],
                  [5112, 8960],
                  [5129, 8964],
                  [5140, 8978],
                  [5157, 8973],
                  [5156, 8987],
                  [5174, 8981],
                  [5185, 8981],
                  [5183, 8990],
                  [5191, 8986],
                  [5192, 8996],
                  [5223, 8980],
                  [5216, 8976],
                  [5195, 8979],
                  [5206, 8972],
                  [5222, 8970],
                  [5216, 8964],
                  [5235, 8968],
                  [5228, 8957],
                  [5256, 8967],
                  [5269, 8958],
                  [5286, 8956],
                  [5288, 8960],
                  [5307, 8954],
                  [5358, 8931],
                  [5380, 8912],
                  [5385, 8914],
                  [5412, 8898],
                  [5426, 8895],
                  [5456, 8879],
                  [5459, 8857],
                  [5464, 8856],
                  [5466, 8845],
                  [5461, 8834],
                  [5439, 8815],
                  [5407, 8801],
                  [5383, 8797],
                  [5365, 8799],
                  [5334, 8809],
                  [5320, 8809],
                  [5290, 8815],
                  [5273, 8825],
                  [5262, 8822],
                  [5254, 8828],
                  [5234, 8831],
                  [5215, 8843],
                  [5214, 8848],
                  [5198, 8850],
                  [5207, 8843],
                  [5214, 8831],
                  [5225, 8829],
                  [5218, 8821],
                  [5241, 8816],
                  [5237, 8811],
                  [5264, 8800],
                  [5274, 8790],
                  [5276, 8780],
                  [5262, 8764],
                  [5277, 8740],
                  [5278, 8728],
                  [5272, 8725],
                  [5291, 8712],
                  [5309, 8716],
                  [5305, 8711],
                  [5317, 8699],
                  [5343, 8694],
                  [5346, 8690],
                  [5367, 8697],
                  [5367, 8714],
                  [5358, 8719],
                  [5341, 8717],
                  [5321, 8742],
                  [5308, 8748],
                  [5301, 8745],
                  [5294, 8751],
                  [5300, 8755],
                  [5316, 8754],
                  [5325, 8742],
                  [5338, 8755],
                  [5358, 8747],
                  [5368, 8739],
                  [5394, 8734],
                  [5413, 8725],
                  [5422, 8732],
                  [5436, 8735],
                  [5437, 8743],
                  [5417, 8766],
                  [5421, 8776],
                  [5434, 8782],
                  [5449, 8794],
                  [5465, 8798],
                  [5481, 8809],
                  [5502, 8833],
                  [5501, 8814],
                  [5522, 8816],
                  [5539, 8804],
                  [5549, 8789],
                  [5547, 8810],
                  [5558, 8828],
                  [5558, 8840],
                  [5552, 8848],
                  [5538, 8853],
                  [5538, 8861],
                  [5548, 8884],
                  [5551, 8907],
                  [5548, 8911],
                  [5524, 8925],
                  [5528, 8928],
                  [5543, 8922],
                  [5582, 8922],
                  [5601, 8917],
                  [5603, 8911],
                  [5618, 8901],
                  [5624, 8886],
                  [5583, 8880],
                  [5574, 8871],
                  [5572, 8860],
                  [5591, 8852],
                  [5598, 8838],
                  [5620, 8835],
                  [5653, 8844],
                  [5652, 8854],
                  [5660, 8866],
                  [5656, 8872],
                  [5669, 8878],
                  [5684, 8880],
                  [5686, 8887],
                  [5695, 8887],
                  [5733, 8905],
                  [5755, 8920],
                  [5770, 8919],
                  [5786, 8924],
                  [5783, 8913],
                  [5791, 8911],
                  [5801, 8918],
                  [5788, 8926],
                  [5821, 8941],
                  [5841, 8945],
                  [5849, 8943],
                  [5827, 8941],
                  [5839, 8937],
                  [5830, 8928],
                  [5838, 8912],
                  [5822, 8913],
                  [5816, 8907],
                  [5838, 8905],
                  [5847, 8911],
                  [5864, 8904],
                  [5866, 8914],
                  [5879, 8923],
                  [5896, 8927],
                  [5936, 8923],
                  [5955, 8938],
                  [5982, 8945],
                  [5987, 8958],
                  [5992, 8945],
                  [5982, 8942],
                  [5998, 8933],
                  [5987, 8926],
                  [5989, 8915],
                  [6005, 8911],
                  [6014, 8918],
                  [6008, 8928],
                  [6028, 8931],
                  [6041, 8942],
                  [6041, 8952],
                  [6032, 8953],
                  [6030, 8963],
                  [6019, 8975],
                  [6034, 8980],
                  [6037, 8990],
                  [6056, 8987],
                  [6092, 8984],
                  [6115, 8980],
                  [6136, 8974],
                  [6183, 8949],
                  [6211, 8940],
                  [6221, 8939],
                  [6231, 8930],
                  [6258, 8911],
                  [6259, 8904],
                  [6277, 8927],
                  [6283, 8942],
                  [6265, 8944],
                  [6251, 8963],
                  [6251, 8971],
                  [6230, 8978],
                  [6224, 8964],
                  [6215, 8977],
                  [6217, 8997],
                  [6228, 8999],
                  [6224, 9009],
                  [6229, 9020],
                  [6230, 9036],
                  [6225, 9042],
                  [6212, 9039],
                  [6209, 9046],
                  [6205, 9034],
                  [6215, 9019],
                  [6204, 9028],
                  [6204, 9042],
                  [6219, 9067],
                  [6249, 9080],
                  [6264, 9096],
                  [6269, 9107],
                  [6279, 9145],
                  [6293, 9160],
                  [6297, 9154],
                  [6355, 9156],
                  [6393, 9145],
                  [6394, 9120],
                  [6378, 9098],
                  [6374, 9084],
                  [6363, 9080],
                  [6371, 9067],
                  [6388, 9057],
                  [6392, 9045],
                  [6388, 9031],
                  [6391, 9020],
                  [6381, 9012],
                  [6388, 8989],
                  [6383, 8979],
                  [6387, 8960],
                  [6382, 8956],
                  [6385, 8942],
                  [6416, 8920],
                  [6400, 8905],
                  [6402, 8881],
                  [6386, 8875],
                  [6380, 8860],
                  [6370, 8857],
                  [6375, 8852],
                  [6354, 8838],
                  [6356, 8827],
                  [6341, 8826],
                  [6329, 8820],
                  [6304, 8835],
                  [6279, 8834],
                  [6283, 8825],
                  [6320, 8811],
                  [6343, 8813],
                  [6368, 8806],
                  [6379, 8811],
                  [6383, 8825],
                  [6412, 8835],
                  [6423, 8844],
                  [6424, 8859],
                  [6448, 8878],
                  [6451, 8891],
                  [6448, 8903],
                  [6437, 8914],
                  [6440, 8930],
                  [6462, 8939],
                  [6497, 8945],
                  [6504, 8944],
                  [6505, 8933],
                  [6525, 8921],
                  [6520, 8908],
                  [6526, 8906],
                  [6519, 8882],
                  [6546, 8871],
                  [6574, 8874],
                  [6548, 8877],
                  [6530, 8882],
                  [6531, 8901],
                  [6550, 8908],
                  [6536, 8926],
                  [6535, 8939],
                  [6513, 8946],
                  [6508, 8952],
                  [6487, 8958],
                  [6471, 8959],
                  [6460, 8951],
                  [6434, 8953],
                  [6426, 8950],
                  [6420, 8955],
                  [6424, 8967],
                  [6413, 8984],
                  [6417, 8990],
                  [6419, 9007],
                  [6436, 9025],
                  [6436, 9033],
                  [6426, 9042],
                  [6414, 9065],
                  [6398, 9073],
                  [6412, 9086],
                  [6413, 9096],
                  [6454, 9111],
                  [6459, 9117],
                  [6457, 9142],
                  [6449, 9150],
                  [6456, 9154],
                  [6466, 9151],
                  [6477, 9136],
                  [6473, 9131],
                  [6478, 9119],
                  [6465, 9103],
                  [6464, 9091],
                  [6472, 9080],
                  [6463, 9073],
                  [6486, 9064],
                  [6538, 9059],
                  [6545, 9049],
                  [6558, 9045],
                  [6559, 9057],
                  [6552, 9057],
                  [6553, 9065],
                  [6535, 9066],
                  [6495, 9081],
                  [6486, 9100],
                  [6496, 9105],
                  [6514, 9108],
                  [6532, 9096],
                  [6548, 9099],
                  [6551, 9105],
                  [6543, 9112],
                  [6529, 9109],
                  [6548, 9127],
                  [6586, 9127],
                  [6604, 9117],
                  [6628, 9110],
                  [6623, 9107],
                  [6655, 9089],
                  [6688, 9094],
                  [6701, 9088],
                  [6693, 9081],
                  [6693, 9073],
                  [6671, 9066],
                  [6668, 9052],
                  [6674, 9040],
                  [6665, 9028],
                  [6676, 9030],
                  [6677, 9040],
                  [6688, 9051],
                  [6696, 9045],
                  [6692, 9028],
                  [6696, 9021],
                  [6699, 9040],
                  [6698, 9014],
                  [6715, 9023],
                  [6706, 9046],
                  [6696, 9064],
                  [6710, 9084],
                  [6703, 9097],
                  [6686, 9100],
                  [6668, 9111],
                  [6668, 9121],
                  [6639, 9125],
                  [6624, 9136],
                  [6622, 9146],
                  [6628, 9157],
                  [6613, 9173],
                  [6612, 9179],
                  [6622, 9187],
                  [6621, 9194],
                  [6628, 9194],
                  [6661, 9199],
                  [6706, 9198],
                  [6745, 9205],
                  [6763, 9202],
                  [6769, 9208],
                  [6803, 9213],
                  [6812, 9211],
                  [6803, 9195],
                  [6815, 9196],
                  [6828, 9208],
                  [6817, 9210],
                  [6804, 9229],
                  [6789, 9236],
                  [6788, 9243],
                  [6817, 9239],
                  [6804, 9243],
                  [6795, 9251],
                  [6773, 9255],
                  [6762, 9262],
                  [6790, 9259],
                  [6808, 9254],
                  [6808, 9267],
                  [6789, 9268],
                  [6801, 9274],
                  [6831, 9279],
                  [6807, 9282],
                  [6810, 9286],
                  [6837, 9283],
                  [6848, 9287],
                  [6857, 9297],
                  [6872, 9303],
                  [6890, 9303],
                  [6897, 9311],
                  [6925, 9316],
                  [6936, 9314],
                  [6946, 9318],
                  [7003, 9328],
                  [6995, 9335],
                  [6983, 9330],
                  [6987, 9341],
                  [7016, 9340],
                  [7007, 9344],
                  [7025, 9344],
                  [7033, 9340],
                  [7044, 9352],
                  [7053, 9344],
                  [7071, 9345],
                  [7075, 9336],
                  [7062, 9330],
                  [7089, 9337],
                  [7088, 9329],
                  [7099, 9330],
                  [7109, 9342],
                  [7110, 9336],
                  [7129, 9336],
                  [7140, 9343],
                  [7131, 9344],
                  [7158, 9353],
                  [7155, 9349],
                  [7185, 9339],
                  [7181, 9324],
                  [7188, 9330],
                  [7189, 9342],
                  [7179, 9353],
                  [7165, 9358],
                  [7159, 9368],
                  [7178, 9365],
                  [7218, 9369],
                  [7224, 9366],
                  [7257, 9361],
                  [7219, 9371],
                  [7229, 9383],
                  [7218, 9388],
                  [7220, 9396],
                  [7228, 9397],
                  [7228, 9404],
                  [7256, 9423],
                  [7278, 9432],
                  [7288, 9439],
                  [7298, 9437],
                  [7311, 9444],
                  [7320, 9440],
                  [7332, 9442],
                  [7334, 9438],
                  [7350, 9432],
                  [7365, 9433],
                  [7368, 9424],
                  [7377, 9422],
                  [7394, 9427],
                  [7409, 9412],
                  [7392, 9424],
                  [7380, 9417],
                  [7363, 9421],
                  [7345, 9410],
                  [7320, 9406],
                  [7336, 9403],
                  [7363, 9405],
                  [7367, 9398],
                  [7378, 9402],
                  [7406, 9398],
                  [7412, 9392],
                  [7382, 9367],
                  [7423, 9369],
                  [7426, 9381],
                  [7436, 9379],
                  [7467, 9383],
                  [7489, 9379],
                  [7497, 9383],
                  [7520, 9382],
                  [7533, 9378],
                  [7531, 9374],
                  [7561, 9374],
                  [7564, 9364],
                  [7553, 9364],
                  [7566, 9358],
                  [7564, 9350],
                  [7571, 9345],
                  [7563, 9339],
                  [7586, 9349],
                  [7592, 9329],
                  [7601, 9328],
                  [7596, 9312],
                  [7562, 9327],
                  [7570, 9321],
                  [7569, 9312],
                  [7584, 9315],
                  [7594, 9307],
                  [7593, 9293],
                  [7572, 9276],
                  [7550, 9269],
                  [7538, 9257],
                  [7530, 9259],
                  [7515, 9250],
                  [7485, 9238],
                  [7484, 9230],
                  [7457, 9219],
                  [7442, 9205],
                  [7430, 9197],
                  [7403, 9196],
                  [7402, 9191],
                  [7388, 9179],
                  [7376, 9179],
                  [7359, 9156],
                  [7343, 9149],
                  [7354, 9148],
                  [7369, 9158],
                  [7388, 9152],
                  [7402, 9153],
                  [7376, 9160],
                  [7380, 9172],
                  [7420, 9171],
                  [7440, 9179],
                  [7464, 9183],
                  [7463, 9192],
                  [7474, 9187],
                  [7483, 9188],
                  [7499, 9197],
                  [7513, 9200],
                  [7506, 9206],
                  [7495, 9201],
                  [7481, 9201],
                  [7473, 9205],
                  [7488, 9219],
                  [7504, 9218],
                  [7517, 9213],
                  [7521, 9220],
                  [7529, 9207],
                  [7557, 9201],
                  [7574, 9207],
                  [7570, 9218],
                  [7578, 9212],
                  [7588, 9195],
                  [7579, 9187],
                  [7592, 9175],
                  [7600, 9181],
                  [7590, 9190],
                  [7608, 9195],
                  [7625, 9195],
                  [7646, 9202],
                  [7681, 9199],
                  [7715, 9194],
                  [7736, 9195],
                  [7752, 9189],
                  [7737, 9189],
                  [7733, 9184],
                  [7736, 9173],
                  [7768, 9164],
                  [7782, 9171],
                  [7788, 9160],
                  [7812, 9157],
                  [7822, 9160],
                  [7868, 9155],
                  [7853, 9160],
                  [7858, 9163],
                  [7874, 9157],
                  [7886, 9173],
                  [7877, 9183],
                  [7877, 9193],
                  [7887, 9202],
                  [7898, 9197],
                  [7916, 9213],
                  [7920, 9201],
                  [7935, 9198],
                  [7934, 9193],
                  [7948, 9191],
                  [7944, 9186],
                  [7965, 9193],
                  [7969, 9184],
                  [7985, 9186],
                  [7989, 9192],
                  [8018, 9189],
                  [8016, 9181],
                  [8028, 9181],
                  [8024, 9176],
                  [8043, 9173],
                  [8059, 9163],
                  [8057, 9158],
                  [8044, 9160],
                  [8025, 9156],
                  [8021, 9149],
                  [8055, 9145],
                  [8042, 9143],
                  [8046, 9138],
                  [8035, 9132],
                  [8050, 9132],
                  [8062, 9119],
                  [8044, 9109],
                  [8013, 9129],
                  [8009, 9123],
                  [8023, 9118],
                  [8044, 9091],
                  [8055, 9099],
                  [8055, 9092],
                  [8041, 9088],
                  [8050, 9084],
                  [8058, 9070],
                  [8069, 9059],
                  [8094, 9044],
                  [8099, 9049],
                  [8102, 9039],
                  [8112, 9037],
                  [8121, 9045],
                  [8134, 9065],
                  [8138, 9079],
                  [8151, 9099],
                  [8169, 9082],
                  [8183, 9075],
                  [8208, 9071],
                  [8224, 9080],
                  [8252, 9085],
                  [8273, 9080],
                  [8296, 9070],
                  [8298, 9064],
                  [8318, 9066],
                  [8304, 9074],
                  [8283, 9080],
                  [8288, 9082],
                  [8312, 9081],
                  [8334, 9086],
                  [8346, 9073],
                  [8354, 9078],
                  [8371, 9077],
                  [8362, 9087],
                  [8358, 9102],
                  [8366, 9115],
                  [8357, 9118],
                  [8346, 9114],
                  [8345, 9122],
                  [8357, 9133],
                  [8387, 9133],
                  [8403, 9138],
                  [8388, 9155],
                  [8411, 9152],
                  [8416, 9148],
                  [8479, 9142],
                  [8529, 9136],
                  [8550, 9131],
                  [8570, 9124],
                  [8528, 9125],
                  [8516, 9130],
                  [8500, 9115],
                  [8519, 9120],
                  [8574, 9123],
                  [8561, 9109],
                  [8546, 9098],
                  [8546, 9109],
                  [8539, 9117],
                  [8536, 9110],
                  [8541, 9102],
                  [8524, 9097],
                  [8516, 9089],
                  [8528, 9087],
                  [8551, 9096],
                  [8582, 9124],
                  [8618, 9123],
                  [8653, 9114],
                  [8667, 9101],
                  [8656, 9093],
                  [8646, 9100],
                  [8635, 9089],
                  [8663, 9087],
                  [8661, 9076],
                  [8683, 9079],
                  [8683, 9066],
                  [8695, 9072],
                  [8712, 9067],
                  [8727, 9054],
                  [8713, 9050],
                  [8730, 9044],
                  [8753, 9042],
                  [8772, 9043],
                  [8789, 9049],
                  [8839, 9056],
                  [8888, 9055],
                  [8916, 9049],
                  [8937, 9042],
                  [8950, 9033],
                  [8962, 9012],
                  [8950, 8992],
                  [8968, 8979],
                  [8986, 8979],
                  [8990, 8949],
                  [8993, 8962],
                  [8991, 8968],
                  [8999, 8974],
                  [8998, 8958],
                  [9002, 8963],
                  [9000, 8976],
                  [9015, 8979],
                  [9009, 8971],
                  [9027, 8980],
                  [9052, 8983],
                  [9070, 8981],
                  [9078, 8986],
                  [9090, 8978],
                  [9101, 8975],
                  [9126, 8976],
                  [9138, 8973],
                  [9163, 8971],
                  [9189, 8986],
                  [9202, 8974],
                  [9203, 8958],
                  [9233, 8950],
                  [9242, 8934],
                  [9264, 8936],
                  [9280, 8945],
                  [9280, 8961],
                  [9271, 8977],
                  [9256, 8981],
                  [9271, 8985],
                  [9271, 9004],
                  [9312, 8997],
                  [9336, 8996],
                  [9347, 8989],
                  [9355, 8995],
                  [9372, 8991],
                  [9416, 8990],
                  [9439, 8986],
                  [9452, 8980],
                  [9470, 8977],
                  [9495, 8968],
                  [9500, 8971],
                  [9526, 8959],
                  [9547, 8945],
                  [9582, 8933],
                  [9586, 8922],
                  [9615, 8912],
                  [9644, 8896],
                  [9651, 8889],
                  [9664, 8887],
                  [9668, 8876],
                  [9671, 8885],
                  [9687, 8877],
                  [9690, 8861],
                  [9695, 8866],
                  [9702, 8859],
                  [9698, 8846],
                  [9704, 8832],
                  [9696, 8827],
                  [9712, 8821],
                  [9711, 8808],
                  [9724, 8818],
                  [9730, 8810],
                  [9734, 8816],
                  [9717, 8822],
                  [9726, 8827],
                  [9724, 8842],
                  [9707, 8848],
                  [9746, 8847],
                  [9764, 8838],
                  [9773, 8841],
                  [9760, 8846],
                  [9792, 8841],
                  [9802, 8828],
                  [9826, 8812],
                  [9838, 8807],
                  [9838, 8801],
                  [9851, 8801],
                  [9850, 8795],
                  [9838, 8795],
                  [9827, 8788],
                  [9826, 8776],
                  [9808, 8780],
                  [9812, 8769],
                  [9805, 8771],
                  [9778, 8772],
                  [9771, 8779],
                  [9781, 8749],
                  [9767, 8743],
                  [9782, 8734],
                  [9765, 8731],
                  [9777, 8718],
                  [9766, 8716],
                  [9759, 8723],
                  [9759, 8714],
                  [9743, 8712],
                  [9746, 8720],
                  [9736, 8714],
                  [9703, 8737],
                  [9683, 8735],
                  [9670, 8746],
                  [9673, 8752],
                  [9668, 8766],
                  [9637, 8776],
                  [9624, 8768],
                  [9598, 8768],
                  [9591, 8771],
                  [9595, 8779],
                  [9588, 8782],
                  [9578, 8797],
                  [9585, 8794],
                  [9592, 8802],
                  [9589, 8812],
                  [9584, 8803],
                  [9571, 8804],
                  [9555, 8800],
                  [9556, 8784],
                  [9569, 8777],
                  [9558, 8753],
                  [9541, 8747],
                  [9533, 8738],
                  [9516, 8733],
                  [9495, 8730],
                  [9478, 8734],
                  [9473, 8743],
                  [9457, 8749],
                  [9468, 8739],
                  [9431, 8743],
                  [9452, 8726],
                  [9459, 8733],
                  [9474, 8735],
                  [9473, 8719],
                  [9489, 8709],
                  [9497, 8716],
                  [9508, 8696],
                  [9511, 8681],
                  [9507, 8671],
                  [9527, 8662],
                  [9526, 8651],
                  [9536, 8639],
                  [9530, 8630],
                  [9517, 8623],
                  [9491, 8631],
                  [9469, 8633],
                  [9469, 8643],
                  [9458, 8638],
                  [9467, 8632],
                  [9451, 8629],
                  [9438, 8621],
                  [9409, 8612],
                  [9386, 8598],
                  [9372, 8598],
                  [9365, 8590],
                  [9358, 8595],
                  [9356, 8586],
                  [9331, 8570],
                  [9313, 8555],
                  [9300, 8552],
                  [9288, 8542],
                  [9277, 8539],
                  [9268, 8529],
                  [9265, 8515],
                  [9252, 8519],
                  [9245, 8534],
                  [9231, 8542],
                  [9197, 8542],
                  [9167, 8531],
                  [9144, 8510],
                  [9139, 8509],
                  [9147, 8538],
                  [9137, 8537],
                  [9127, 8529],
                  [9110, 8521],
                  [9112, 8516],
                  [9101, 8508],
                  [9091, 8522],
                  [9082, 8515],
                  [9066, 8519],
                  [9068, 8513],
                  [9058, 8509],
                  [9052, 8495],
                  [9057, 8486],
                  [9050, 8485],
                  [9055, 8477],
                  [9030, 8458],
                  [9018, 8434],
                  [9019, 8427],
                  [9033, 8420],
                  [9039, 8429],
                  [9057, 8418],
                  [9042, 8404],
                  [9041, 8378],
                  [9054, 8377],
                  [9058, 8353],
                  [9049, 8346],
                  [9037, 8355],
                  [9045, 8364],
                  [9030, 8361],
                  [9035, 8357],
                  [9022, 8351],
                  [9011, 8330],
                  [9014, 8308],
                  [9022, 8299],
                  [9010, 8285],
                  [8993, 8288],
                  [8981, 8286],
                  [8961, 8271],
                  [8956, 8263],
                  [8954, 8245],
                  [8961, 8228],
                  [8948, 8234],
                  [8919, 8220],
                  [8914, 8203],
                  [8917, 8200],
                  [8909, 8183],
                  [8893, 8166],
                  [8862, 8141],
                  [8863, 8153],
                  [8857, 8157],
                  [8854, 8193],
                  [8845, 8221],
                  [8839, 8259],
                  [8833, 8281],
                  [8828, 8316],
                  [8831, 8343],
                  [8843, 8378],
                  [8861, 8390],
                  [8871, 8406],
                  [8865, 8420],
                  [8870, 8424],
                  [8885, 8422],
                  [8892, 8431],
                  [8902, 8430],
                  [8930, 8448],
                  [8951, 8468],
                  [8955, 8479],
                  [8968, 8488],
                  [8974, 8497],
                  [8983, 8500],
                  [9004, 8520],
                  [9015, 8526],
                  [9016, 8535],
                  [9040, 8545],
                  [9044, 8550],
                  [9070, 8558],
                  [9062, 8561],
                  [9078, 8577],
                  [9070, 8580],
                  [9078, 8592],
                  [9081, 8618],
                  [9093, 8627],
                  [9113, 8624],
                  [9094, 8637],
                  [9055, 8630],
                  [9058, 8621],
                  [9050, 8617],
                  [9053, 8609],
                  [9047, 8597],
                  [9057, 8593],
                  [9049, 8584],
                  [9042, 8593],
                  [9030, 8592],
                  [9018, 8578],
                  [8964, 8542],
                  [8964, 8553],
                  [8972, 8563],
                  [8954, 8558],
                  [8959, 8566],
                  [8952, 8572],
                  [8967, 8586],
                  [8969, 8604],
                  [8956, 8593],
                  [8945, 8592],
                  [8940, 8601],
                  [8908, 8598],
                  [8903, 8594],
                  [8884, 8596],
                  [8861, 8585],
                  [8861, 8571],
                  [8844, 8561],
                  [8836, 8549],
                  [8810, 8533],
                  [8799, 8521],
                  [8797, 8512],
                  [8789, 8511],
                  [8785, 8495],
                  [8811, 8495],
                  [8818, 8481],
                  [8797, 8483],
                  [8784, 8475],
                  [8764, 8484],
                  [8750, 8470],
                  [8733, 8476],
                  [8724, 8468],
                  [8705, 8467],
                  [8697, 8478],
                  [8685, 8479],
                  [8687, 8494],
                  [8678, 8500],
                  [8653, 8506],
                  [8630, 8496],
                  [8627, 8489],
                  [8634, 8484],
                  [8619, 8485],
                  [8617, 8490],
                  [8603, 8490],
                  [8592, 8483],
                  [8584, 8488],
                  [8556, 8491],
                  [8556, 8481],
                  [8542, 8484],
                  [8546, 8491],
                  [8517, 8489],
                  [8485, 8492],
                  [8473, 8487],
                  [8463, 8489],
                  [8437, 8479],
                  [8417, 8457],
                  [8397, 8447],
                  [8390, 8438],
                  [8385, 8424],
                  [8370, 8417],
                  [8364, 8408],
                  [8347, 8399],
                  [8331, 8387],
                  [8309, 8361],
                  [8275, 8332],
                  [8262, 8325],
                  [8249, 8312],
                  [8229, 8300],
                  [8231, 8293],
                  [8245, 8287],
                  [8278, 8288],
                  [8273, 8256],
                  [8285, 8256],
                  [8290, 8266],
                  [8284, 8270],
                  [8309, 8283],
                  [8291, 8266],
                  [8305, 8262],
                  [8292, 8245],
                  [8309, 8247],
                  [8328, 8264],
                  [8328, 8257],
                  [8319, 8247],
                  [8326, 8246],
                  [8334, 8263],
                  [8333, 8277],
                  [8352, 8272],
                  [8364, 8276],
                  [8377, 8266],
                  [8378, 8260],
                  [8412, 8230],
                  [8403, 8223],
                  [8408, 8207],
                  [8403, 8202],
                  [8412, 8193],
                  [8412, 8182],
                  [8397, 8169],
                  [8391, 8158],
                  [8391, 8148],
                  [8383, 8128],
                  [8390, 8109],
                  [8382, 8101],
                  [8387, 8090],
                  [8375, 8048],
                  [8352, 8027],
                  [8340, 8005],
                  [8327, 7993],
                  [8314, 7965],
                  [8302, 7949],
                  [8277, 7927],
                  [8256, 7901],
                  [8249, 7898],
                  [8227, 7866],
                  [8199, 7851],
                  [8191, 7844],
                  [8169, 7837],
                  [8156, 7845],
                  [8143, 7844],
                  [8144, 7859],
                  [8133, 7851],
                  [8127, 7854],
                  [8117, 7845],
                  [8111, 7834],
                  [8095, 7836],
                  [8101, 7832],
                  [8096, 7823],
                  [8095, 7826],
                  [8091, 7831],
                ],
              ],
              [
                [
                  [4866, 8316],
                  [4853, 8303],
                  [4873, 8302],
                  [4874, 8315],
                  [4899, 8306],
                  [4913, 8307],
                  [4920, 8300],
                  [4916, 8282],
                  [4918, 8278],
                  [4916, 8278],
                  [4830, 8282],
                  [4849, 8292],
                  [4836, 8293],
                  [4832, 8289],
                  [4832, 8289],
                  [4838, 8303],
                  [4848, 8303],
                  [4864, 8316],
                  [4866, 8316],
                  [4866, 8316],
                ],
              ],
              [
                [
                  [4826, 8282],
                  [4826, 8283],
                  [4826, 8283],
                  [4829, 8286],
                  [4829, 8286],
                  [4829, 8286],
                  [4826, 8282],
                ],
              ],
              [
                [
                  [4829, 8286],
                  [4832, 8289],
                  [4832, 8289],
                  [4832, 8288],
                  [4829, 8286],
                  [4829, 8286],
                  [4829, 8286],
                ],
              ],
              [
                [
                  [8467, 8230],
                  [8468, 8212],
                  [8464, 8197],
                  [8463, 8179],
                  [8468, 8175],
                  [8474, 8155],
                  [8482, 8119],
                  [8488, 8107],
                  [8496, 8078],
                  [8503, 8067],
                  [8488, 8079],
                  [8466, 8083],
                  [8445, 8031],
                  [8445, 8022],
                  [8459, 8003],
                  [8464, 7983],
                  [8474, 7985],
                  [8477, 7970],
                  [8472, 7963],
                  [8470, 7976],
                  [8443, 7980],
                  [8432, 7953],
                  [8427, 7958],
                  [8424, 7979],
                  [8431, 7995],
                  [8428, 8016],
                  [8435, 8029],
                  [8433, 8043],
                  [8425, 8060],
                  [8428, 8063],
                  [8434, 8094],
                  [8434, 8110],
                  [8430, 8127],
                  [8437, 8148],
                  [8431, 8164],
                  [8420, 8174],
                  [8419, 8199],
                  [8424, 8208],
                  [8427, 8225],
                  [8422, 8239],
                  [8436, 8245],
                  [8438, 8239],
                  [8453, 8252],
                  [8450, 8262],
                  [8439, 8275],
                  [8451, 8281],
                  [8459, 8270],
                  [8455, 8257],
                  [8467, 8230],
                ],
              ],
              [
                [
                  [5765, 9082],
                  [5762, 9098],
                  [5768, 9110],
                  [5775, 9114],
                  [5791, 9110],
                  [5791, 9120],
                  [5799, 9126],
                  [5802, 9141],
                  [5791, 9145],
                  [5797, 9153],
                  [5809, 9157],
                  [5818, 9154],
                  [5813, 9170],
                  [5831, 9178],
                  [5844, 9177],
                  [5866, 9185],
                  [5876, 9180],
                  [5910, 9174],
                  [5908, 9165],
                  [5886, 9160],
                  [5904, 9159],
                  [5901, 9149],
                  [5889, 9149],
                  [5889, 9141],
                  [5879, 9122],
                  [5884, 9116],
                  [5874, 9102],
                  [5882, 9100],
                  [5887, 9084],
                  [5900, 9065],
                  [5928, 9044],
                  [5945, 9036],
                  [5930, 9024],
                  [5910, 9036],
                  [5916, 9028],
                  [5898, 9028],
                  [5880, 9037],
                  [5872, 9027],
                  [5853, 9039],
                  [5845, 9036],
                  [5817, 9044],
                  [5830, 9048],
                  [5823, 9055],
                  [5845, 9057],
                  [5839, 9064],
                  [5826, 9062],
                  [5816, 9076],
                  [5808, 9073],
                  [5797, 9076],
                  [5775, 9076],
                  [5765, 9082],
                ],
              ],
              [
                [
                  [8587, 9303],
                  [8618, 9302],
                  [8624, 9289],
                  [8639, 9292],
                  [8668, 9290],
                  [8671, 9287],
                  [8690, 9284],
                  [8683, 9270],
                  [8641, 9262],
                  [8611, 9265],
                  [8592, 9275],
                  [8579, 9277],
                  [8549, 9291],
                  [8558, 9311],
                  [8570, 9307],
                  [8570, 9298],
                  [8581, 9297],
                  [8587, 9303],
                ],
              ],
              [
                [
                  [8344, 9342],
                  [8364, 9335],
                  [8364, 9330],
                  [8386, 9322],
                  [8383, 9315],
                  [8399, 9314],
                  [8396, 9321],
                  [8401, 9340],
                  [8417, 9337],
                  [8410, 9347],
                  [8433, 9337],
                  [8445, 9328],
                  [8470, 9325],
                  [8486, 9326],
                  [8529, 9307],
                  [8509, 9302],
                  [8514, 9294],
                  [8498, 9279],
                  [8488, 9278],
                  [8455, 9285],
                  [8444, 9299],
                  [8445, 9305],
                  [8459, 9312],
                  [8459, 9319],
                  [8439, 9320],
                  [8432, 9308],
                  [8435, 9297],
                  [8448, 9282],
                  [8479, 9273],
                  [8472, 9271],
                  [8440, 9266],
                  [8428, 9273],
                  [8435, 9277],
                  [8403, 9272],
                  [8372, 9266],
                  [8366, 9274],
                  [8355, 9273],
                  [8357, 9267],
                  [8351, 9258],
                  [8341, 9256],
                  [8308, 9267],
                  [8305, 9275],
                  [8286, 9285],
                  [8278, 9298],
                  [8293, 9297],
                  [8290, 9312],
                  [8284, 9320],
                  [8299, 9323],
                  [8295, 9334],
                  [8312, 9338],
                  [8327, 9348],
                  [8338, 9350],
                  [8344, 9342],
                ],
              ],
              [
                [
                  [6184, 9378],
                  [6219, 9395],
                  [6238, 9399],
                  [6264, 9396],
                  [6278, 9385],
                  [6273, 9372],
                  [6278, 9371],
                  [6260, 9358],
                  [6225, 9343],
                  [6197, 9334],
                  [6168, 9328],
                  [6124, 9314],
                  [6104, 9312],
                  [6082, 9303],
                  [6066, 9299],
                  [6058, 9290],
                  [6055, 9296],
                  [6039, 9286],
                  [6036, 9278],
                  [6015, 9275],
                  [6033, 9275],
                  [6031, 9269],
                  [6020, 9268],
                  [6023, 9262],
                  [6008, 9260],
                  [6011, 9255],
                  [5994, 9256],
                  [5990, 9244],
                  [5961, 9252],
                  [5975, 9243],
                  [5977, 9232],
                  [5963, 9229],
                  [5959, 9217],
                  [5942, 9222],
                  [5953, 9213],
                  [5948, 9202],
                  [5937, 9193],
                  [5927, 9194],
                  [5934, 9187],
                  [5919, 9175],
                  [5880, 9180],
                  [5868, 9186],
                  [5845, 9180],
                  [5839, 9182],
                  [5854, 9196],
                  [5870, 9201],
                  [5853, 9201],
                  [5840, 9196],
                  [5827, 9204],
                  [5846, 9213],
                  [5862, 9217],
                  [5858, 9222],
                  [5872, 9229],
                  [5891, 9224],
                  [5886, 9229],
                  [5870, 9234],
                  [5886, 9238],
                  [5874, 9240],
                  [5879, 9244],
                  [5905, 9246],
                  [5882, 9251],
                  [5883, 9256],
                  [5908, 9260],
                  [5911, 9265],
                  [5895, 9264],
                  [5894, 9267],
                  [5917, 9273],
                  [5909, 9279],
                  [5893, 9277],
                  [5891, 9286],
                  [5908, 9288],
                  [5910, 9281],
                  [5923, 9290],
                  [5919, 9294],
                  [5928, 9300],
                  [5948, 9296],
                  [5943, 9307],
                  [5961, 9312],
                  [5956, 9317],
                  [5974, 9320],
                  [5977, 9330],
                  [5991, 9336],
                  [6007, 9332],
                  [6024, 9336],
                  [6023, 9343],
                  [6039, 9344],
                  [6029, 9338],
                  [6047, 9342],
                  [6041, 9346],
                  [6046, 9353],
                  [6063, 9355],
                  [6085, 9348],
                  [6097, 9353],
                  [6102, 9349],
                  [6124, 9358],
                  [6134, 9356],
                  [6157, 9366],
                  [6165, 9365],
                  [6180, 9372],
                  [6191, 9369],
                  [6184, 9378],
                ],
              ],
              [
                [
                  [7222, 9469],
                  [7194, 9458],
                  [7178, 9457],
                  [7171, 9463],
                  [7185, 9478],
                  [7201, 9499],
                  [7200, 9504],
                  [7224, 9528],
                  [7224, 9534],
                  [7238, 9542],
                  [7246, 9550],
                  [7250, 9543],
                  [7259, 9541],
                  [7260, 9554],
                  [7279, 9548],
                  [7275, 9534],
                  [7263, 9514],
                  [7277, 9528],
                  [7305, 9535],
                  [7312, 9526],
                  [7322, 9525],
                  [7325, 9516],
                  [7345, 9513],
                  [7352, 9498],
                  [7350, 9493],
                  [7333, 9482],
                  [7316, 9482],
                  [7302, 9477],
                  [7228, 9473],
                  [7222, 9469],
                ],
              ],
              [
                [
                  [7025, 9557],
                  [7015, 9554],
                  [7008, 9561],
                  [6990, 9556],
                  [6980, 9551],
                  [6951, 9553],
                  [6980, 9554],
                  [6982, 9562],
                  [6995, 9562],
                  [7021, 9577],
                  [7036, 9580],
                  [7026, 9583],
                  [7025, 9590],
                  [7038, 9592],
                  [7045, 9599],
                  [7052, 9593],
                  [7060, 9599],
                  [7089, 9599],
                  [7122, 9604],
                  [7136, 9596],
                  [7119, 9579],
                  [7125, 9576],
                  [7131, 9585],
                  [7145, 9584],
                  [7150, 9596],
                  [7169, 9595],
                  [7193, 9580],
                  [7195, 9571],
                  [7202, 9569],
                  [7184, 9563],
                  [7185, 9549],
                  [7180, 9543],
                  [7165, 9544],
                  [7187, 9532],
                  [7191, 9523],
                  [7175, 9514],
                  [7127, 9513],
                  [7112, 9516],
                  [7098, 9525],
                  [7086, 9527],
                  [7066, 9525],
                  [7058, 9532],
                  [7046, 9528],
                  [7027, 9541],
                  [7025, 9557],
                ],
              ],
              [
                [
                  [5659, 9609],
                  [5645, 9608],
                  [5635, 9603],
                  [5622, 9613],
                  [5635, 9617],
                  [5639, 9613],
                  [5667, 9615],
                  [5650, 9619],
                  [5667, 9620],
                  [5664, 9624],
                  [5644, 9622],
                  [5662, 9629],
                  [5674, 9631],
                  [5678, 9626],
                  [5695, 9627],
                  [5709, 9635],
                  [5709, 9642],
                  [5697, 9639],
                  [5691, 9645],
                  [5727, 9656],
                  [5731, 9662],
                  [5736, 9672],
                  [5743, 9667],
                  [5749, 9649],
                  [5734, 9647],
                  [5728, 9642],
                  [5759, 9645],
                  [5770, 9638],
                  [5755, 9634],
                  [5748, 9628],
                  [5712, 9625],
                  [5715, 9619],
                  [5705, 9617],
                  [5686, 9618],
                  [5681, 9613],
                  [5694, 9605],
                  [5676, 9605],
                  [5672, 9598],
                  [5665, 9601],
                  [5652, 9597],
                  [5659, 9609],
                ],
              ],
              [
                [
                  [6988, 9660],
                  [7042, 9670],
                  [7048, 9679],
                  [7068, 9681],
                  [7091, 9666],
                  [7103, 9654],
                  [7126, 9649],
                  [7132, 9640],
                  [7110, 9636],
                  [7105, 9628],
                  [7110, 9616],
                  [7117, 9614],
                  [7110, 9608],
                  [7046, 9601],
                  [7031, 9601],
                  [7023, 9595],
                  [7020, 9591],
                  [7007, 9592],
                  [6963, 9606],
                  [6960, 9612],
                  [6995, 9610],
                  [6992, 9613],
                  [6943, 9612],
                  [6941, 9616],
                  [6960, 9619],
                  [6955, 9624],
                  [6979, 9627],
                  [6983, 9638],
                  [6994, 9646],
                  [6972, 9645],
                  [6977, 9652],
                  [6989, 9655],
                  [6988, 9660],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "TW",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.44,
            "hc-middle-y": 0.46,
            "hc-key": "TWN",
            "hc-a2": "TW",
            // name: t("Countries.tw", { ns: region }),
            name: "",
            labelrank: "3",
            "country-abbrev": "Taiwan",
            subregion: "Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "TWN",
            "iso-a2": "TW",
            "woe-id": "23424971",
            continent: "Asia",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [7785, 7201],
                [7787, 7214],
                [7802, 7240],
                [7812, 7254],
                [7828, 7261],
                [7840, 7252],
                [7835, 7246],
                [7835, 7236],
                [7830, 7227],
                [7823, 7195],
                [7809, 7175],
                [7806, 7156],
                [7796, 7172],
                [7791, 7175],
                [7783, 7195],
                [7785, 7201],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "MY",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.89,
            "hc-middle-y": 0.3,
            "hc-key": "MYS",
            "hc-a2": "MY",
            name: t("Countries.my", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Malay.",
            subregion: "South-Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "MYS",
            "iso-a2": "MY",
            "woe-id": "23424901",
            continent: "Asia",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [7714, 6627],
                  [7714, 6630],
                  [7720, 6627],
                  [7715, 6627],
                  [7714, 6627],
                ],
              ],
              [
                [
                  [7476, 6566],
                  [7485, 6555],
                  [7502, 6556],
                  [7501, 6553],
                  [7517, 6551],
                  [7523, 6566],
                  [7526, 6587],
                  [7546, 6590],
                  [7575, 6598],
                  [7588, 6615],
                  [7603, 6630],
                  [7605, 6640],
                  [7612, 6636],
                  [7622, 6623],
                  [7630, 6635],
                  [7627, 6644],
                  [7634, 6648],
                  [7635, 6649],
                  [7635, 6646],
                  [7635, 6646],
                  [7635, 6640],
                  [7636, 6639],
                  [7645, 6632],
                  [7638, 6649],
                  [7645, 6649],
                  [7652, 6658],
                  [7645, 6661],
                  [7651, 6670],
                  [7659, 6668],
                  [7667, 6685],
                  [7678, 6695],
                  [7693, 6721],
                  [7700, 6721],
                  [7695, 6713],
                  [7702, 6700],
                  [7715, 6692],
                  [7711, 6687],
                  [7716, 6678],
                  [7723, 6683],
                  [7726, 6672],
                  [7735, 6675],
                  [7750, 6663],
                  [7758, 6665],
                  [7760, 6657],
                  [7742, 6650],
                  [7733, 6653],
                  [7726, 6648],
                  [7736, 6638],
                  [7745, 6636],
                  [7719, 6630],
                  [7713, 6635],
                  [7710, 6627],
                  [7699, 6633],
                  [7675, 6631],
                  [7659, 6634],
                  [7650, 6619],
                  [7652, 6606],
                  [7648, 6594],
                  [7636, 6588],
                  [7640, 6579],
                  [7628, 6571],
                  [7629, 6561],
                  [7619, 6547],
                  [7602, 6547],
                  [7594, 6541],
                  [7576, 6550],
                  [7560, 6551],
                  [7551, 6548],
                  [7549, 6539],
                  [7541, 6535],
                  [7522, 6537],
                  [7503, 6530],
                  [7495, 6534],
                  [7482, 6546],
                  [7473, 6560],
                  [7476, 6566],
                ],
              ],
              [
                [
                  [7196, 6694],
                  [7197, 6701],
                  [7204, 6696],
                  [7224, 6688],
                  [7221, 6674],
                  [7225, 6670],
                  [7238, 6678],
                  [7245, 6673],
                  [7253, 6688],
                  [7263, 6685],
                  [7266, 6678],
                  [7284, 6663],
                  [7294, 6646],
                  [7295, 6632],
                  [7291, 6615],
                  [7295, 6608],
                  [7294, 6592],
                  [7303, 6582],
                  [7316, 6558],
                  [7319, 6547],
                  [7301, 6547],
                  [7296, 6542],
                  [7292, 6550],
                  [7266, 6566],
                  [7257, 6570],
                  [7245, 6581],
                  [7230, 6589],
                  [7233, 6595],
                  [7223, 6611],
                  [7214, 6618],
                  [7215, 6625],
                  [7209, 6632],
                  [7209, 6647],
                  [7203, 6654],
                  [7203, 6681],
                  [7187, 6686],
                  [7182, 6694],
                  [7196, 6694],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "TR",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.34,
            "hc-middle-y": 0.48,
            "hc-key": "TUR",
            "hc-a2": "TR",
            name: t("Countries.tr", { ns: region }),
            labelrank: "2",
            "country-abbrev": "Tur.",
            subregion: "Western Asia",
            "region-wb": "Europe & Central Asia",
            "iso-a3": "TUR",
            "iso-a2": "TR",
            "woe-id": "23424969",
            continent: "Asia",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [5567, 7730],
                  [5560, 7735],
                  [5556, 7723],
                  [5545, 7722],
                  [5552, 7703],
                  [5552, 7687],
                  [5557, 7685],
                  [5550, 7673],
                  [5561, 7665],
                  [5560, 7655],
                  [5566, 7645],
                  [5553, 7640],
                  [5550, 7649],
                  [5528, 7649],
                  [5517, 7653],
                  [5506, 7652],
                  [5495, 7644],
                  [5491, 7651],
                  [5485, 7646],
                  [5469, 7643],
                  [5447, 7644],
                  [5419, 7632],
                  [5403, 7629],
                  [5387, 7631],
                  [5373, 7637],
                  [5351, 7628],
                  [5338, 7628],
                  [5327, 7634],
                  [5324, 7623],
                  [5328, 7614],
                  [5319, 7614],
                  [5319, 7606],
                  [5312, 7601],
                  [5305, 7604],
                  [5302, 7617],
                  [5314, 7627],
                  [5309, 7638],
                  [5289, 7625],
                  [5272, 7634],
                  [5266, 7632],
                  [5240, 7611],
                  [5224, 7611],
                  [5214, 7608],
                  [5201, 7613],
                  [5191, 7625],
                  [5171, 7634],
                  [5152, 7637],
                  [5143, 7615],
                  [5139, 7617],
                  [5122, 7611],
                  [5106, 7618],
                  [5100, 7632],
                  [5081, 7635],
                  [5063, 7629],
                  [5061, 7634],
                  [5074, 7634],
                  [5082, 7642],
                  [5051, 7639],
                  [5061, 7650],
                  [5049, 7652],
                  [5050, 7674],
                  [5031, 7678],
                  [5021, 7683],
                  [5028, 7687],
                  [5029, 7696],
                  [5033, 7685],
                  [5041, 7689],
                  [5035, 7699],
                  [5044, 7706],
                  [5032, 7718],
                  [5040, 7728],
                  [5016, 7725],
                  [5019, 7743],
                  [5035, 7757],
                  [5052, 7759],
                  [5066, 7754],
                  [5059, 7765],
                  [5074, 7759],
                  [5070, 7757],
                  [5106, 7758],
                  [5095, 7761],
                  [5102, 7765],
                  [5129, 7769],
                  [5113, 7769],
                  [5103, 7777],
                  [5109, 7786],
                  [5128, 7783],
                  [5139, 7785],
                  [5156, 7780],
                  [5168, 7781],
                  [5173, 7789],
                  [5194, 7799],
                  [5198, 7803],
                  [5229, 7813],
                  [5270, 7811],
                  [5277, 7816],
                  [5285, 7804],
                  [5294, 7800],
                  [5307, 7803],
                  [5312, 7794],
                  [5321, 7786],
                  [5326, 7791],
                  [5355, 7779],
                  [5377, 7775],
                  [5409, 7782],
                  [5430, 7775],
                  [5467, 7791],
                  [5471, 7796],
                  [5498, 7793],
                  [5509, 7798],
                  [5521, 7784],
                  [5527, 7781],
                  [5536, 7766],
                  [5531, 7759],
                  [5534, 7747],
                  [5557, 7742],
                  [5566, 7733],
                  [5567, 7730],
                ],
              ],
              [
                [
                  [5023, 7803],
                  [5030, 7810],
                  [5051, 7816],
                  [5059, 7809],
                  [5073, 7812],
                  [5075, 7800],
                  [5084, 7793],
                  [5105, 7786],
                  [5101, 7778],
                  [5090, 7777],
                  [5080, 7781],
                  [5071, 7777],
                  [5059, 7777],
                  [5048, 7765],
                  [5034, 7759],
                  [5018, 7745],
                  [5007, 7750],
                  [5020, 7754],
                  [5038, 7764],
                  [5016, 7764],
                  [5015, 7768],
                  [5024, 7776],
                  [5023, 7786],
                  [5032, 7791],
                  [5031, 7799],
                  [5023, 7803],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "GE",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.25,
            "hc-middle-y": 0.46,
            "hc-key": "GEO",
            "hc-a2": "GE",
            name: "",
            labelrank: "5",
            "country-abbrev": "Geo.",
            subregion: "Western Asia",
            "region-wb": "Europe & Central Asia",
            "iso-a3": "GEO",
            "iso-a2": "GE",
            "woe-id": "23424823",
            continent: "Asia",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [5584, 7831],
                [5594, 7831],
                [5591, 7821],
                [5601, 7813],
                [5615, 7809],
                [5608, 7801],
                [5623, 7787],
                [5617, 7779],
                [5609, 7785],
                [5602, 7783],
                [5587, 7793],
                [5573, 7788],
                [5560, 7784],
                [5549, 7786],
                [5527, 7781],
                [5521, 7784],
                [5509, 7798],
                [5498, 7793],
                [5471, 7796],
                [5478, 7806],
                [5470, 7835],
                [5460, 7841],
                [5451, 7850],
                [5436, 7853],
                [5425, 7862],
                [5433, 7869],
                [5445, 7867],
                [5472, 7856],
                [5497, 7856],
                [5514, 7852],
                [5520, 7846],
                [5538, 7839],
                [5542, 7832],
                [5560, 7839],
                [5569, 7840],
                [5574, 7837],
                [5579, 7837],
                [5584, 7831],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "AM",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.1,
            "hc-middle-y": 0.12,
            "hc-key": "ARM",
            "hc-a2": "AM",
            name: t("Countries.am", { ns: region }),
            //name: "",
            labelrank: "6",
            "country-abbrev": "Arm.",
            subregion: "Western Asia",
            "region-wb": "Europe & Central Asia",
            "iso-a3": "ARM",
            "iso-a2": "AM",
            "woe-id": "23424743",
            continent: "Asia",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [5587, 7764],
                  [5587, 7765],
                  [5590, 7765],
                  [5588, 7764],
                  [5587, 7764],
                ],
              ],
              [
                [
                  [5618, 7704],
                  [5614, 7706],
                  [5607, 7704],
                  [5596, 7727],
                  [5578, 7728],
                  [5574, 7735],
                  [5566, 7733],
                  [5557, 7742],
                  [5534, 7747],
                  [5531, 7759],
                  [5536, 7766],
                  [5527, 7781],
                  [5549, 7786],
                  [5560, 7784],
                  [5573, 7788],
                  [5575, 7781],
                  [5591, 7773],
                  [5584, 7766],
                  [5589, 7758],
                  [5602, 7751],
                  [5599, 7743],
                  [5592, 7744],
                  [5609, 7729],
                  [5618, 7727],
                  [5614, 7721],
                  [5618, 7704],
                ],
                [
                  [5574, 7779],
                  [5574, 7780],
                  [5572, 7780],
                  [5574, 7778],
                  [5574, 7779],
                ],
                [
                  [5580, 7777],
                  [5579, 7778],
                  [5578, 7777],
                  [5579, 7777],
                  [5580, 7777],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "AZ",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.7,
            "hc-middle-y": 0.15,
            "hc-key": "AZE",
            "hc-a2": "AZ",
            name: "",
            labelrank: "5",
            "country-abbrev": "Aze.",
            subregion: "Western Asia",
            "region-wb": "Europe & Central Asia",
            "iso-a3": "AZE",
            "iso-a2": "AZ",
            "woe-id": "23424741",
            continent: "Asia",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [5574, 7779],
                  [5574, 7778],
                  [5572, 7780],
                  [5574, 7780],
                  [5574, 7779],
                ],
              ],
              [
                [
                  [5580, 7777],
                  [5579, 7777],
                  [5578, 7777],
                  [5579, 7778],
                  [5580, 7777],
                ],
              ],
              [
                [
                  [5663, 7794],
                  [5667, 7795],
                  [5672, 7798],
                  [5678, 7807],
                  [5692, 7792],
                  [5697, 7780],
                  [5708, 7765],
                  [5722, 7763],
                  [5731, 7755],
                  [5717, 7756],
                  [5704, 7746],
                  [5703, 7733],
                  [5697, 7709],
                  [5690, 7715],
                  [5687, 7689],
                  [5679, 7688],
                  [5674, 7695],
                  [5662, 7702],
                  [5670, 7710],
                  [5665, 7719],
                  [5671, 7721],
                  [5657, 7732],
                  [5628, 7714],
                  [5618, 7704],
                  [5614, 7721],
                  [5618, 7727],
                  [5609, 7729],
                  [5592, 7744],
                  [5599, 7743],
                  [5602, 7751],
                  [5589, 7758],
                  [5584, 7766],
                  [5591, 7773],
                  [5575, 7781],
                  [5573, 7788],
                  [5587, 7793],
                  [5602, 7783],
                  [5609, 7785],
                  [5617, 7779],
                  [5623, 7787],
                  [5608, 7801],
                  [5615, 7809],
                  [5624, 7807],
                  [5640, 7788],
                  [5658, 7785],
                  [5663, 7794],
                ],
                [
                  [5587, 7764],
                  [5588, 7764],
                  [5590, 7765],
                  [5587, 7765],
                  [5587, 7764],
                ],
              ],
              [
                [
                  [5567, 7730],
                  [5566, 7733],
                  [5574, 7735],
                  [5578, 7728],
                  [5596, 7727],
                  [5607, 7704],
                  [5586, 7708],
                  [5578, 7716],
                  [5567, 7730],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "TH",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.32,
            "hc-middle-y": 0.86,
            "hc-key": "THA",
            "hc-a2": "TH",
            name: t("Countries.th", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Thai.",
            subregion: "South-Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "THA",
            "iso-a2": "TH",
            "woe-id": "23424960",
            continent: "Asia",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [7253, 6688],
                  [7245, 6673],
                  [7238, 6678],
                  [7225, 6670],
                  [7221, 6674],
                  [7224, 6688],
                  [7204, 6696],
                  [7197, 6701],
                  [7196, 6694],
                  [7186, 6705],
                  [7185, 6714],
                  [7175, 6719],
                  [7171, 6728],
                  [7160, 6741],
                  [7147, 6749],
                  [7147, 6736],
                  [7143, 6733],
                  [7139, 6755],
                  [7141, 6770],
                  [7150, 6791],
                  [7156, 6809],
                  [7156, 6819],
                  [7169, 6831],
                  [7182, 6852],
                  [7175, 6875],
                  [7169, 6880],
                  [7167, 6909],
                  [7161, 6919],
                  [7150, 6929],
                  [7141, 6941],
                  [7138, 6951],
                  [7149, 6957],
                  [7154, 6985],
                  [7147, 6999],
                  [7146, 7008],
                  [7137, 7016],
                  [7124, 7032],
                  [7126, 7036],
                  [7115, 7053],
                  [7126, 7055],
                  [7123, 7065],
                  [7127, 7080],
                  [7134, 7092],
                  [7149, 7088],
                  [7163, 7093],
                  [7166, 7102],
                  [7172, 7100],
                  [7191, 7112],
                  [7195, 7108],
                  [7201, 7110],
                  [7209, 7103],
                  [7204, 7091],
                  [7206, 7084],
                  [7229, 7085],
                  [7231, 7069],
                  [7229, 7058],
                  [7223, 7050],
                  [7227, 7039],
                  [7219, 7025],
                  [7226, 7021],
                  [7254, 7044],
                  [7271, 7033],
                  [7292, 7051],
                  [7310, 7047],
                  [7319, 7033],
                  [7334, 7018],
                  [7332, 6993],
                  [7341, 6981],
                  [7352, 6978],
                  [7359, 6966],
                  [7353, 6950],
                  [7357, 6947],
                  [7352, 6930],
                  [7345, 6928],
                  [7341, 6924],
                  [7333, 6930],
                  [7310, 6928],
                  [7301, 6930],
                  [7283, 6926],
                  [7266, 6904],
                  [7261, 6904],
                  [7266, 6887],
                  [7266, 6877],
                  [7274, 6870],
                  [7272, 6862],
                  [7273, 6859],
                  [7273, 6859],
                  [7273, 6859],
                  [7260, 6857],
                  [7259, 6866],
                  [7246, 6878],
                  [7235, 6876],
                  [7217, 6879],
                  [7221, 6902],
                  [7209, 6903],
                  [7194, 6900],
                  [7196, 6889],
                  [7191, 6876],
                  [7193, 6864],
                  [7188, 6857],
                  [7178, 6832],
                  [7178, 6824],
                  [7172, 6817],
                  [7168, 6802],
                  [7171, 6776],
                  [7183, 6778],
                  [7183, 6787],
                  [7194, 6786],
                  [7188, 6778],
                  [7191, 6758],
                  [7200, 6749],
                  [7205, 6724],
                  [7201, 6733],
                  [7198, 6725],
                  [7207, 6714],
                  [7210, 6717],
                  [7222, 6706],
                  [7239, 6705],
                  [7253, 6688],
                ],
              ],
              [
                [
                  [7273, 6859],
                  [7273, 6859],
                  [7278, 6847],
                  [7273, 6859],
                  [7273, 6859],
                  [7273, 6859],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "KZ",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.58,
            "hc-middle-y": 0.47,
            "hc-key": "KAZ",
            "hc-a2": "KZ",
            name: t("Countries.kz", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Kaz.",
            subregion: "Central Asia",
            "region-wb": "Europe & Central Asia",
            "iso-a3": "KAZ",
            "iso-a2": "KZ",
            "woe-id": "-90",
            continent: "Asia",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [6457, 8256],
                  [6475, 8268],
                  [6511, 8283],
                  [6505, 8269],
                  [6500, 8271],
                  [6497, 8270],
                  [6501, 8263],
                  [6533, 8242],
                  [6541, 8235],
                  [6559, 8210],
                  [6588, 8164],
                  [6590, 8161],
                  [6603, 8137],
                  [6617, 8144],
                  [6617, 8146],
                  [6616, 8152],
                  [6624, 8157],
                  [6637, 8151],
                  [6635, 8143],
                  [6645, 8144],
                  [6647, 8135],
                  [6656, 8137],
                  [6676, 8134],
                  [6685, 8142],
                  [6705, 8145],
                  [6716, 8140],
                  [6727, 8126],
                  [6729, 8117],
                  [6744, 8112],
                  [6745, 8111],
                  [6746, 8110],
                  [6750, 8110],
                  [6759, 8091],
                  [6764, 8091],
                  [6766, 8091],
                  [6768, 8092],
                  [6785, 8086],
                  [6798, 8099],
                  [6798, 8091],
                  [6805, 8088],
                  [6808, 8081],
                  [6810, 8078],
                  [6819, 8072],
                  [6806, 8073],
                  [6802, 8068],
                  [6802, 8057],
                  [6797, 8051],
                  [6774, 8046],
                  [6766, 8028],
                  [6771, 8008],
                  [6765, 7995],
                  [6757, 7995],
                  [6744, 7987],
                  [6741, 7993],
                  [6719, 7992],
                  [6692, 8001],
                  [6677, 7953],
                  [6671, 7939],
                  [6681, 7936],
                  [6680, 7926],
                  [6661, 7925],
                  [6655, 7932],
                  [6629, 7925],
                  [6605, 7921],
                  [6603, 7913],
                  [6614, 7907],
                  [6614, 7888],
                  [6625, 7864],
                  [6627, 7853],
                  [6614, 7849],
                  [6620, 7845],
                  [6608, 7835],
                  [6610, 7819],
                  [6601, 7828],
                  [6587, 7829],
                  [6579, 7841],
                  [6559, 7844],
                  [6521, 7845],
                  [6514, 7848],
                  [6499, 7844],
                  [6479, 7845],
                  [6475, 7841],
                  [6462, 7843],
                  [6432, 7857],
                  [6416, 7850],
                  [6410, 7834],
                  [6412, 7828],
                  [6389, 7836],
                  [6364, 7842],
                  [6351, 7841],
                  [6339, 7833],
                  [6337, 7821],
                  [6327, 7814],
                  [6323, 7816],
                  [6307, 7803],
                  [6298, 7801],
                  [6281, 7790],
                  [6281, 7785],
                  [6267, 7775],
                  [6268, 7764],
                  [6250, 7771],
                  [6254, 7780],
                  [6248, 7785],
                  [6215, 7783],
                  [6212, 7785],
                  [6206, 7812],
                  [6192, 7813],
                  [6194, 7848],
                  [6185, 7844],
                  [6177, 7859],
                  [6161, 7873],
                  [6145, 7868],
                  [6109, 7871],
                  [6074, 7865],
                  [6049, 7890],
                  [6045, 7898],
                  [6016, 7914],
                  [6015, 7941],
                  [6007, 7942],
                  [6009, 7953],
                  [6027, 7951],
                  [6038, 7961],
                  [6050, 7965],
                  [6052, 7973],
                  [6042, 7974],
                  [6037, 7981],
                  [6024, 7982],
                  [6015, 7977],
                  [6019, 7970],
                  [6025, 7972],
                  [6039, 7966],
                  [6033, 7959],
                  [6016, 7961],
                  [6009, 7959],
                  [6009, 7967],
                  [6001, 7968],
                  [6007, 7959],
                  [5998, 7945],
                  [5992, 7947],
                  [5994, 7957],
                  [5978, 7952],
                  [5973, 7940],
                  [5971, 7940],
                  [5896, 7920],
                  [5896, 7789],
                  [5880, 7788],
                  [5865, 7810],
                  [5844, 7824],
                  [5821, 7822],
                  [5808, 7817],
                  [5792, 7804],
                  [5791, 7816],
                  [5797, 7825],
                  [5800, 7839],
                  [5784, 7844],
                  [5777, 7842],
                  [5769, 7855],
                  [5758, 7854],
                  [5759, 7864],
                  [5745, 7885],
                  [5745, 7891],
                  [5730, 7895],
                  [5720, 7919],
                  [5729, 7908],
                  [5747, 7906],
                  [5754, 7901],
                  [5759, 7905],
                  [5749, 7914],
                  [5761, 7932],
                  [5773, 7935],
                  [5796, 7935],
                  [5811, 7957],
                  [5811, 7977],
                  [5814, 7983],
                  [5806, 7992],
                  [5793, 7993],
                  [5786, 7986],
                  [5756, 7998],
                  [5733, 7989],
                  [5715, 7976],
                  [5700, 7977],
                  [5698, 7969],
                  [5688, 7974],
                  [5683, 7976],
                  [5682, 7977],
                  [5675, 7981],
                  [5691, 7985],
                  [5677, 8009],
                  [5663, 8022],
                  [5645, 8025],
                  [5644, 8023],
                  [5643, 8019],
                  [5635, 8024],
                  [5634, 8041],
                  [5617, 8046],
                  [5625, 8065],
                  [5633, 8076],
                  [5625, 8081],
                  [5629, 8100],
                  [5641, 8108],
                  [5641, 8117],
                  [5648, 8124],
                  [5665, 8107],
                  [5666, 8105],
                  [5668, 8101],
                  [5674, 8099],
                  [5687, 8107],
                  [5681, 8129],
                  [5686, 8130],
                  [5691, 8133],
                  [5693, 8135],
                  [5695, 8137],
                  [5703, 8139],
                  [5703, 8149],
                  [5714, 8149],
                  [5720, 8154],
                  [5726, 8156],
                  [5726, 8156],
                  [5731, 8158],
                  [5737, 8170],
                  [5761, 8170],
                  [5759, 8164],
                  [5773, 8164],
                  [5775, 8172],
                  [5789, 8175],
                  [5794, 8164],
                  [5819, 8165],
                  [5828, 8154],
                  [5836, 8152],
                  [5852, 8140],
                  [5849, 8131],
                  [5858, 8130],
                  [5857, 8146],
                  [5869, 8141],
                  [5877, 8132],
                  [5887, 8127],
                  [5899, 8135],
                  [5902, 8142],
                  [5912, 8148],
                  [5931, 8149],
                  [5937, 8141],
                  [5941, 8140],
                  [5942, 8141],
                  [5942, 8142],
                  [5947, 8141],
                  [5948, 8143],
                  [5949, 8150],
                  [5960, 8147],
                  [5965, 8151],
                  [5973, 8146],
                  [5973, 8140],
                  [5975, 8137],
                  [5977, 8137],
                  [5978, 8137],
                  [5983, 8133],
                  [5998, 8131],
                  [5999, 8129],
                  [6001, 8125],
                  [6008, 8127],
                  [6015, 8140],
                  [6024, 8133],
                  [6036, 8132],
                  [6055, 8137],
                  [6059, 8151],
                  [6064, 8155],
                  [6058, 8162],
                  [6045, 8164],
                  [6042, 8169],
                  [6025, 8171],
                  [6029, 8176],
                  [6019, 8180],
                  [6030, 8190],
                  [6045, 8198],
                  [6035, 8211],
                  [6046, 8221],
                  [6058, 8224],
                  [6076, 8224],
                  [6075, 8229],
                  [6058, 8233],
                  [6057, 8233],
                  [6054, 8235],
                  [6050, 8235],
                  [6053, 8246],
                  [6044, 8249],
                  [6050, 8265],
                  [6068, 8264],
                  [6069, 8263],
                  [6069, 8262],
                  [6074, 8261],
                  [6074, 8264],
                  [6074, 8265],
                  [6106, 8268],
                  [6132, 8276],
                  [6159, 8280],
                  [6168, 8278],
                  [6168, 8285],
                  [6175, 8290],
                  [6191, 8289],
                  [6205, 8293],
                  [6239, 8299],
                  [6255, 8303],
                  [6258, 8313],
                  [6268, 8313],
                  [6278, 8323],
                  [6285, 8318],
                  [6300, 8318],
                  [6315, 8310],
                  [6322, 8316],
                  [6333, 8317],
                  [6338, 8308],
                  [6339, 8296],
                  [6344, 8294],
                  [6344, 8277],
                  [6344, 8277],
                  [6338, 8277],
                  [6344, 8268],
                  [6348, 8272],
                  [6359, 8269],
                  [6360, 8271],
                  [6361, 8274],
                  [6370, 8270],
                  [6375, 8278],
                  [6381, 8260],
                  [6386, 8270],
                  [6396, 8269],
                  [6399, 8263],
                  [6411, 8259],
                  [6412, 8259],
                  [6408, 8256],
                  [6407, 8255],
                  [6407, 8254],
                  [6407, 8254],
                  [6405, 8249],
                  [6404, 8247],
                  [6410, 8241],
                  [6420, 8248],
                  [6421, 8248],
                  [6425, 8250],
                  [6439, 8243],
                  [6440, 8251],
                  [6450, 8257],
                  [6457, 8256],
                ],
              ],
              [
                [
                  [5978, 7937],
                  [5988, 7950],
                  [5997, 7940],
                  [5998, 7925],
                  [5978, 7937],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "TL",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.63,
            "hc-middle-y": 0.31,
            "hc-key": "TLS",
            "hc-a2": "TL",
            name: "",
            labelrank: "5",
            "country-abbrev": "T.L.",
            subregion: "South-Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "TLS",
            "iso-a2": "TL",
            "woe-id": "23424968",
            continent: "Asia",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [7900, 6231],
                  [7905, 6234],
                  [7912, 6236],
                  [7907, 6226],
                  [7900, 6231],
                ],
              ],
              [
                [
                  [7926, 6242],
                  [7933, 6252],
                  [7986, 6262],
                  [7997, 6258],
                  [7988, 6251],
                  [7971, 6243],
                  [7946, 6236],
                  [7930, 6227],
                  [7928, 6236],
                  [7926, 6242],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "TM",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.38,
            "hc-middle-y": 0.41,
            "hc-key": "TKM",
            "hc-a2": "TM",
            name: "",
            labelrank: "4",
            "country-abbrev": "Turkm.",
            subregion: "Central Asia",
            "region-wb": "Europe & Central Asia",
            "iso-a3": "TKM",
            "iso-a2": "TM",
            "woe-id": "23424972",
            continent: "Asia",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [5928, 7810],
                [5936, 7797],
                [5952, 7802],
                [5945, 7818],
                [5951, 7819],
                [5956, 7830],
                [5970, 7823],
                [5960, 7835],
                [5970, 7836],
                [5974, 7840],
                [5982, 7832],
                [5989, 7832],
                [5999, 7823],
                [6016, 7820],
                [6013, 7811],
                [6022, 7806],
                [6016, 7803],
                [6018, 7791],
                [6027, 7786],
                [6040, 7786],
                [6052, 7783],
                [6058, 7788],
                [6070, 7782],
                [6079, 7760],
                [6084, 7758],
                [6087, 7743],
                [6117, 7722],
                [6136, 7707],
                [6142, 7707],
                [6180, 7682],
                [6188, 7683],
                [6208, 7675],
                [6207, 7653],
                [6200, 7651],
                [6184, 7660],
                [6177, 7648],
                [6164, 7648],
                [6155, 7643],
                [6155, 7638],
                [6146, 7615],
                [6113, 7602],
                [6105, 7588],
                [6083, 7578],
                [6075, 7587],
                [6060, 7588],
                [6052, 7594],
                [6046, 7628],
                [6025, 7628],
                [6015, 7641],
                [5996, 7651],
                [5996, 7657],
                [5979, 7664],
                [5967, 7662],
                [5961, 7667],
                [5937, 7673],
                [5933, 7683],
                [5928, 7681],
                [5910, 7683],
                [5906, 7677],
                [5880, 7677],
                [5863, 7666],
                [5861, 7658],
                [5844, 7651],
                [5836, 7652],
                [5833, 7665],
                [5833, 7692],
                [5837, 7705],
                [5829, 7711],
                [5826, 7720],
                [5811, 7723],
                [5815, 7727],
                [5830, 7727],
                [5821, 7735],
                [5825, 7741],
                [5801, 7745],
                [5801, 7760],
                [5807, 7777],
                [5812, 7770],
                [5825, 7769],
                [5830, 7765],
                [5848, 7768],
                [5860, 7776],
                [5859, 7782],
                [5841, 7794],
                [5835, 7815],
                [5813, 7816],
                [5803, 7804],
                [5803, 7791],
                [5792, 7804],
                [5808, 7817],
                [5821, 7822],
                [5844, 7824],
                [5865, 7810],
                [5880, 7788],
                [5896, 7789],
                [5927, 7786],
                [5925, 7808],
                [5928, 7810],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "KH",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.83,
            "hc-middle-y": 0.49,
            "hc-key": "KHM",
            "hc-a2": "KH",
            name: t("Countries.kh", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Camb.",
            subregion: "South-Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "KHM",
            "iso-a2": "KH",
            "woe-id": "23424776",
            continent: "Asia",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [7324, 6811],
                [7318, 6815],
                [7299, 6813],
                [7301, 6830],
                [7295, 6832],
                [7291, 6824],
                [7284, 6826],
                [7285, 6838],
                [7278, 6847],
                [7273, 6859],
                [7273, 6859],
                [7273, 6859],
                [7273, 6859],
                [7272, 6862],
                [7274, 6870],
                [7266, 6877],
                [7266, 6887],
                [7261, 6904],
                [7266, 6904],
                [7283, 6926],
                [7301, 6930],
                [7310, 6928],
                [7333, 6930],
                [7341, 6924],
                [7345, 6928],
                [7350, 6921],
                [7355, 6922],
                [7367, 6915],
                [7373, 6919],
                [7368, 6928],
                [7384, 6935],
                [7397, 6927],
                [7414, 6938],
                [7408, 6921],
                [7416, 6903],
                [7412, 6888],
                [7414, 6868],
                [7403, 6866],
                [7390, 6857],
                [7381, 6857],
                [7382, 6848],
                [7370, 6851],
                [7363, 6847],
                [7365, 6837],
                [7374, 6827],
                [7374, 6821],
                [7362, 6829],
                [7349, 6824],
                [7341, 6826],
                [7335, 6814],
                [7324, 6811],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "MN",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.49,
            "hc-middle-y": 0.52,
            "hc-key": "MNG",
            "hc-a2": "MN",
            name: "",
            labelrank: "3",
            "country-abbrev": "Mong.",
            subregion: "Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "MNG",
            "iso-a2": "MN",
            "woe-id": "23424887",
            continent: "Asia",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [7708, 8022],
                [7710, 8018],
                [7719, 8025],
                [7715, 8030],
                [7728, 8032],
                [7738, 8029],
                [7754, 8018],
                [7760, 8009],
                [7772, 7999],
                [7778, 7983],
                [7772, 7978],
                [7746, 7984],
                [7729, 7983],
                [7713, 7975],
                [7705, 7978],
                [7702, 7969],
                [7681, 7968],
                [7670, 7953],
                [7669, 7946],
                [7653, 7936],
                [7620, 7934],
                [7606, 7918],
                [7594, 7911],
                [7563, 7917],
                [7559, 7922],
                [7546, 7923],
                [7538, 7919],
                [7528, 7899],
                [7541, 7882],
                [7544, 7873],
                [7514, 7858],
                [7499, 7840],
                [7472, 7829],
                [7451, 7827],
                [7433, 7829],
                [7392, 7823],
                [7346, 7804],
                [7340, 7798],
                [7325, 7801],
                [7325, 7808],
                [7302, 7804],
                [7283, 7813],
                [7252, 7819],
                [7241, 7831],
                [7193, 7837],
                [7177, 7833],
                [7110, 7841],
                [7085, 7839],
                [7083, 7846],
                [7072, 7856],
                [7060, 7883],
                [7055, 7884],
                [7056, 7894],
                [7046, 7893],
                [7014, 7908],
                [7002, 7918],
                [6979, 7921],
                [6971, 7920],
                [6947, 7922],
                [6924, 7927],
                [6917, 7938],
                [6919, 7947],
                [6928, 7957],
                [6924, 7968],
                [6929, 7977],
                [6922, 7993],
                [6912, 8005],
                [6908, 8018],
                [6899, 8026],
                [6891, 8024],
                [6885, 8032],
                [6870, 8030],
                [6856, 8039],
                [6856, 8044],
                [6837, 8053],
                [6833, 8061],
                [6834, 8075],
                [6843, 8079],
                [6844, 8085],
                [6865, 8085],
                [6889, 8095],
                [6887, 8103],
                [6928, 8123],
                [6940, 8124],
                [6950, 8133],
                [6962, 8133],
                [6966, 8139],
                [6976, 8133],
                [6985, 8137],
                [6987, 8131],
                [7023, 8128],
                [7026, 8116],
                [7034, 8107],
                [7061, 8102],
                [7071, 8107],
                [7086, 8102],
                [7103, 8102],
                [7113, 8096],
                [7137, 8109],
                [7142, 8127],
                [7134, 8131],
                [7128, 8145],
                [7135, 8163],
                [7143, 8173],
                [7155, 8178],
                [7160, 8189],
                [7193, 8174],
                [7207, 8174],
                [7233, 8163],
                [7257, 8158],
                [7256, 8149],
                [7261, 8128],
                [7269, 8123],
                [7300, 8112],
                [7314, 8112],
                [7322, 8118],
                [7349, 8125],
                [7369, 8122],
                [7376, 8118],
                [7388, 8119],
                [7405, 8107],
                [7426, 8104],
                [7426, 8094],
                [7444, 8081],
                [7462, 8082],
                [7492, 8075],
                [7508, 8074],
                [7526, 8082],
                [7547, 8084],
                [7576, 8091],
                [7581, 8100],
                [7613, 8117],
                [7627, 8116],
                [7645, 8103],
                [7656, 8102],
                [7670, 8107],
                [7684, 8100],
                [7658, 8051],
                [7658, 8041],
                [7649, 8035],
                [7659, 8020],
                [7671, 8026],
                [7689, 8026],
                [7702, 8018],
                [7708, 8022],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "KP",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.33,
            "hc-middle-y": 0.7,
            "hc-key": "PRK",
            "hc-a2": "KP",
            name: "",
            labelrank: "3",
            "country-abbrev": "N.K.",
            subregion: "Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "PRK",
            "iso-a2": "KP",
            "woe-id": "23424865",
            continent: "Asia",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [7978, 7668],
                [7962, 7668],
                [7946, 7675],
                [7947, 7666],
                [7929, 7673],
                [7936, 7677],
                [7919, 7678],
                [7924, 7682],
                [7928, 7694],
                [7938, 7698],
                [7933, 7702],
                [7942, 7719],
                [7937, 7726],
                [7910, 7738],
                [7910, 7746],
                [7925, 7760],
                [7941, 7765],
                [7951, 7774],
                [7958, 7774],
                [7973, 7793],
                [7976, 7801],
                [7985, 7806],
                [7995, 7795],
                [8021, 7791],
                [8026, 7798],
                [8018, 7812],
                [8043, 7814],
                [8056, 7828],
                [8067, 7828],
                [8071, 7847],
                [8079, 7847],
                [8091, 7831],
                [8095, 7826],
                [8096, 7823],
                [8088, 7824],
                [8078, 7815],
                [8065, 7797],
                [8070, 7791],
                [8067, 7772],
                [8053, 7767],
                [8049, 7759],
                [8035, 7753],
                [8036, 7750],
                [8003, 7734],
                [7999, 7721],
                [8001, 7714],
                [8010, 7712],
                [8028, 7695],
                [8018, 7685],
                [7992, 7685],
                [7978, 7668],
                [7978, 7668],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "KR",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.44,
            "hc-middle-y": 0.49,
            "hc-key": "KOR",
            "hc-a2": "KR",
            name: t("Countries.kr", { ns: region }),
            labelrank: "2",
            "country-abbrev": "S.K.",
            subregion: "Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "KOR",
            "iso-a2": "KR",
            "woe-id": "23424868",
            continent: "Asia",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [7992, 7685],
                [8018, 7685],
                [8028, 7695],
                [8035, 7679],
                [8056, 7650],
                [8060, 7633],
                [8058, 7613],
                [8063, 7609],
                [8060, 7590],
                [8052, 7578],
                [8038, 7572],
                [8039, 7566],
                [8029, 7565],
                [8019, 7571],
                [8019, 7564],
                [8004, 7563],
                [7992, 7554],
                [7994, 7564],
                [7974, 7548],
                [7966, 7559],
                [7960, 7575],
                [7971, 7577],
                [7968, 7582],
                [7972, 7594],
                [7982, 7602],
                [7973, 7612],
                [7968, 7633],
                [7973, 7642],
                [7985, 7638],
                [7977, 7649],
                [7982, 7650],
                [7966, 7664],
                [7978, 7668],
                [7978, 7668],
                [7978, 7668],
                [7978, 7672],
                [7992, 7685],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "MM",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.18,
            "hc-middle-y": 0.49,
            "hc-key": "MMR",
            "hc-a2": "MM",
            name: "",
            labelrank: "3",
            "country-abbrev": "Myan.",
            subregion: "South-Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "MMR",
            "iso-a2": "MM",
            "woe-id": "23424763",
            continent: "Asia",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [7227, 7146],
                [7214, 7138],
                [7208, 7123],
                [7199, 7119],
                [7195, 7108],
                [7191, 7112],
                [7172, 7100],
                [7166, 7102],
                [7163, 7093],
                [7149, 7088],
                [7134, 7092],
                [7127, 7080],
                [7123, 7065],
                [7126, 7055],
                [7115, 7053],
                [7126, 7036],
                [7124, 7032],
                [7137, 7016],
                [7146, 7008],
                [7147, 6999],
                [7154, 6985],
                [7149, 6957],
                [7138, 6951],
                [7141, 6941],
                [7150, 6929],
                [7161, 6919],
                [7167, 6909],
                [7169, 6880],
                [7175, 6875],
                [7182, 6852],
                [7169, 6831],
                [7156, 6819],
                [7156, 6809],
                [7150, 6798],
                [7140, 6800],
                [7148, 6805],
                [7147, 6820],
                [7140, 6814],
                [7139, 6827],
                [7155, 6826],
                [7153, 6832],
                [7156, 6851],
                [7150, 6852],
                [7149, 6844],
                [7142, 6853],
                [7153, 6856],
                [7154, 6865],
                [7132, 6869],
                [7142, 6873],
                [7143, 6878],
                [7151, 6871],
                [7151, 6893],
                [7138, 6908],
                [7128, 6944],
                [7125, 6974],
                [7121, 6977],
                [7106, 7015],
                [7101, 7019],
                [7098, 6999],
                [7093, 6993],
                [7083, 6995],
                [7083, 6988],
                [7071, 6984],
                [7058, 6969],
                [7045, 6970],
                [7022, 6978],
                [7024, 6993],
                [7034, 7024],
                [7028, 7047],
                [7020, 7062],
                [7006, 7064],
                [7001, 7077],
                [7011, 7075],
                [7005, 7083],
                [7014, 7081],
                [6997, 7101],
                [6987, 7098],
                [6980, 7104],
                [6968, 7119],
                [6965, 7130],
                [6966, 7143],
                [6976, 7138],
                [6974, 7159],
                [6977, 7164],
                [6986, 7159],
                [6991, 7171],
                [6990, 7190],
                [6997, 7194],
                [6999, 7210],
                [6995, 7222],
                [7019, 7216],
                [7024, 7231],
                [7037, 7253],
                [7034, 7264],
                [7045, 7275],
                [7050, 7285],
                [7046, 7298],
                [7079, 7323],
                [7097, 7326],
                [7108, 7319],
                [7100, 7334],
                [7114, 7343],
                [7114, 7353],
                [7120, 7363],
                [7137, 7351],
                [7142, 7332],
                [7154, 7333],
                [7156, 7303],
                [7150, 7287],
                [7154, 7280],
                [7137, 7264],
                [7128, 7260],
                [7120, 7244],
                [7125, 7225],
                [7123, 7217],
                [7139, 7225],
                [7151, 7223],
                [7159, 7209],
                [7159, 7196],
                [7178, 7192],
                [7172, 7182],
                [7174, 7174],
                [7167, 7164],
                [7191, 7161],
                [7191, 7151],
                [7198, 7142],
                [7213, 7144],
                [7225, 7152],
                [7227, 7146],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "LA",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.5,
            "hc-middle-y": 0.26,
            "hc-key": "LAO",
            "hc-a2": "LA",
            name: t("Countries.la", { ns: region }),
            labelrank: "4",
            "country-abbrev": "Laos",
            subregion: "South-Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "LAO",
            "iso-a2": "LA",
            "woe-id": "23424872",
            continent: "Asia",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [7195, 7108],
                [7199, 7119],
                [7208, 7123],
                [7214, 7138],
                [7227, 7146],
                [7230, 7134],
                [7243, 7133],
                [7244, 7154],
                [7237, 7166],
                [7241, 7173],
                [7255, 7171],
                [7280, 7146],
                [7277, 7138],
                [7284, 7125],
                [7300, 7118],
                [7312, 7127],
                [7328, 7118],
                [7321, 7111],
                [7338, 7101],
                [7334, 7092],
                [7325, 7086],
                [7317, 7089],
                [7306, 7077],
                [7331, 7061],
                [7343, 7059],
                [7342, 7051],
                [7353, 7043],
                [7361, 7027],
                [7385, 7006],
                [7385, 6998],
                [7391, 6990],
                [7407, 6979],
                [7403, 6970],
                [7418, 6956],
                [7414, 6938],
                [7397, 6927],
                [7384, 6935],
                [7368, 6928],
                [7373, 6919],
                [7367, 6915],
                [7355, 6922],
                [7350, 6921],
                [7345, 6928],
                [7352, 6930],
                [7357, 6947],
                [7353, 6950],
                [7359, 6966],
                [7352, 6978],
                [7341, 6981],
                [7332, 6993],
                [7334, 7018],
                [7319, 7033],
                [7310, 7047],
                [7292, 7051],
                [7271, 7033],
                [7254, 7044],
                [7226, 7021],
                [7219, 7025],
                [7227, 7039],
                [7223, 7050],
                [7229, 7058],
                [7231, 7069],
                [7229, 7085],
                [7206, 7084],
                [7204, 7091],
                [7209, 7103],
                [7201, 7110],
                [7195, 7108],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "AF",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.38,
            "hc-middle-y": 0.53,
            "hc-key": "AFG",
            "hc-a2": "AF",
            name: "",
            labelrank: "3",
            "country-abbrev": "Afg.",
            subregion: "Southern Asia",
            "region-wb": "South Asia",
            "iso-a3": "AFG",
            "iso-a2": "AF",
            "woe-id": "23424739",
            continent: "Asia",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [6453, 7648],
                [6448, 7650],
                [6438, 7645],
                [6443, 7641],
                [6430, 7635],
                [6416, 7637],
                [6385, 7634],
                [6374, 7631],
                [6360, 7620],
                [6357, 7622],
                [6343, 7608],
                [6356, 7592],
                [6357, 7580],
                [6352, 7571],
                [6341, 7562],
                [6340, 7542],
                [6325, 7538],
                [6309, 7542],
                [6304, 7538],
                [6312, 7531],
                [6318, 7518],
                [6306, 7510],
                [6296, 7510],
                [6292, 7496],
                [6286, 7488],
                [6289, 7473],
                [6280, 7463],
                [6273, 7462],
                [6255, 7469],
                [6238, 7459],
                [6243, 7453],
                [6231, 7449],
                [6219, 7452],
                [6202, 7440],
                [6197, 7405],
                [6163, 7395],
                [6147, 7396],
                [6135, 7390],
                [6120, 7394],
                [6088, 7391],
                [6040, 7406],
                [6067, 7437],
                [6064, 7455],
                [6039, 7458],
                [6039, 7483],
                [6031, 7512],
                [6041, 7525],
                [6030, 7528],
                [6029, 7543],
                [6034, 7550],
                [6041, 7551],
                [6035, 7557],
                [6046, 7567],
                [6047, 7583],
                [6052, 7594],
                [6060, 7588],
                [6075, 7587],
                [6083, 7578],
                [6105, 7588],
                [6113, 7602],
                [6146, 7615],
                [6155, 7638],
                [6155, 7643],
                [6164, 7648],
                [6177, 7648],
                [6184, 7660],
                [6200, 7651],
                [6207, 7653],
                [6221, 7653],
                [6228, 7647],
                [6244, 7647],
                [6251, 7638],
                [6270, 7650],
                [6279, 7651],
                [6287, 7644],
                [6293, 7648],
                [6295, 7660],
                [6314, 7659],
                [6317, 7664],
                [6314, 7672],
                [6332, 7689],
                [6348, 7684],
                [6346, 7672],
                [6356, 7671],
                [6351, 7643],
                [6357, 7630],
                [6363, 7630],
                [6376, 7639],
                [6387, 7641],
                [6390, 7647],
                [6406, 7656],
                [6420, 7655],
                [6416, 7648],
                [6446, 7654],
                [6453, 7648],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "PK",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.29,
            "hc-middle-y": 0.74,
            "hc-key": "PAK",
            "hc-a2": "PK",
            name: t("Countries.pk", { ns: region }),
            labelrank: "2",
            "country-abbrev": "Pak.",
            subregion: "Southern Asia",
            "region-wb": "South Asia",
            "iso-a3": "PAK",
            "iso-a2": "PK",
            "woe-id": "23424922",
            continent: "Asia",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [6509, 7595],
                [6517, 7577],
                [6502, 7564],
                [6487, 7563],
                [6479, 7557],
                [6435, 7566],
                [6425, 7561],
                [6420, 7552],
                [6427, 7547],
                [6425, 7541],
                [6435, 7539],
                [6426, 7529],
                [6431, 7525],
                [6427, 7513],
                [6436, 7506],
                [6436, 7501],
                [6447, 7502],
                [6448, 7490],
                [6457, 7490],
                [6467, 7483],
                [6451, 7476],
                [6441, 7465],
                [6446, 7445],
                [6437, 7439],
                [6422, 7421],
                [6425, 7416],
                [6408, 7408],
                [6404, 7395],
                [6395, 7379],
                [6379, 7371],
                [6364, 7345],
                [6334, 7337],
                [6319, 7347],
                [6297, 7321],
                [6293, 7309],
                [6304, 7302],
                [6314, 7300],
                [6311, 7283],
                [6317, 7274],
                [6328, 7274],
                [6328, 7266],
                [6340, 7242],
                [6341, 7234],
                [6331, 7228],
                [6324, 7234],
                [6308, 7226],
                [6296, 7230],
                [6272, 7230],
                [6272, 7220],
                [6256, 7216],
                [6256, 7216],
                [6256, 7216],
                [6256, 7216],
                [6239, 7215],
                [6231, 7223],
                [6225, 7242],
                [6228, 7244],
                [6211, 7247],
                [6213, 7259],
                [6204, 7271],
                [6182, 7263],
                [6148, 7261],
                [6120, 7263],
                [6118, 7258],
                [6088, 7260],
                [6065, 7253],
                [6061, 7258],
                [6064, 7276],
                [6069, 7291],
                [6081, 7294],
                [6082, 7299],
                [6096, 7304],
                [6107, 7303],
                [6112, 7318],
                [6108, 7323],
                [6097, 7322],
                [6095, 7355],
                [6070, 7364],
                [6061, 7374],
                [6052, 7391],
                [6040, 7406],
                [6088, 7391],
                [6120, 7394],
                [6135, 7390],
                [6147, 7396],
                [6163, 7395],
                [6197, 7405],
                [6202, 7440],
                [6219, 7452],
                [6231, 7449],
                [6243, 7453],
                [6238, 7459],
                [6255, 7469],
                [6273, 7462],
                [6280, 7463],
                [6289, 7473],
                [6286, 7488],
                [6292, 7496],
                [6296, 7510],
                [6306, 7510],
                [6318, 7518],
                [6312, 7531],
                [6304, 7538],
                [6309, 7542],
                [6325, 7538],
                [6340, 7542],
                [6341, 7562],
                [6352, 7571],
                [6357, 7580],
                [6356, 7592],
                [6343, 7608],
                [6357, 7622],
                [6360, 7620],
                [6374, 7631],
                [6385, 7634],
                [6416, 7637],
                [6430, 7635],
                [6443, 7641],
                [6467, 7637],
                [6468, 7632],
                [6480, 7630],
                [6485, 7622],
                [6483, 7610],
                [6491, 7600],
                [6502, 7603],
                [6509, 7595],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "BN",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.5,
            "hc-middle-y": 0.56,
            "hc-key": "BRN",
            "hc-a2": "BN",
            name: t("Countries.bn", { ns: region }),
            labelrank: "6",
            "country-abbrev": "Brunei",
            subregion: "South-Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "BRN",
            "iso-a2": "BN",
            "woe-id": "23424773",
            continent: "Asia",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [7635, 6646],
                  [7638, 6647],
                  [7638, 6649],
                  [7645, 6632],
                  [7637, 6633],
                  [7636, 6639],
                  [7635, 6646],
                ],
              ],
              [
                [
                  [7605, 6640],
                  [7620, 6643],
                  [7636, 6653],
                  [7634, 6648],
                  [7627, 6644],
                  [7630, 6635],
                  [7622, 6623],
                  [7612, 6636],
                  [7605, 6640],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "BT",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.49,
            "hc-middle-y": 0.49,
            "hc-key": "BTN",
            "hc-a2": "BT",
            name: "",
            labelrank: "5",
            "country-abbrev": "Bhutan",
            subregion: "Southern Asia",
            "region-wb": "South Asia",
            "iso-a3": "BTN",
            "iso-a2": "BT",
            "woe-id": "23424770",
            continent: "Asia",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [6865, 7325],
                [6870, 7334],
                [6885, 7351],
                [6905, 7358],
                [6915, 7354],
                [6912, 7349],
                [6930, 7345],
                [6936, 7349],
                [6947, 7344],
                [6946, 7339],
                [6950, 7328],
                [6956, 7330],
                [6959, 7313],
                [6943, 7308],
                [6915, 7308],
                [6909, 7311],
                [6893, 7305],
                [6879, 7310],
                [6871, 7309],
                [6861, 7320],
                [6865, 7325],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "VN",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.41,
            "hc-middle-y": 0.96,
            "hc-key": "VNM",
            "hc-a2": "VN",
            name: t("Countries.vn", { ns: region }),
            labelrank: "2",
            "country-abbrev": "Viet.",
            subregion: "South-Eastern Asia",
            "region-wb": "East Asia & Pacific",
            "iso-a3": "VNM",
            "iso-a2": "VN",
            "woe-id": "23424984",
            continent: "Asia",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [7428, 7143],
                [7412, 7137],
                [7422, 7128],
                [7394, 7128],
                [7400, 7120],
                [7392, 7120],
                [7384, 7115],
                [7386, 7105],
                [7370, 7098],
                [7364, 7087],
                [7361, 7071],
                [7358, 7068],
                [7372, 7046],
                [7382, 7041],
                [7388, 7021],
                [7425, 6986],
                [7434, 6984],
                [7441, 6970],
                [7451, 6959],
                [7460, 6939],
                [7466, 6914],
                [7464, 6899],
                [7471, 6885],
                [7471, 6877],
                [7463, 6877],
                [7465, 6850],
                [7458, 6839],
                [7431, 6826],
                [7407, 6810],
                [7399, 6814],
                [7385, 6794],
                [7383, 6785],
                [7376, 6788],
                [7375, 6780],
                [7356, 6773],
                [7343, 6758],
                [7333, 6764],
                [7337, 6794],
                [7342, 6799],
                [7334, 6805],
                [7311, 6800],
                [7306, 6810],
                [7313, 6806],
                [7328, 6806],
                [7324, 6811],
                [7335, 6814],
                [7341, 6826],
                [7349, 6824],
                [7362, 6829],
                [7374, 6821],
                [7374, 6827],
                [7365, 6837],
                [7363, 6847],
                [7370, 6851],
                [7382, 6848],
                [7381, 6857],
                [7390, 6857],
                [7403, 6866],
                [7414, 6868],
                [7412, 6888],
                [7416, 6903],
                [7408, 6921],
                [7414, 6938],
                [7418, 6956],
                [7403, 6970],
                [7407, 6979],
                [7391, 6990],
                [7385, 6998],
                [7385, 7006],
                [7361, 7027],
                [7353, 7043],
                [7342, 7051],
                [7343, 7059],
                [7331, 7061],
                [7306, 7077],
                [7317, 7089],
                [7325, 7086],
                [7334, 7092],
                [7338, 7101],
                [7321, 7111],
                [7328, 7118],
                [7312, 7127],
                [7300, 7118],
                [7284, 7125],
                [7277, 7138],
                [7280, 7146],
                [7255, 7171],
                [7264, 7183],
                [7280, 7173],
                [7290, 7183],
                [7296, 7177],
                [7300, 7184],
                [7310, 7175],
                [7317, 7185],
                [7320, 7180],
                [7334, 7188],
                [7336, 7195],
                [7349, 7201],
                [7365, 7187],
                [7383, 7188],
                [7391, 7182],
                [7385, 7172],
                [7388, 7159],
                [7409, 7147],
                [7423, 7148],
                [7428, 7143],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "NP",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.52,
            "hc-middle-y": 0.55,
            "hc-key": "NPL",
            "hc-a2": "NP",
            name: t("Countries.np", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Nepal",
            subregion: "Southern Asia",
            "region-wb": "South Asia",
            "iso-a3": "NPL",
            "iso-a2": "NP",
            "woe-id": "23424911",
            continent: "Asia",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [6843, 7342],
                [6838, 7318],
                [6844, 7307],
                [6841, 7298],
                [6819, 7294],
                [6811, 7302],
                [6801, 7296],
                [6789, 7303],
                [6775, 7301],
                [6768, 7310],
                [6759, 7306],
                [6740, 7316],
                [6738, 7325],
                [6724, 7331],
                [6716, 7328],
                [6685, 7330],
                [6682, 7337],
                [6674, 7336],
                [6664, 7343],
                [6659, 7342],
                [6642, 7350],
                [6637, 7358],
                [6623, 7366],
                [6614, 7366],
                [6605, 7373],
                [6612, 7388],
                [6610, 7391],
                [6618, 7404],
                [6633, 7416],
                [6636, 7411],
                [6644, 7422],
                [6665, 7421],
                [6667, 7412],
                [6678, 7408],
                [6687, 7399],
                [6697, 7398],
                [6707, 7384],
                [6724, 7386],
                [6728, 7375],
                [6741, 7366],
                [6756, 7365],
                [6753, 7356],
                [6771, 7357],
                [6780, 7343],
                [6793, 7344],
                [6796, 7349],
                [6814, 7341],
                [6843, 7342],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "KG",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.49,
            "hc-middle-y": 0.45,
            "hc-key": "KGZ",
            "hc-a2": "KG",
            name: "",
            labelrank: "4",
            "country-abbrev": "Kgz.",
            subregion: "Central Asia",
            "region-wb": "Europe & Central Asia",
            "iso-a3": "KGZ",
            "iso-a2": "KG",
            "woe-id": "23424864",
            continent: "Asia",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [6337, 7821],
                [6339, 7833],
                [6351, 7841],
                [6364, 7842],
                [6389, 7836],
                [6412, 7828],
                [6410, 7834],
                [6416, 7850],
                [6432, 7857],
                [6462, 7843],
                [6475, 7841],
                [6479, 7845],
                [6499, 7844],
                [6514, 7848],
                [6521, 7845],
                [6559, 7844],
                [6579, 7841],
                [6587, 7829],
                [6601, 7828],
                [6610, 7819],
                [6609, 7813],
                [6583, 7805],
                [6555, 7791],
                [6547, 7779],
                [6529, 7777],
                [6515, 7779],
                [6508, 7776],
                [6504, 7765],
                [6495, 7755],
                [6493, 7758],
                [6476, 7753],
                [6474, 7764],
                [6462, 7758],
                [6452, 7761],
                [6438, 7746],
                [6427, 7745],
                [6422, 7736],
                [6425, 7729],
                [6416, 7724],
                [6401, 7720],
                [6370, 7721],
                [6360, 7718],
                [6360, 7724],
                [6352, 7729],
                [6330, 7723],
                [6323, 7729],
                [6315, 7726],
                [6299, 7728],
                [6289, 7726],
                [6289, 7742],
                [6308, 7750],
                [6325, 7744],
                [6337, 7751],
                [6346, 7754],
                [6358, 7748],
                [6378, 7764],
                [6385, 7760],
                [6401, 7770],
                [6373, 7778],
                [6373, 7783],
                [6364, 7784],
                [6361, 7793],
                [6351, 7783],
                [6344, 7781],
                [6332, 7786],
                [6314, 7798],
                [6346, 7820],
                [6337, 7821],
              ],
              [
                [6327, 7738],
                [6323, 7738],
                [6326, 7735],
                [6330, 7737],
                [6327, 7738],
              ],
              [
                [6361, 7739],
                [6362, 7742],
                [6361, 7742],
                [6358, 7741],
                [6361, 7739],
              ],
              [
                [6344, 7744],
                [6338, 7748],
                [6340, 7742],
                [6345, 7739],
                [6344, 7744],
              ],
            ],
          },
        },
      ],
    };
  } else if (region === "eclac") {
    return {
      title: "Latin American and Carribean",
      version: "2.0.1",
      type: "FeatureCollection",
      copyright:
        "Copyright (c) 2022 Highsoft AS, Based on data from Natural Earth",
      copyrightShort: "Natural Earth",
      copyrightUrl: "http://www.naturalearthdata.com",
      crs: { type: "name", properties: { name: "urn:ogc:def:crs:EPSG:54003" } },
      "hc-transform": {
        default: {
          crs: "+proj=mill +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R_A +datum=WGS84 +units=m +no_defs",
          scale: 1.71096809122e-5,
          jsonres: 15.5,
          jsonmarginX: -999,
          jsonmarginY: 9851.0,
          xoffset: -19753395.3101,
          yoffset: 12635908.1982,
        },
      },
      features: [
        {
          type: "Feature",
          id: "BR",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.54,
            "hc-middle-y": 0.34,
            "hc-key": "BRA",
            "hc-a2": "BR",
            name: t("Countries.br", { ns: region }),
            labelrank: "2",
            "country-abbrev": "Brazil",
            subregion: "South America",
            "region-wb": "Latin America & Caribbean",
            "iso-a3": "BRA",
            "iso-a2": "BR",
            "woe-id": "23424768",
            continent: "South America",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [2774, 6496],
                  [2812, 6492],
                  [2799, 6457],
                  [2771, 6447],
                  [2747, 6448],
                  [2741, 6483],
                  [2755, 6497],
                  [2774, 6496],
                ],
              ],
              [
                [
                  [2661, 5478],
                  [2673, 5503],
                  [2689, 5510],
                  [2687, 5523],
                  [2672, 5507],
                  [2629, 5546],
                  [2611, 5553],
                  [2600, 5566],
                  [2588, 5559],
                  [2582, 5575],
                  [2564, 5590],
                  [2541, 5588],
                  [2576, 5623],
                  [2595, 5650],
                  [2621, 5669],
                  [2652, 5684],
                  [2657, 5712],
                  [2650, 5732],
                  [2629, 5734],
                  [2630, 5735],
                  [2629, 5738],
                  [2640, 5762],
                  [2639, 5781],
                  [2628, 5789],
                  [2605, 5784],
                  [2599, 5825],
                  [2576, 5843],
                  [2569, 5838],
                  [2530, 5843],
                  [2535, 5877],
                  [2525, 5901],
                  [2542, 5961],
                  [2535, 5981],
                  [2518, 5989],
                  [2516, 6017],
                  [2466, 6019],
                  [2456, 6093],
                  [2439, 6103],
                  [2416, 6101],
                  [2406, 6113],
                  [2380, 6127],
                  [2341, 6133],
                  [2323, 6147],
                  [2311, 6172],
                  [2314, 6200],
                  [2309, 6215],
                  [2274, 6209],
                  [2226, 6177],
                  [2188, 6178],
                  [2156, 6176],
                  [2160, 6223],
                  [2140, 6208],
                  [2111, 6206],
                  [2107, 6220],
                  [2081, 6224],
                  [2088, 6233],
                  [2057, 6279],
                  [2065, 6298],
                  [2083, 6312],
                  [2080, 6322],
                  [2089, 6349],
                  [2119, 6368],
                  [2152, 6378],
                  [2176, 6376],
                  [2192, 6458],
                  [2187, 6485],
                  [2173, 6495],
                  [2174, 6517],
                  [2201, 6519],
                  [2194, 6531],
                  [2180, 6531],
                  [2180, 6550],
                  [2230, 6550],
                  [2254, 6561],
                  [2261, 6534],
                  [2268, 6536],
                  [2289, 6521],
                  [2306, 6519],
                  [2319, 6533],
                  [2348, 6546],
                  [2371, 6571],
                  [2351, 6572],
                  [2346, 6605],
                  [2333, 6616],
                  [2369, 6616],
                  [2388, 6606],
                  [2389, 6618],
                  [2424, 6625],
                  [2453, 6645],
                  [2448, 6652],
                  [2471, 6649],
                  [2467, 6632],
                  [2484, 6615],
                  [2475, 6606],
                  [2470, 6579],
                  [2477, 6555],
                  [2505, 6535],
                  [2520, 6547],
                  [2556, 6559],
                  [2574, 6557],
                  [2588, 6554],
                  [2589, 6574],
                  [2618, 6574],
                  [2629, 6568],
                  [2643, 6562],
                  [2667, 6569],
                  [2677, 6564],
                  [2716, 6618],
                  [2720, 6630],
                  [2733, 6614],
                  [2735, 6589],
                  [2745, 6564],
                  [2768, 6549],
                  [2764, 6515],
                  [2770, 6500],
                  [2748, 6500],
                  [2725, 6486],
                  [2746, 6447],
                  [2788, 6443],
                  [2817, 6475],
                  [2833, 6484],
                  [2878, 6473],
                  [2889, 6461],
                  [2913, 6460],
                  [2927, 6444],
                  [2923, 6421],
                  [2938, 6417],
                  [2951, 6434],
                  [2988, 6419],
                  [3012, 6415],
                  [3060, 6416],
                  [3105, 6392],
                  [3143, 6356],
                  [3191, 6350],
                  [3200, 6339],
                  [3214, 6289],
                  [3213, 6267],
                  [3198, 6230],
                  [3166, 6191],
                  [3151, 6183],
                  [3118, 6128],
                  [3091, 6110],
                  [3088, 6067],
                  [3094, 6032],
                  [3083, 5992],
                  [3085, 5977],
                  [3071, 5961],
                  [3069, 5925],
                  [3028, 5860],
                  [3032, 5846],
                  [3002, 5828],
                  [2999, 5815],
                  [2932, 5816],
                  [2900, 5795],
                  [2855, 5775],
                  [2829, 5754],
                  [2806, 5719],
                  [2804, 5698],
                  [2812, 5677],
                  [2802, 5641],
                  [2771, 5611],
                  [2756, 5579],
                  [2729, 5587],
                  [2723, 5559],
                  [2700, 5537],
                  [2688, 5493],
                  [2666, 5472],
                  [2661, 5475],
                  [2661, 5478],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "EC",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.71,
            "hc-middle-y": 0.37,
            "hc-key": "ECU",
            "hc-a2": "EC",
            name: t("Countries.ec", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Ecu.",
            subregion: "South America",
            "region-wb": "Latin America & Caribbean",
            "iso-a3": "ECU",
            "iso-a2": "EC",
            "woe-id": "23424801",
            continent: "South America",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [1561, 6490],
                  [1607, 6478],
                  [1580, 6480],
                  [1544, 6470],
                  [1561, 6490],
                ],
              ],
              [
                [
                  [1915, 6542],
                  [1955, 6519],
                  [1957, 6511],
                  [1986, 6507],
                  [1990, 6513],
                  [2020, 6497],
                  [2011, 6455],
                  [1978, 6425],
                  [1943, 6412],
                  [1929, 6401],
                  [1920, 6367],
                  [1908, 6353],
                  [1895, 6367],
                  [1865, 6380],
                  [1876, 6386],
                  [1870, 6401],
                  [1887, 6422],
                  [1874, 6420],
                  [1854, 6432],
                  [1859, 6443],
                  [1853, 6469],
                  [1879, 6501],
                  [1877, 6522],
                  [1905, 6532],
                  [1915, 6542],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "MX",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.51,
            "hc-middle-y": 0.49,
            "hc-key": "MEX",
            "hc-a2": "MX",
            name: t("Countries.mx", { ns: region }),
            labelrank: "2",
            "country-abbrev": "Mex.",
            subregion: "Central America",
            "region-wb": "Latin America & Caribbean",
            "iso-a3": "MEX",
            "iso-a2": "MX",
            "woe-id": "23424900",
            continent: "North America",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [1681, 7111],
                  [1674, 7102],
                  [1673, 7106],
                  [1676, 7110],
                  [1681, 7111],
                ],
              ],
              [
                [
                  [1094, 7147],
                  [1098, 7145],
                  [1107, 7133],
                  [1100, 7138],
                  [1094, 7147],
                ],
              ],
              [
                [
                  [938, 7233],
                  [942, 7233],
                  [946, 7228],
                  [945, 7226],
                  [938, 7233],
                ],
              ],
              [
                [
                  [932, 7248],
                  [931, 7243],
                  [928, 7242],
                  [931, 7249],
                  [932, 7248],
                ],
              ],
              [
                [
                  [843, 7345],
                  [841, 7344],
                  [838, 7346],
                  [843, 7354],
                  [843, 7345],
                ],
              ],
              [
                [
                  [753, 7372],
                  [752, 7371],
                  [749, 7379],
                  [753, 7376],
                  [753, 7372],
                ],
              ],
              [
                [
                  [921, 7365],
                  [923, 7380],
                  [931, 7375],
                  [928, 7366],
                  [921, 7365],
                ],
              ],
              [
                [
                  [893, 7391],
                  [902, 7384],
                  [904, 7374],
                  [890, 7387],
                  [893, 7391],
                ],
              ],
              [
                [
                  [1255, 7393],
                  [1253, 7390],
                  [1260, 7389],
                  [1283, 7351],
                  [1305, 7329],
                  [1307, 7313],
                  [1313, 7304],
                  [1315, 7297],
                  [1343, 7282],
                  [1375, 7278],
                  [1360, 7233],
                  [1354, 7172],
                  [1360, 7144],
                  [1375, 7114],
                  [1395, 7090],
                  [1414, 7056],
                  [1433, 7054],
                  [1454, 7037],
                  [1506, 7052],
                  [1531, 7052],
                  [1558, 7068],
                  [1572, 7091],
                  [1576, 7125],
                  [1592, 7133],
                  [1641, 7143],
                  [1682, 7132],
                  [1661, 7101],
                  [1658, 7070],
                  [1649, 7040],
                  [1642, 7044],
                  [1636, 7048],
                  [1619, 7030],
                  [1610, 7027],
                  [1557, 7027],
                  [1556, 7010],
                  [1543, 7010],
                  [1574, 6984],
                  [1571, 6975],
                  [1534, 6975],
                  [1520, 6951],
                  [1519, 6929],
                  [1471, 6975],
                  [1443, 6986],
                  [1425, 6972],
                  [1392, 6962],
                  [1356, 6972],
                  [1327, 6989],
                  [1302, 6993],
                  [1260, 7011],
                  [1237, 7030],
                  [1188, 7043],
                  [1164, 7065],
                  [1143, 7074],
                  [1123, 7106],
                  [1138, 7138],
                  [1125, 7154],
                  [1120, 7175],
                  [1087, 7212],
                  [1055, 7237],
                  [1045, 7256],
                  [1012, 7273],
                  [1019, 7290],
                  [1012, 7302],
                  [980, 7323],
                  [970, 7337],
                  [932, 7374],
                  [904, 7433],
                  [906, 7444],
                  [861, 7463],
                  [853, 7456],
                  [858, 7413],
                  [867, 7399],
                  [889, 7383],
                  [904, 7358],
                  [915, 7361],
                  [914, 7338],
                  [926, 7328],
                  [957, 7282],
                  [957, 7274],
                  [980, 7244],
                  [978, 7225],
                  [1002, 7222],
                  [1012, 7193],
                  [999, 7182],
                  [987, 7203],
                  [933, 7244],
                  [930, 7281],
                  [903, 7304],
                  [890, 7301],
                  [863, 7318],
                  [847, 7337],
                  [873, 7341],
                  [877, 7357],
                  [849, 7386],
                  [828, 7398],
                  [817, 7432],
                  [799, 7456],
                  [786, 7488],
                  [857, 7494],
                  [854, 7487],
                  [964, 7449],
                  [1048, 7449],
                  [1048, 7464],
                  [1099, 7464],
                  [1147, 7424],
                  [1158, 7395],
                  [1198, 7374],
                  [1211, 7398],
                  [1222, 7403],
                  [1255, 7393],
                ],
                [
                  [1363, 7262],
                  [1357, 7247],
                  [1360, 7234],
                  [1367, 7261],
                  [1363, 7262],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "BU",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.49,
            "hc-middle-y": 0.73,
            "hc-key": "bu",
            "hc-a2": "BU",
            name: "Bajo Nuevo Bank (Petrel Is.)",
            labelrank: "8",
            "country-abbrev": null,
            subregion: "Caribbean",
            "region-wb": "Latin America & Caribbean",
            "iso-a3": "-99",
            "iso-a2": "BU",
            "woe-id": "-99",
            continent: "North America",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [1881, 6967],
                [1881, 6966],
                [1881, 6967],
                [1881, 6967],
                [1881, 6967],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "JM",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.5,
            "hc-middle-y": 0.5,
            "hc-key": "JAM",
            "hc-a2": "JM",
            name: t("Countries.jm", { ns: region }),
            labelrank: "4",
            "country-abbrev": "Jam.",
            subregion: "Caribbean",
            "region-wb": "Latin America & Caribbean",
            "iso-a3": "JAM",
            "iso-a2": "JM",
            "woe-id": "23424858",
            continent: "North America",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [1956, 7047],
                [1972, 7045],
                [1993, 7030],
                [1973, 7033],
                [1963, 7024],
                [1928, 7041],
                [1956, 7047],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "TT",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.5,
            "hc-middle-y": 0.5,
            "hc-key": "TTO",
            "hc-a2": "TT",
            name: t("Countries.tt", { ns: region }),
            labelrank: "5",
            "country-abbrev": "Tr.T.",
            subregion: "Caribbean",
            "region-wb": "Latin America & Caribbean",
            "iso-a3": "TTO",
            "iso-a2": "TT",
            "woe-id": "23424958",
            continent: "North America",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [2440, 6813],
                [2441, 6798],
                [2427, 6802],
                [2421, 6815],
                [2440, 6813],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "PA",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.22,
            "hc-middle-y": 0.5,
            "hc-key": "PAN",
            "hc-a2": "PA",
            name: t("Countries.pa", { ns: region }),
            labelrank: "4",
            "country-abbrev": "Pan.",
            subregion: "Central America",
            "region-wb": "Latin America & Caribbean",
            "iso-a3": "PAN",
            "iso-a2": "PA",
            "woe-id": "23424924",
            continent: "North America",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [1943, 6712],
                [1931, 6726],
                [1924, 6752],
                [1893, 6763],
                [1866, 6737],
                [1880, 6719],
                [1855, 6712],
                [1852, 6723],
                [1827, 6712],
                [1835, 6726],
                [1829, 6740],
                [1802, 6744],
                [1795, 6736],
                [1790, 6744],
                [1791, 6745],
                [1791, 6745],
                [1791, 6745],
                [1791, 6745],
                [1805, 6781],
                [1819, 6762],
                [1849, 6759],
                [1891, 6782],
                [1927, 6776],
                [1958, 6754],
                [1964, 6733],
                [1943, 6712],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "CL",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.4,
            "hc-middle-y": 0.93,
            "hc-key": "CHL",
            "hc-a2": "CL",
            name: t("Countries.cl", { ns: region }),
            labelrank: "2",
            "country-abbrev": "Chile",
            subregion: "South America",
            "region-wb": "Latin America & Caribbean",
            "iso-a3": "CHL",
            "iso-a2": "CL",
            "woe-id": "23424782",
            continent: "South America",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [2164, 5957],
                  [2176, 5959],
                  [2190, 5982],
                  [2205, 5938],
                  [2221, 5923],
                  [2212, 5893],
                  [2228, 5867],
                  [2238, 5820],
                  [2258, 5820],
                  [2263, 5814],
                  [2254, 5783],
                  [2227, 5771],
                  [2217, 5759],
                  [2225, 5692],
                  [2210, 5685],
                  [2199, 5659],
                  [2186, 5645],
                  [2174, 5614],
                  [2178, 5583],
                  [2171, 5582],
                  [2158, 5543],
                  [2182, 5484],
                  [2164, 5425],
                  [2164, 5395],
                  [2145, 5380],
                  [2140, 5339],
                  [2150, 5306],
                  [2134, 5298],
                  [2131, 5274],
                  [2118, 5235],
                  [2124, 5187],
                  [2113, 5181],
                  [2112, 5155],
                  [2126, 5122],
                  [2122, 5105],
                  [2140, 5104],
                  [2137, 5090],
                  [2115, 5092],
                  [2137, 5072],
                  [2122, 5056],
                  [2128, 5047],
                  [2119, 5001],
                  [2107, 4993],
                  [2100, 4975],
                  [2108, 4959],
                  [2099, 4942],
                  [2070, 4914],
                  [2071, 4891],
                  [2082, 4867],
                  [2107, 4871],
                  [2103, 4836],
                  [2119, 4819],
                  [2177, 4818],
                  [2221, 4804],
                  [2201, 4810],
                  [2154, 4789],
                  [2145, 4746],
                  [2113, 4751],
                  [2106, 4758],
                  [2106, 4757],
                  [2081, 4769],
                  [2088, 4785],
                  [2129, 4796],
                  [2107, 4797],
                  [2086, 4785],
                  [2054, 4790],
                  [2059, 4799],
                  [2045, 4813],
                  [2066, 4809],
                  [2045, 4824],
                  [2034, 4815],
                  [2031, 4833],
                  [2065, 4815],
                  [2061, 4847],
                  [2048, 4856],
                  [2063, 4859],
                  [2037, 4889],
                  [2014, 4867],
                  [2026, 4889],
                  [2047, 4893],
                  [2044, 4915],
                  [2046, 4949],
                  [2039, 4972],
                  [2064, 4971],
                  [2071, 4979],
                  [2036, 4983],
                  [2050, 5017],
                  [2037, 5014],
                  [2016, 5023],
                  [2044, 5067],
                  [2058, 5045],
                  [2074, 5073],
                  [2079, 5112],
                  [2094, 5155],
                  [2093, 5182],
                  [2102, 5188],
                  [2088, 5209],
                  [2084, 5199],
                  [2064, 5199],
                  [2059, 5227],
                  [2066, 5261],
                  [2080, 5278],
                  [2067, 5338],
                  [2070, 5358],
                  [2081, 5358],
                  [2097, 5411],
                  [2110, 5426],
                  [2116, 5458],
                  [2127, 5480],
                  [2134, 5517],
                  [2126, 5556],
                  [2127, 5586],
                  [2137, 5596],
                  [2130, 5628],
                  [2148, 5669],
                  [2162, 5740],
                  [2158, 5811],
                  [2165, 5813],
                  [2174, 5862],
                  [2172, 5904],
                  [2164, 5957],
                ],
                [
                  [2106, 4758],
                  [2106, 4760],
                  [2106, 4760],
                  [2106, 4760],
                  [2135, 4774],
                  [2141, 4786],
                  [2116, 4773],
                  [2105, 4776],
                  [2106, 4760],
                  [2106, 4760],
                  [2106, 4760],
                  [2105, 4759],
                  [2106, 4758],
                ],
              ],
              [
                [
                  [2275, 4689],
                  [2262, 4684],
                  [2231, 4688],
                  [2228, 4701],
                  [2255, 4701],
                  [2275, 4689],
                ],
              ],
              [
                [
                  [2127, 4739],
                  [2145, 4734],
                  [2142, 4723],
                  [2132, 4731],
                  [2127, 4739],
                ],
              ],
              [
                [
                  [2034, 4877],
                  [2051, 4868],
                  [2041, 4843],
                  [2021, 4838],
                  [2040, 4851],
                  [2025, 4866],
                  [2043, 4866],
                  [2034, 4877],
                ],
              ],
              [
                [
                  [2017, 4955],
                  [2011, 4969],
                  [2018, 4972],
                  [2025, 4937],
                  [2017, 4955],
                ],
              ],
              [
                [
                  [2058, 5121],
                  [2068, 5089],
                  [2046, 5091],
                  [2033, 5099],
                  [2048, 5105],
                  [2058, 5121],
                ],
              ],
              [
                [
                  [2178, 4696],
                  [2182, 4703],
                  [2210, 4698],
                  [2244, 4677],
                  [2262, 4660],
                  [2240, 4661],
                  [2227, 4676],
                  [2206, 4680],
                  [2210, 4690],
                  [2181, 4681],
                  [2178, 4696],
                ],
              ],
              [
                [
                  [2078, 4764],
                  [2040, 4782],
                  [2073, 4773],
                  [2112, 4746],
                  [2110, 4732],
                  [2092, 4733],
                  [2064, 4762],
                  [2078, 4764],
                ],
              ],
              [
                [
                  [2026, 4979],
                  [2032, 4982],
                  [2042, 4947],
                  [2043, 4898],
                  [2032, 4895],
                  [2010, 4910],
                  [2017, 4924],
                  [2030, 4924],
                  [2020, 4969],
                  [2026, 4979],
                ],
              ],
              [
                [
                  [2071, 5177],
                  [2065, 5141],
                  [2035, 5131],
                  [2051, 5154],
                  [2056, 5193],
                  [2070, 5198],
                  [2071, 5177],
                ],
              ],
              [
                [
                  [2216, 4793],
                  [2215, 4706],
                  [2213, 4707],
                  [2215, 4706],
                  [2215, 4702],
                  [2176, 4707],
                  [2159, 4689],
                  [2144, 4714],
                  [2149, 4743],
                  [2162, 4755],
                  [2166, 4725],
                  [2205, 4721],
                  [2174, 4735],
                  [2171, 4749],
                  [2194, 4764],
                  [2169, 4760],
                  [2163, 4778],
                  [2183, 4787],
                  [2193, 4800],
                  [2216, 4793],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "CO",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.5,
            "hc-middle-y": 0.54,
            "hc-key": "COL",
            "hc-a2": "CO",
            name: t("Countries.co", { ns: region }),
            labelrank: "2",
            "country-abbrev": "Col.",
            subregion: "South America",
            "region-wb": "Latin America & Caribbean",
            "iso-a3": "COL",
            "iso-a2": "CO",
            "woe-id": "23424787",
            continent: "South America",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [2020, 6497],
                [1990, 6513],
                [1986, 6507],
                [1957, 6511],
                [1955, 6519],
                [1915, 6542],
                [1919, 6564],
                [1930, 6578],
                [1944, 6580],
                [1966, 6613],
                [1953, 6623],
                [1959, 6631],
                [1962, 6670],
                [1959, 6693],
                [1943, 6712],
                [1964, 6733],
                [1958, 6754],
                [1976, 6733],
                [1971, 6751],
                [2010, 6778],
                [2012, 6811],
                [2033, 6827],
                [2047, 6817],
                [2054, 6834],
                [2078, 6832],
                [2131, 6866],
                [2136, 6849],
                [2117, 6843],
                [2089, 6807],
                [2087, 6788],
                [2075, 6769],
                [2087, 6773],
                [2105, 6745],
                [2102, 6720],
                [2114, 6708],
                [2172, 6705],
                [2192, 6680],
                [2249, 6682],
                [2239, 6655],
                [2238, 6633],
                [2255, 6600],
                [2239, 6585],
                [2258, 6570],
                [2268, 6536],
                [2261, 6534],
                [2254, 6561],
                [2230, 6550],
                [2180, 6550],
                [2180, 6531],
                [2194, 6531],
                [2201, 6519],
                [2174, 6517],
                [2173, 6495],
                [2187, 6485],
                [2192, 6458],
                [2176, 6376],
                [2154, 6389],
                [2174, 6420],
                [2145, 6436],
                [2124, 6437],
                [2105, 6428],
                [2081, 6435],
                [2081, 6448],
                [2068, 6463],
                [2050, 6471],
                [2033, 6495],
                [2020, 6497],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "AR",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.45,
            "hc-middle-y": 0.27,
            "hc-key": "ARG",
            "hc-a2": "AR",
            name: t("Countries.ar", { ns: region }),
            labelrank: "2",
            "country-abbrev": "Arg.",
            subregion: "South America",
            "region-wb": "Latin America & Caribbean",
            "iso-a3": "ARG",
            "iso-a2": "AR",
            "woe-id": "23424747",
            continent: "South America",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [2215, 4706],
                  [2218, 4703],
                  [2215, 4702],
                  [2215, 4706],
                ],
              ],
              [
                [
                  [2215, 4706],
                  [2216, 4793],
                  [2227, 4779],
                  [2221, 4767],
                  [2255, 4736],
                  [2298, 4712],
                  [2319, 4712],
                  [2334, 4702],
                  [2302, 4701],
                  [2277, 4696],
                  [2263, 4701],
                  [2215, 4706],
                ],
              ],
              [
                [
                  [2541, 5588],
                  [2523, 5532],
                  [2523, 5514],
                  [2519, 5492],
                  [2518, 5486],
                  [2512, 5454],
                  [2525, 5438],
                  [2555, 5415],
                  [2547, 5401],
                  [2568, 5367],
                  [2541, 5324],
                  [2498, 5305],
                  [2445, 5296],
                  [2409, 5298],
                  [2408, 5266],
                  [2397, 5250],
                  [2410, 5245],
                  [2401, 5230],
                  [2380, 5220],
                  [2357, 5220],
                  [2326, 5236],
                  [2318, 5227],
                  [2321, 5192],
                  [2335, 5175],
                  [2359, 5188],
                  [2364, 5164],
                  [2349, 5159],
                  [2339, 5172],
                  [2323, 5163],
                  [2340, 5156],
                  [2313, 5131],
                  [2316, 5106],
                  [2304, 5095],
                  [2305, 5082],
                  [2287, 5083],
                  [2254, 5061],
                  [2245, 5040],
                  [2251, 5025],
                  [2270, 5009],
                  [2294, 5007],
                  [2301, 4990],
                  [2294, 4970],
                  [2247, 4934],
                  [2237, 4896],
                  [2209, 4883],
                  [2200, 4858],
                  [2207, 4832],
                  [2221, 4804],
                  [2177, 4818],
                  [2119, 4819],
                  [2103, 4836],
                  [2107, 4871],
                  [2082, 4867],
                  [2071, 4891],
                  [2070, 4914],
                  [2099, 4942],
                  [2108, 4959],
                  [2100, 4975],
                  [2107, 4993],
                  [2119, 5001],
                  [2128, 5047],
                  [2122, 5056],
                  [2137, 5072],
                  [2115, 5092],
                  [2137, 5090],
                  [2140, 5104],
                  [2122, 5105],
                  [2126, 5122],
                  [2112, 5155],
                  [2113, 5181],
                  [2124, 5187],
                  [2118, 5235],
                  [2131, 5274],
                  [2134, 5298],
                  [2150, 5306],
                  [2140, 5339],
                  [2145, 5380],
                  [2164, 5395],
                  [2164, 5425],
                  [2182, 5484],
                  [2158, 5543],
                  [2171, 5582],
                  [2178, 5583],
                  [2174, 5614],
                  [2186, 5645],
                  [2199, 5659],
                  [2210, 5685],
                  [2225, 5692],
                  [2217, 5759],
                  [2227, 5771],
                  [2254, 5783],
                  [2263, 5814],
                  [2258, 5820],
                  [2286, 5851],
                  [2301, 5841],
                  [2335, 5839],
                  [2343, 5818],
                  [2354, 5845],
                  [2387, 5845],
                  [2392, 5838],
                  [2413, 5813],
                  [2441, 5789],
                  [2469, 5783],
                  [2505, 5759],
                  [2536, 5746],
                  [2542, 5738],
                  [2527, 5717],
                  [2511, 5679],
                  [2529, 5681],
                  [2553, 5674],
                  [2585, 5680],
                  [2595, 5675],
                  [2624, 5700],
                  [2629, 5734],
                  [2650, 5732],
                  [2657, 5712],
                  [2652, 5684],
                  [2621, 5669],
                  [2595, 5650],
                  [2576, 5623],
                  [2541, 5588],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "PE",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.68,
            "hc-middle-y": 0.7,
            "hc-key": "PER",
            "hc-a2": "PE",
            name: t("Countries.pe", { ns: region }),
            labelrank: "2",
            "country-abbrev": "Peru",
            subregion: "South America",
            "region-wb": "Latin America & Caribbean",
            "iso-a3": "PER",
            "iso-a2": "PE",
            "woe-id": "23424919",
            continent: "South America",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [2194, 6042],
                [2184, 6048],
                [2175, 6032],
                [2202, 6020],
                [2203, 6021],
                [2206, 6021],
                [2202, 6012],
                [2204, 6011],
                [2185, 5988],
                [2190, 5982],
                [2176, 5959],
                [2164, 5957],
                [2135, 5976],
                [2131, 5988],
                [2105, 6005],
                [2066, 6021],
                [2022, 6046],
                [1990, 6085],
                [1992, 6106],
                [1950, 6168],
                [1925, 6230],
                [1910, 6259],
                [1896, 6273],
                [1882, 6301],
                [1848, 6322],
                [1855, 6334],
                [1845, 6347],
                [1844, 6376],
                [1870, 6401],
                [1876, 6386],
                [1865, 6380],
                [1895, 6367],
                [1908, 6353],
                [1920, 6367],
                [1929, 6401],
                [1943, 6412],
                [1978, 6425],
                [2011, 6455],
                [2020, 6497],
                [2033, 6495],
                [2050, 6471],
                [2068, 6463],
                [2081, 6448],
                [2081, 6435],
                [2105, 6428],
                [2124, 6437],
                [2145, 6436],
                [2174, 6420],
                [2154, 6389],
                [2176, 6376],
                [2152, 6378],
                [2119, 6368],
                [2089, 6349],
                [2080, 6322],
                [2083, 6312],
                [2065, 6298],
                [2057, 6279],
                [2088, 6233],
                [2081, 6224],
                [2107, 6220],
                [2111, 6206],
                [2140, 6208],
                [2160, 6223],
                [2156, 6176],
                [2188, 6178],
                [2214, 6132],
                [2205, 6120],
                [2202, 6097],
                [2209, 6081],
                [2194, 6058],
                [2194, 6042],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "DO",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.48,
            "hc-middle-y": 0.43,
            "hc-key": "DOM",
            "hc-a2": "DO",
            name: t("Countries.do", { ns: region }),
            labelrank: "5",
            "country-abbrev": "Dom. Rep.",
            subregion: "Caribbean",
            "region-wb": "Latin America & Caribbean",
            "iso-a3": "DOM",
            "iso-a2": "DO",
            "woe-id": "23424800",
            continent: "North America",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [2119, 7048],
                [2119, 7048],
                [2118, 7049],
                [2118, 7049],
                [2116, 7051],
                [2125, 7056],
                [2124, 7085],
                [2146, 7092],
                [2177, 7084],
                [2187, 7066],
                [2213, 7062],
                [2224, 7053],
                [2217, 7036],
                [2207, 7045],
                [2178, 7047],
                [2159, 7039],
                [2155, 7046],
                [2134, 7021],
                [2123, 7034],
                [2125, 7042],
                [2119, 7048],
              ],
            ],
          },
        },

        {
          type: "Feature",
          id: "CR",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.09,
            "hc-middle-y": 0.05,
            "hc-key": "CRI",
            "hc-a2": "CR",
            name: t("Countries.cr", { ns: region }),
            labelrank: "5",
            "country-abbrev": "C.R.",
            subregion: "Central America",
            "region-wb": "Latin America & Caribbean",
            "iso-a3": "CRI",
            "iso-a2": "CR",
            "woe-id": "23424791",
            continent: "North America",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [1773, 6821],
                  [1778, 6808],
                  [1805, 6781],
                  [1791, 6745],
                  [1791, 6745],
                  [1787, 6754],
                  [1743, 6784],
                  [1730, 6781],
                  [1707, 6804],
                  [1712, 6826],
                  [1752, 6823],
                  [1773, 6821],
                ],
              ],
              [
                [
                  [1795, 6736],
                  [1790, 6744],
                  [1791, 6745],
                  [1791, 6745],
                  [1795, 6736],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "SV",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.5,
            "hc-middle-y": 0.51,
            "hc-key": "SLV",
            "hc-a2": "SV",
            name: t("Countries.sv", { ns: region }),
            labelrank: "6",
            "country-abbrev": "El. S.",
            subregion: "Central America",
            "region-wb": "Latin America & Caribbean",
            "iso-a3": "SLV",
            "iso-a2": "SV",
            "woe-id": "23424807",
            continent: "North America",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [1650, 6895],
                [1647, 6888],
                [1621, 6890],
                [1583, 6905],
                [1582, 6908],
                [1604, 6925],
                [1630, 6912],
                [1653, 6907],
                [1650, 6895],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "BZ",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.48,
            "hc-middle-y": 0.5,
            "hc-key": "BLZ",
            "hc-a2": "BZ",
            name: t("Countries.bz", { ns: region }),
            labelrank: "6",
            "country-abbrev": "Belize",
            subregion: "Central America",
            "region-wb": "Latin America & Caribbean",
            "iso-a3": "BLZ",
            "iso-a2": "BZ",
            "woe-id": "23424760",
            continent: "North America",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [1610, 7027],
                [1619, 7030],
                [1636, 7048],
                [1642, 7044],
                [1642, 7044],
                [1638, 7002],
                [1618, 6969],
                [1608, 6969],
                [1610, 7027],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "HN",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.71,
            "hc-middle-y": 0.09,
            "hc-key": "HND",
            "hc-a2": "HN",
            name: t("Countries.hn", { ns: region }),
            labelrank: "5",
            "country-abbrev": "Hond.",
            subregion: "Central America",
            "region-wb": "Latin America & Caribbean",
            "iso-a3": "HND",
            "iso-a2": "HN",
            "woe-id": "23424841",
            continent: "North America",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [1638, 6964],
                [1653, 6970],
                [1693, 6966],
                [1706, 6973],
                [1754, 6967],
                [1770, 6949],
                [1788, 6943],
                [1748, 6931],
                [1739, 6937],
                [1712, 6912],
                [1681, 6905],
                [1683, 6891],
                [1665, 6882],
                [1659, 6891],
                [1650, 6895],
                [1653, 6907],
                [1630, 6912],
                [1604, 6925],
                [1610, 6944],
                [1638, 6964],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "NI",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.45,
            "hc-middle-y": 0.86,
            "hc-key": "NIC",
            "hc-a2": "NI",
            name: t("Countries.ni", { ns: region }),
            labelrank: "5",
            "country-abbrev": "Nic.",
            subregion: "Central America",
            "region-wb": "Latin America & Caribbean",
            "iso-a3": "NIC",
            "iso-a2": "NI",
            "woe-id": "23424915",
            continent: "North America",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [1712, 6826],
                [1681, 6859],
                [1655, 6879],
                [1665, 6882],
                [1683, 6891],
                [1681, 6905],
                [1712, 6912],
                [1739, 6937],
                [1748, 6931],
                [1788, 6943],
                [1787, 6923],
                [1776, 6895],
                [1767, 6835],
                [1773, 6821],
                [1752, 6823],
                [1712, 6826],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "GT",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.23,
            "hc-middle-y": 0.79,
            "hc-key": "GTM",
            "hc-a2": "GT",
            name: t("Countries.gt", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Guat.",
            subregion: "Central America",
            "region-wb": "Latin America & Caribbean",
            "iso-a3": "GTM",
            "iso-a2": "GT",
            "woe-id": "23424834",
            continent: "North America",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [1618, 6969],
                [1626, 6965],
                [1638, 6964],
                [1610, 6944],
                [1604, 6925],
                [1582, 6908],
                [1583, 6905],
                [1547, 6911],
                [1519, 6929],
                [1520, 6951],
                [1534, 6975],
                [1571, 6975],
                [1574, 6984],
                [1543, 7010],
                [1556, 7010],
                [1557, 7027],
                [1610, 7027],
                [1608, 6969],
                [1618, 6969],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "UY",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.81,
            "hc-middle-y": 0.63,
            "hc-key": "URY",
            "hc-a2": "UY",
            name: t("Countries.uy", { ns: region }),
            labelrank: "4",
            "country-abbrev": "Ury.",
            subregion: "South America",
            "region-wb": "Latin America & Caribbean",
            "iso-a3": "URY",
            "iso-a2": "UY",
            "woe-id": "23424979",
            continent: "South America",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [2672, 5507],
                [2658, 5493],
                [2661, 5478],
                [2661, 5475],
                [2666, 5472],
                [2654, 5450],
                [2619, 5432],
                [2607, 5437],
                [2584, 5432],
                [2554, 5448],
                [2534, 5448],
                [2518, 5465],
                [2518, 5486],
                [2518, 5491],
                [2519, 5492],
                [2527, 5495],
                [2523, 5514],
                [2523, 5532],
                [2541, 5588],
                [2564, 5590],
                [2582, 5575],
                [2588, 5559],
                [2600, 5566],
                [2611, 5553],
                [2629, 5546],
                [2672, 5507],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "BO",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.48,
            "hc-middle-y": 0.59,
            "hc-key": "BOL",
            "hc-a2": "BO",
            name: t("Countries.bo", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Bolivia",
            subregion: "South America",
            "region-wb": "Latin America & Caribbean",
            "iso-a3": "BOL",
            "iso-a2": "BO",
            "woe-id": "23424762",
            continent: "South America",
          },
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [2202, 6020],
                  [2201, 6026],
                  [2206, 6021],
                  [2203, 6021],
                  [2202, 6020],
                ],
              ],
              [
                [
                  [2190, 5982],
                  [2185, 5988],
                  [2204, 6011],
                  [2217, 6017],
                  [2194, 6042],
                  [2194, 6058],
                  [2209, 6081],
                  [2202, 6097],
                  [2205, 6120],
                  [2214, 6132],
                  [2188, 6178],
                  [2226, 6177],
                  [2274, 6209],
                  [2309, 6215],
                  [2314, 6200],
                  [2311, 6172],
                  [2323, 6147],
                  [2341, 6133],
                  [2380, 6127],
                  [2406, 6113],
                  [2416, 6101],
                  [2439, 6103],
                  [2456, 6093],
                  [2466, 6019],
                  [2516, 6017],
                  [2518, 5989],
                  [2535, 5981],
                  [2542, 5961],
                  [2525, 5901],
                  [2524, 5912],
                  [2497, 5928],
                  [2470, 5928],
                  [2419, 5917],
                  [2403, 5889],
                  [2403, 5874],
                  [2392, 5838],
                  [2387, 5845],
                  [2354, 5845],
                  [2343, 5818],
                  [2335, 5839],
                  [2301, 5841],
                  [2286, 5851],
                  [2258, 5820],
                  [2238, 5820],
                  [2228, 5867],
                  [2212, 5893],
                  [2221, 5923],
                  [2205, 5938],
                  [2190, 5982],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "PY",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.49,
            "hc-middle-y": 0.5,
            "hc-key": "PRY",
            "hc-a2": "PY",
            name: t("Countries.py", { ns: region }),
            labelrank: "4",
            "country-abbrev": "Para.",
            subregion: "South America",
            "region-wb": "Latin America & Caribbean",
            "iso-a3": "PRY",
            "iso-a2": "PY",
            "woe-id": "23424917",
            continent: "South America",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [2639, 5781],
                [2636, 5769],
                [2629, 5738],
                [2630, 5735],
                [2629, 5734],
                [2624, 5700],
                [2595, 5675],
                [2585, 5680],
                [2553, 5674],
                [2529, 5681],
                [2511, 5679],
                [2527, 5717],
                [2542, 5738],
                [2536, 5746],
                [2505, 5759],
                [2469, 5783],
                [2441, 5789],
                [2413, 5813],
                [2392, 5838],
                [2403, 5874],
                [2403, 5889],
                [2419, 5917],
                [2470, 5928],
                [2497, 5928],
                [2524, 5912],
                [2525, 5901],
                [2535, 5877],
                [2530, 5843],
                [2569, 5838],
                [2576, 5843],
                [2599, 5825],
                [2605, 5784],
                [2628, 5789],
                [2639, 5781],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "CU",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.67,
            "hc-middle-y": 0.64,
            "hc-key": "CUB",
            "hc-a2": "CU",
            name: t("Countries.cu", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Cuba",
            subregion: "Caribbean",
            "region-wb": "Latin America & Caribbean",
            "iso-a3": "CUB",
            "iso-a2": "CU",
            "woe-id": "23424793",
            continent: "North America",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [1948, 7089],
                [1967, 7108],
                [1959, 7116],
                [1938, 7116],
                [1925, 7126],
                [1920, 7114],
                [1900, 7127],
                [1904, 7141],
                [1867, 7157],
                [1827, 7161],
                [1825, 7176],
                [1799, 7177],
                [1787, 7165],
                [1806, 7143],
                [1797, 7138],
                [1780, 7161],
                [1765, 7160],
                [1747, 7148],
                [1751, 7166],
                [1785, 7186],
                [1821, 7192],
                [1879, 7188],
                [1903, 7167],
                [1918, 7171],
                [1929, 7172],
                [1983, 7130],
                [2011, 7125],
                [2014, 7116],
                [2036, 7112],
                [2050, 7096],
                [2010, 7090],
                [1992, 7094],
                [1948, 7089],
              ],
            ],
          },
        },
        {
          type: "Feature",
          id: "VE",
          properties: {
            "hc-group": "admin0",
            "hc-middle-x": 0.44,
            "hc-middle-y": 0.25,
            "hc-key": "VEN",
            "hc-a2": "VE",
            name: t("Countries.ve", { ns: region }),
            labelrank: "3",
            "country-abbrev": "Ven.",
            subregion: "South America",
            "region-wb": "Latin America & Caribbean",
            "iso-a3": "VEN",
            "iso-a2": "VE",
            "woe-id": "23424982",
            continent: "South America",
          },
          geometry: {
            type: "Polygon",
            coordinates: [
              [
                [2136, 6849],
                [2119, 6842],
                [2129, 6815],
                [2113, 6789],
                [2131, 6766],
                [2145, 6786],
                [2129, 6818],
                [2171, 6837],
                [2175, 6859],
                [2186, 6837],
                [2209, 6837],
                [2236, 6808],
                [2285, 6813],
                [2296, 6802],
                [2329, 6797],
                [2355, 6813],
                [2390, 6816],
                [2412, 6813],
                [2388, 6808],
                [2402, 6785],
                [2404, 6795],
                [2447, 6776],
                [2444, 6762],
                [2470, 6751],
                [2476, 6743],
                [2455, 6729],
                [2452, 6711],
                [2461, 6709],
                [2435, 6692],
                [2430, 6673],
                [2448, 6652],
                [2453, 6645],
                [2424, 6625],
                [2389, 6618],
                [2388, 6606],
                [2369, 6616],
                [2333, 6616],
                [2346, 6605],
                [2351, 6572],
                [2371, 6571],
                [2348, 6546],
                [2319, 6533],
                [2306, 6519],
                [2289, 6521],
                [2268, 6536],
                [2258, 6570],
                [2239, 6585],
                [2255, 6600],
                [2238, 6633],
                [2239, 6655],
                [2249, 6682],
                [2192, 6680],
                [2172, 6705],
                [2114, 6708],
                [2102, 6720],
                [2105, 6745],
                [2087, 6773],
                [2075, 6769],
                [2087, 6788],
                [2089, 6807],
                [2117, 6843],
                [2136, 6849],
              ],
            ],
          },
        },
      ],
    };
  }
}
